{
  "version": 1,
  "models": [
    {
      "id": "hp.pdc",
      "class": "hardpoint",
      "budget": "hardpoint",
      "path": "/assets/hardpoint/hp.pdc.d739bed6.glb",
      "bytes": 93892,
      "sha256": "d739bed610098d1907313a5dcf9176d4273fa0d88086ee198c264e4ec2432e83",
      "ledgerLine": "kit.hardpoints",
      "placeholder": false,
      "provenance": {
        "source": "procedural-ts",
        "tool": "Node 24.15.0 + tools/assetkit + assets-src/hp.pdc/build.ts @ sha256:94f8556d2d38",
        "humanContribution": "none",
        "license": "LicenseRef-Eclipse-Owned",
        "aiGenerated": true,
        "manifestRef": "hp.pdc"
      },
      "kind": "model",
      "materialSlots": [
        "hull",
        "decal"
      ],
      "lod": {
        "source": "authored",
        "distances": [
          0,
          40,
          150
        ],
        "hysteresis": 0.1,
        "tris": [
          3852,
          1184,
          296
        ]
      },
      "sockets": [
        {
          "name": "HP_MUZZLE_0",
          "kind": "HP",
          "position": [
            -0.1,
            0,
            -1.1
          ],
          "quaternion": [
            0,
            0,
            0,
            1
          ],
          "params": {}
        },
        {
          "name": "HP_MUZZLE_1",
          "kind": "HP",
          "position": [
            0.1,
            0,
            -1.1
          ],
          "quaternion": [
            0,
            0,
            0,
            1
          ],
          "params": {}
        }
      ],
      "collider": null,
      "bounds": {
        "min": [
          -0.29676,
          -0.22,
          -1.1
        ],
        "max": [
          0.295012,
          0.218979,
          0.3
        ],
        "center": [
          -0.000874,
          -0.00051,
          -0.4
        ],
        "radius": 0.751325
      }
    },
    {
      "id": "hp.pulse_laser",
      "class": "hardpoint",
      "budget": "hardpoint",
      "path": "/assets/hardpoint/hp.pulse_laser.3d3ca3ad.glb",
      "bytes": 92276,
      "sha256": "3d3ca3ad2ab244cd6d8413183c590dfd14cd496fac39e4557b9d2f659b38ca3d",
      "ledgerLine": "kit.hardpoints",
      "placeholder": false,
      "provenance": {
        "source": "procedural-ts",
        "tool": "Node 24.15.0 + tools/assetkit + assets-src/hp.pulse_laser/build.ts @ sha256:6bbc1bd89c2b",
        "humanContribution": "none",
        "license": "LicenseRef-Eclipse-Owned",
        "aiGenerated": true,
        "manifestRef": "hp.pulse_laser"
      },
      "kind": "model",
      "materialSlots": [
        "hull",
        "emissive",
        "decal"
      ],
      "lod": {
        "source": "authored",
        "distances": [
          0,
          40,
          150
        ],
        "hysteresis": 0.1,
        "tris": [
          3790,
          1180,
          280
        ]
      },
      "sockets": [
        {
          "name": "HP_MUZZLE_0",
          "kind": "HP",
          "position": [
            0,
            0,
            -1.15
          ],
          "quaternion": [
            0,
            0,
            0,
            1
          ],
          "params": {}
        }
      ],
      "collider": null,
      "bounds": {
        "min": [
          -0.2669,
          -0.22,
          -1.145
        ],
        "max": [
          0.26688,
          0.221037,
          0.311757
        ],
        "center": [
          -0.00001,
          0.000519,
          -0.416621
        ],
        "radius": 0.739681
      }
    },
    {
      "id": "hp.torpedo_rack",
      "class": "hardpoint",
      "budget": "hardpoint",
      "path": "/assets/hardpoint/hp.torpedo_rack.bb73cee9.glb",
      "bytes": 99584,
      "sha256": "bb73cee956fa09b55af9d29b99717f500348845a155a2324ccb74db43b96e9e4",
      "ledgerLine": "kit.hardpoints",
      "placeholder": false,
      "provenance": {
        "source": "procedural-ts",
        "tool": "Node 24.15.0 + tools/assetkit + assets-src/hp.torpedo_rack/build.ts @ sha256:143d694f734f",
        "humanContribution": "none",
        "license": "LicenseRef-Eclipse-Owned",
        "aiGenerated": true,
        "manifestRef": "hp.torpedo_rack"
      },
      "kind": "model",
      "materialSlots": [
        "hull",
        "decal"
      ],
      "lod": {
        "source": "authored",
        "distances": [
          0,
          40,
          150
        ],
        "hysteresis": 0.1,
        "tris": [
          3462,
          1198,
          300
        ]
      },
      "sockets": [
        {
          "name": "HP_MUZZLE_0",
          "kind": "HP",
          "position": [
            0,
            -0.05,
            -1.25
          ],
          "quaternion": [
            0,
            0,
            0,
            1
          ],
          "params": {}
        }
      ],
      "collider": null,
      "bounds": {
        "min": [
          -0.534737,
          -0.711353,
          -1.25
        ],
        "max": [
          0.53475,
          0.246734,
          -0.1
        ],
        "center": [
          0.000006,
          -0.23231,
          -0.675
        ],
        "radius": 0.760052
      }
    },
    {
      "id": "kit.station.core",
      "class": "station_module",
      "budget": "station_module",
      "path": "/assets/placeholder/kit.station.core.31dff29f.glb",
      "bytes": 32976,
      "sha256": "31dff29f2bae3306239753d5fa63d1d37ee9bfb097cf4914a263bb12bb0bf19a",
      "ledgerLine": "placeholders",
      "placeholder": true,
      "provenance": {
        "source": "greybox",
        "tool": "Blender 5.2.0 LTS + tools/blender/greybox_placeholders.py",
        "humanContribution": "none",
        "license": "LicenseRef-Eclipse-Owned",
        "aiGenerated": true
      },
      "kind": "model",
      "materialSlots": [
        "hull",
        "glass"
      ],
      "lod": {
        "source": "authored",
        "distances": [
          0,
          250,
          900,
          3000
        ],
        "hysteresis": 0.1,
        "tris": [
          224,
          144,
          68,
          20
        ]
      },
      "sockets": [
        {
          "name": "CON_BOTTOM",
          "kind": "CON",
          "position": [
            0,
            -10,
            0
          ],
          "quaternion": [
            -0.707107,
            0,
            0,
            0.707107
          ],
          "params": {
            "roll4": true,
            "size": "L"
          }
        },
        {
          "name": "CON_RADIAL_E",
          "kind": "CON",
          "position": [
            7,
            0,
            0
          ],
          "quaternion": [
            0,
            -0.707107,
            0,
            0.707107
          ],
          "params": {
            "roll4": false,
            "size": "M"
          }
        },
        {
          "name": "CON_RADIAL_N",
          "kind": "CON",
          "position": [
            0,
            0,
            -7
          ],
          "quaternion": [
            0,
            0,
            0,
            1
          ],
          "params": {
            "roll4": false,
            "size": "M"
          }
        },
        {
          "name": "CON_RADIAL_S",
          "kind": "CON",
          "position": [
            0,
            0,
            7
          ],
          "quaternion": [
            0,
            -1,
            0,
            0
          ],
          "params": {
            "roll4": false,
            "size": "M"
          }
        },
        {
          "name": "CON_RADIAL_W",
          "kind": "CON",
          "position": [
            -7,
            0,
            0
          ],
          "quaternion": [
            0,
            0.707107,
            0,
            0.707107
          ],
          "params": {
            "roll4": false,
            "size": "M"
          }
        },
        {
          "name": "CON_TOP",
          "kind": "CON",
          "position": [
            0,
            10,
            0
          ],
          "quaternion": [
            0,
            0.707107,
            -0.707107,
            0
          ],
          "params": {
            "roll4": true,
            "size": "L"
          }
        }
      ],
      "collider": {
        "kind": "trimesh",
        "nodes": [
          "COL_CORE"
        ],
        "triangles": 44
      },
      "bounds": {
        "min": [
          -7.6,
          -10.000001,
          -7.599999
        ],
        "max": [
          7.6,
          10.000001,
          7.600001
        ],
        "center": [
          0,
          0,
          0.000001
        ],
        "radius": 12.244183
      }
    },
    {
      "id": "kit.station.core_breached",
      "class": "station_module",
      "budget": "station_module",
      "path": "/assets/placeholder/kit.station.core_breached.13c5c024.glb",
      "bytes": 28200,
      "sha256": "13c5c024a1bc0f7fa1faec1bc78a17af7c966f18f764e5d7627c076dec62843a",
      "ledgerLine": "placeholders",
      "placeholder": true,
      "provenance": {
        "source": "greybox",
        "tool": "Blender 5.2.0 LTS + tools/blender/greybox_placeholders.py",
        "humanContribution": "none",
        "license": "LicenseRef-Eclipse-Owned",
        "aiGenerated": true
      },
      "kind": "model",
      "materialSlots": [
        "hull"
      ],
      "lod": {
        "source": "authored",
        "distances": [
          0,
          250,
          900,
          3000
        ],
        "hysteresis": 0.1,
        "tris": [
          224,
          144,
          68,
          20
        ]
      },
      "sockets": [
        {
          "name": "CON_BOTTOM",
          "kind": "CON",
          "position": [
            0,
            -10,
            0
          ],
          "quaternion": [
            -0.707107,
            0,
            0,
            0.707107
          ],
          "params": {
            "roll4": true,
            "size": "L"
          }
        },
        {
          "name": "CON_RADIAL_E",
          "kind": "CON",
          "position": [
            7,
            0,
            0
          ],
          "quaternion": [
            0,
            -0.707107,
            0,
            0.707107
          ],
          "params": {
            "roll4": false,
            "size": "M"
          }
        },
        {
          "name": "CON_RADIAL_N",
          "kind": "CON",
          "position": [
            0,
            0,
            -7
          ],
          "quaternion": [
            0,
            0,
            0,
            1
          ],
          "params": {
            "roll4": false,
            "size": "M"
          }
        },
        {
          "name": "CON_RADIAL_S",
          "kind": "CON",
          "position": [
            0,
            0,
            7
          ],
          "quaternion": [
            0,
            -1,
            0,
            0
          ],
          "params": {
            "roll4": false,
            "size": "M"
          }
        },
        {
          "name": "CON_RADIAL_W",
          "kind": "CON",
          "position": [
            -7,
            0,
            0
          ],
          "quaternion": [
            0,
            0.707107,
            0,
            0.707107
          ],
          "params": {
            "roll4": false,
            "size": "M"
          }
        },
        {
          "name": "CON_TOP",
          "kind": "CON",
          "position": [
            0,
            10,
            0
          ],
          "quaternion": [
            0,
            0.707107,
            -0.707107,
            0
          ],
          "params": {
            "roll4": true,
            "size": "L"
          }
        }
      ],
      "collider": {
        "kind": "trimesh",
        "nodes": [
          "COL_CORE"
        ],
        "triangles": 44
      },
      "bounds": {
        "min": [
          -7.6,
          -10.000001,
          -7.599999
        ],
        "max": [
          7.6,
          10.000001,
          7.600001
        ],
        "center": [
          0,
          0,
          0.000001
        ],
        "radius": 12.244183
      }
    },
    {
      "id": "kit.station.dock",
      "class": "station_module",
      "budget": "station_module",
      "path": "/assets/placeholder/kit.station.dock.db647361.glb",
      "bytes": 72928,
      "sha256": "db6473619f3663fcde373be17f15bf7928b6eff9252cd6e9e56f3cb994cb0b90",
      "ledgerLine": "placeholders",
      "placeholder": true,
      "provenance": {
        "source": "greybox",
        "tool": "Blender 5.2.0 LTS + tools/blender/greybox_placeholders.py",
        "humanContribution": "none",
        "license": "LicenseRef-Eclipse-Owned",
        "aiGenerated": true
      },
      "kind": "model",
      "materialSlots": [
        "hull",
        "emissive"
      ],
      "lod": {
        "source": "authored",
        "distances": [
          0,
          250,
          900,
          3000
        ],
        "hysteresis": 0.1,
        "tris": [
          640,
          344,
          224,
          88
        ]
      },
      "sockets": [
        {
          "name": "CON_BOTTOM",
          "kind": "CON",
          "position": [
            0,
            -23,
            0
          ],
          "quaternion": [
            -0.707107,
            0,
            0,
            0.707107
          ],
          "params": {
            "roll4": true,
            "size": "L"
          }
        },
        {
          "name": "DOCK_A",
          "kind": "DOCK",
          "position": [
            29.5,
            -14,
            0
          ],
          "quaternion": [
            0,
            -0.707107,
            0,
            0.707107
          ],
          "params": {
            "size": "M"
          }
        },
        {
          "name": "DOCK_B",
          "kind": "DOCK",
          "position": [
            0,
            -14.000002,
            -29.499998
          ],
          "quaternion": [
            0,
            0,
            0,
            1
          ],
          "params": {
            "size": "M"
          }
        },
        {
          "name": "DOCK_C",
          "kind": "DOCK",
          "position": [
            -29.5,
            -14,
            0
          ],
          "quaternion": [
            0,
            0.707107,
            0,
            0.707107
          ],
          "params": {
            "size": "M"
          }
        },
        {
          "name": "DOCK_D",
          "kind": "DOCK",
          "position": [
            0,
            -13.999998,
            29.500002
          ],
          "quaternion": [
            0,
            -1,
            0,
            0
          ],
          "params": {
            "size": "M"
          }
        },
        {
          "name": "LIGHT_BEACON",
          "kind": "LIGHT",
          "position": [
            0,
            23.200001,
            0
          ],
          "quaternion": [
            0,
            0.707107,
            -0.707107,
            0
          ],
          "params": {
            "blinkHz": 0.333,
            "color": "#FF2A1F",
            "phase": 0,
            "type": "strobe"
          }
        }
      ],
      "collider": {
        "kind": "trimesh",
        "nodes": [
          "COL_ARMS",
          "COL_DOCK"
        ],
        "triangles": 92
      },
      "bounds": {
        "min": [
          -29.5,
          -23.000002,
          -29.5
        ],
        "max": [
          29.5,
          23.200001,
          29.500002
        ],
        "center": [
          0,
          0.099999,
          0.000001
        ],
        "radius": 33.343437
      }
    },
    {
      "id": "kit.station.hab",
      "class": "station_module",
      "budget": "station_module",
      "path": "/assets/placeholder/kit.station.hab.b69876c8.glb",
      "bytes": 31976,
      "sha256": "b69876c8980b1d4ae9c7eb5398e9837acc00cabbf1c4f918869282200ef01638",
      "ledgerLine": "placeholders",
      "placeholder": true,
      "provenance": {
        "source": "greybox",
        "tool": "Blender 5.2.0 LTS + tools/blender/greybox_placeholders.py",
        "humanContribution": "none",
        "license": "LicenseRef-Eclipse-Owned",
        "aiGenerated": true
      },
      "kind": "model",
      "materialSlots": [
        "hull",
        "glass"
      ],
      "lod": {
        "source": "authored",
        "distances": [
          0,
          250,
          900,
          3000
        ],
        "hysteresis": 0.1,
        "tris": [
          224,
          144,
          84,
          20
        ]
      },
      "sockets": [
        {
          "name": "CON_END_A",
          "kind": "CON",
          "position": [
            -8.1,
            0,
            0
          ],
          "quaternion": [
            0,
            0.751833,
            0,
            0.659353
          ],
          "params": {
            "roll4": false,
            "size": "L"
          }
        },
        {
          "name": "CON_END_B",
          "kind": "CON",
          "position": [
            8.1,
            0,
            0
          ],
          "quaternion": [
            0,
            -0.751833,
            0,
            0.659353
          ],
          "params": {
            "roll4": false,
            "size": "L"
          }
        },
        {
          "name": "CON_SPOKE",
          "kind": "CON",
          "position": [
            0,
            0,
            7
          ],
          "quaternion": [
            0,
            -1,
            0,
            0
          ],
          "params": {
            "roll4": false,
            "size": "M"
          }
        }
      ],
      "collider": {
        "kind": "trimesh",
        "nodes": [
          "COL_HAB"
        ],
        "triangles": 36
      },
      "bounds": {
        "min": [
          -8.1,
          -6.08,
          -6.1
        ],
        "max": [
          8.1,
          6.08,
          7
        ],
        "center": [
          0,
          0,
          0.45
        ],
        "radius": 10.354348
      }
    },
    {
      "id": "kit.station.hab_broken",
      "class": "station_module",
      "budget": "station_module",
      "path": "/assets/placeholder/kit.station.hab_broken.97de085f.glb",
      "bytes": 18508,
      "sha256": "97de085f89776d932dc6e7ad02098548ff40ff6edb1283707d5f13fe9cd19b75",
      "ledgerLine": "placeholders",
      "placeholder": true,
      "provenance": {
        "source": "greybox",
        "tool": "Blender 5.2.0 LTS + tools/blender/greybox_placeholders.py",
        "humanContribution": "none",
        "license": "LicenseRef-Eclipse-Owned",
        "aiGenerated": true
      },
      "kind": "model",
      "materialSlots": [
        "hull"
      ],
      "lod": {
        "source": "authored",
        "distances": [
          0,
          250,
          900,
          3000
        ],
        "hysteresis": 0.1,
        "tris": [
          104,
          56,
          40,
          20
        ]
      },
      "sockets": [
        {
          "name": "CON_END_A",
          "kind": "CON",
          "position": [
            -4.05,
            0,
            0
          ],
          "quaternion": [
            0,
            0.751833,
            0,
            0.659353
          ],
          "params": {
            "roll4": false,
            "size": "L"
          }
        }
      ],
      "collider": {
        "kind": "trimesh",
        "nodes": [
          "COL_HAB"
        ],
        "triangles": 28
      },
      "bounds": {
        "min": [
          -4.050001,
          -6,
          -6
        ],
        "max": [
          4.05,
          6,
          6
        ],
        "center": [
          0,
          0,
          0
        ],
        "radius": 7.238957
      }
    },
    {
      "id": "kit.station.refinery",
      "class": "station_module",
      "budget": "station_module",
      "path": "/assets/placeholder/kit.station.refinery.450dddb7.glb",
      "bytes": 31904,
      "sha256": "450dddb74074542b8e6e3ee820b539db323f567f8032ab52bafe0e81a99f8742",
      "ledgerLine": "placeholders",
      "placeholder": true,
      "provenance": {
        "source": "greybox",
        "tool": "Blender 5.2.0 LTS + tools/blender/greybox_placeholders.py",
        "humanContribution": "none",
        "license": "LicenseRef-Eclipse-Owned",
        "aiGenerated": true
      },
      "kind": "model",
      "materialSlots": [
        "hull"
      ],
      "lod": {
        "source": "authored",
        "distances": [
          0,
          250,
          900,
          3000
        ],
        "hysteresis": 0.1,
        "tris": [
          296,
          136,
          92,
          24
        ]
      },
      "sockets": [
        {
          "name": "CON_TOP",
          "kind": "CON",
          "position": [
            0,
            20,
            0
          ],
          "quaternion": [
            0,
            0.707107,
            -0.707107,
            0
          ],
          "params": {
            "roll4": true,
            "size": "L"
          }
        },
        {
          "name": "DOCK_ORE",
          "kind": "DOCK",
          "position": [
            18,
            0,
            0
          ],
          "quaternion": [
            0,
            -0.707107,
            0,
            0.707107
          ],
          "params": {
            "size": "L"
          }
        }
      ],
      "collider": {
        "kind": "trimesh",
        "nodes": [
          "COL_REFINERY"
        ],
        "triangles": 24
      },
      "bounds": {
        "min": [
          -18.200001,
          -26,
          -26
        ],
        "max": [
          18.200001,
          21,
          15.000002
        ],
        "center": [
          0,
          -2.5,
          -5.499999
        ],
        "radius": 35.231928
      }
    },
    {
      "id": "kit.station.solar",
      "class": "station_module",
      "budget": "station_module",
      "path": "/assets/placeholder/kit.station.solar.9f43cfd3.glb",
      "bytes": 18020,
      "sha256": "9f43cfd35ac8c3fb21a22e998e3c97a059b78570acf0600d82ce2489381fe07b",
      "ledgerLine": "placeholders",
      "placeholder": true,
      "provenance": {
        "source": "greybox",
        "tool": "Blender 5.2.0 LTS + tools/blender/greybox_placeholders.py",
        "humanContribution": "none",
        "license": "LicenseRef-Eclipse-Owned",
        "aiGenerated": true
      },
      "kind": "model",
      "materialSlots": [
        "hull"
      ],
      "lod": {
        "source": "authored",
        "distances": [
          0,
          250,
          900,
          3000
        ],
        "hysteresis": 0.1,
        "tris": [
          132,
          36,
          24,
          12
        ]
      },
      "sockets": [
        {
          "name": "CON_ROOT",
          "kind": "CON",
          "position": [
            -27.5,
            0,
            0
          ],
          "quaternion": [
            0,
            0.707107,
            0,
            0.707107
          ],
          "params": {
            "roll4": false,
            "size": "M"
          }
        }
      ],
      "collider": {
        "kind": "trimesh",
        "nodes": [
          "COL_SOLAR"
        ],
        "triangles": 12
      },
      "bounds": {
        "min": [
          -27.5,
          -1.100001,
          -8.2
        ],
        "max": [
          27.5,
          1.100001,
          8.2
        ],
        "center": [
          0,
          0,
          0
        ],
        "radius": 28.679205
      }
    },
    {
      "id": "kit.station.tank",
      "class": "station_module",
      "budget": "station_module",
      "path": "/assets/placeholder/kit.station.tank.71e95eef.glb",
      "bytes": 24344,
      "sha256": "71e95eef29ae6c26510da447d9148c040159aaca271b986a1a37d808f9bc9849",
      "ledgerLine": "placeholders",
      "placeholder": true,
      "provenance": {
        "source": "greybox",
        "tool": "Blender 5.2.0 LTS + tools/blender/greybox_placeholders.py",
        "humanContribution": "none",
        "license": "LicenseRef-Eclipse-Owned",
        "aiGenerated": true
      },
      "kind": "model",
      "materialSlots": [
        "hull"
      ],
      "lod": {
        "source": "authored",
        "distances": [
          0,
          250,
          900,
          3000
        ],
        "hysteresis": 0.1,
        "tris": [
          180,
          132,
          56,
          20
        ]
      },
      "sockets": [
        {
          "name": "CON_ROOT",
          "kind": "CON",
          "position": [
            -5,
            0,
            0
          ],
          "quaternion": [
            0,
            0.707107,
            0,
            0.707107
          ],
          "params": {
            "roll4": false,
            "size": "M"
          }
        }
      ],
      "collider": {
        "kind": "trimesh",
        "nodes": [
          "COL_TANK"
        ],
        "triangles": 36
      },
      "bounds": {
        "min": [
          -5.06,
          -10,
          -5.06
        ],
        "max": [
          5.06,
          10,
          5.06
        ],
        "center": [
          0,
          0,
          0
        ],
        "radius": 11.180341
      }
    },
    {
      "id": "kit.station.truss",
      "class": "station_module",
      "budget": "station_module",
      "path": "/assets/placeholder/kit.station.truss.3869cc9c.glb",
      "bytes": 46000,
      "sha256": "3869cc9c03eaa89e026eca57aea0790f027115b1dd02f3ddab612bfd8ec5d9de",
      "ledgerLine": "placeholders",
      "placeholder": true,
      "provenance": {
        "source": "greybox",
        "tool": "Blender 5.2.0 LTS + tools/blender/greybox_placeholders.py",
        "humanContribution": "none",
        "license": "LicenseRef-Eclipse-Owned",
        "aiGenerated": true
      },
      "kind": "model",
      "materialSlots": [
        "hull"
      ],
      "lod": {
        "source": "authored",
        "distances": [
          0,
          250,
          900,
          3000
        ],
        "hysteresis": 0.1,
        "tris": [
          528,
          144,
          96,
          48
        ]
      },
      "sockets": [
        {
          "name": "CON_A",
          "kind": "CON",
          "position": [
            0,
            12,
            0
          ],
          "quaternion": [
            0,
            0.707107,
            -0.707107,
            0
          ],
          "params": {
            "roll4": true,
            "size": "M"
          }
        },
        {
          "name": "CON_B",
          "kind": "CON",
          "position": [
            0,
            -12,
            0
          ],
          "quaternion": [
            -0.707107,
            0,
            0,
            0.707107
          ],
          "params": {
            "roll4": true,
            "size": "M"
          }
        }
      ],
      "collider": {
        "kind": "trimesh",
        "nodes": [
          "COL_TRUSS"
        ],
        "triangles": 12
      },
      "bounds": {
        "min": [
          -1.25,
          -12,
          -1.250001
        ],
        "max": [
          1.25,
          12,
          1.250001
        ],
        "center": [
          0,
          0,
          0
        ],
        "radius": 12.111614
      }
    },
    {
      "id": "kit.station.truss_broken",
      "class": "station_module",
      "budget": "station_module",
      "path": "/assets/placeholder/kit.station.truss_broken.49c53033.glb",
      "bytes": 38332,
      "sha256": "49c5303311970e49aba3e952bf3c09092abd12b440598fa69261bb2324e92490",
      "ledgerLine": "placeholders",
      "placeholder": true,
      "provenance": {
        "source": "greybox",
        "tool": "Blender 5.2.0 LTS + tools/blender/greybox_placeholders.py",
        "humanContribution": "none",
        "license": "LicenseRef-Eclipse-Owned",
        "aiGenerated": true
      },
      "kind": "model",
      "materialSlots": [
        "hull"
      ],
      "lod": {
        "source": "authored",
        "distances": [
          0,
          250,
          900,
          3000
        ],
        "hysteresis": 0.1,
        "tris": [
          396,
          108,
          84,
          48
        ]
      },
      "sockets": [
        {
          "name": "CON_A",
          "kind": "CON",
          "position": [
            0,
            -6,
            0
          ],
          "quaternion": [
            -0.707107,
            0,
            0,
            0.707107
          ],
          "params": {
            "roll4": true,
            "size": "M"
          }
        }
      ],
      "collider": {
        "kind": "trimesh",
        "nodes": [
          "COL_TRUSS"
        ],
        "triangles": 12
      },
      "bounds": {
        "min": [
          -1.25,
          -6,
          -1.25
        ],
        "max": [
          1.291748,
          6.463629,
          1.25
        ],
        "center": [
          0.020874,
          0.231814,
          0
        ],
        "radius": 6.447912
      }
    },
    {
      "id": "ord.torpedo",
      "class": "ordnance",
      "budget": "ordnance",
      "path": "/assets/ordnance/ord.torpedo.78664e92.glb",
      "bytes": 47416,
      "sha256": "78664e92fccac76f216db81189fd08a4f973824b3b0bfeae13bcc73b75a3c8de",
      "ledgerLine": "kit.hardpoints",
      "placeholder": false,
      "provenance": {
        "source": "procedural-ts",
        "tool": "Node 24.15.0 + tools/assetkit + assets-src/ord.torpedo/build.ts @ sha256:d15b7c4c95a5",
        "humanContribution": "none",
        "license": "LicenseRef-Eclipse-Owned",
        "aiGenerated": true,
        "manifestRef": "ord.torpedo"
      },
      "kind": "model",
      "materialSlots": [
        "hull",
        "emissive"
      ],
      "lod": {
        "source": "authored",
        "distances": [
          0,
          80
        ],
        "hysteresis": 0.1,
        "tris": [
          1796,
          388
        ]
      },
      "sockets": [
        {
          "name": "ENG_MAIN_C",
          "kind": "ENG",
          "position": [
            0,
            0,
            1.15
          ],
          "quaternion": [
            0,
            1,
            0,
            0
          ],
          "params": {
            "radius": 0.15
          }
        }
      ],
      "collider": null,
      "bounds": {
        "min": [
          -0.45,
          -0.45,
          -1.4
        ],
        "max": [
          0.45,
          0.45,
          1.14
        ],
        "center": [
          0,
          0,
          -0.13
        ],
        "radius": 1.29417
      }
    },
    {
      "id": "prop.claim_beacon",
      "class": "poi_prop",
      "budget": "poi_prop",
      "path": "/assets/placeholder/prop.claim_beacon.93f226fc.glb",
      "bytes": 31020,
      "sha256": "93f226fc1f66785e8f6aebcd11d492df903d0027611956196c4eea182b81d951",
      "ledgerLine": "placeholders_m5",
      "placeholder": true,
      "provenance": {
        "source": "greybox",
        "tool": "Blender 5.2.0 LTS + tools/blender/greybox_charter.py",
        "humanContribution": "none",
        "license": "LicenseRef-Eclipse-Owned",
        "aiGenerated": true
      },
      "kind": "model",
      "materialSlots": [
        "hull",
        "emissive"
      ],
      "lod": {
        "source": "authored",
        "distances": [
          0,
          400
        ],
        "hysteresis": 0.1,
        "tris": [
          352,
          60
        ]
      },
      "sockets": [
        {
          "name": "DOCK_PORT",
          "kind": "DOCK",
          "position": [
            0,
            -3.2,
            -1.5
          ],
          "quaternion": [
            0,
            0,
            0,
            1
          ],
          "params": {
            "size": "S"
          }
        },
        {
          "name": "LIGHT_BEACON",
          "kind": "LIGHT",
          "position": [
            0,
            5.8,
            0
          ],
          "quaternion": [
            0,
            0.707107,
            -0.707107,
            0
          ],
          "params": {
            "blinkHz": 0.5,
            "color": "#F4F2FF",
            "phase": 0,
            "type": "strobe"
          }
        }
      ],
      "collider": {
        "kind": "convexHulls",
        "nodes": [
          "COL_BASE",
          "COL_MAST",
          "COL_PLATE"
        ],
        "hullVerts": [
          8,
          8,
          8
        ]
      },
      "bounds": {
        "min": [
          -3,
          -6,
          -3
        ],
        "max": [
          3,
          5.8,
          3
        ],
        "center": [
          0,
          -0.1,
          0
        ],
        "radius": 7.242362
      }
    },
    {
      "id": "prop.column_nine_hauler",
      "class": "poi_prop",
      "budget": "poi_prop",
      "path": "/assets/placeholder/prop.column_nine_hauler.fec98f34.glb",
      "bytes": 48824,
      "sha256": "fec98f34985b2f1ddb3c41493dfed3339636e792939b4a699be5e8032a5d79f2",
      "ledgerLine": "placeholders_m7",
      "placeholder": true,
      "provenance": {
        "source": "greybox",
        "tool": "Blender 5.2.0 LTS + tools/blender/greybox_story.py",
        "humanContribution": "none",
        "license": "LicenseRef-Eclipse-Owned",
        "aiGenerated": true
      },
      "kind": "model",
      "materialSlots": [
        "hull",
        "glass"
      ],
      "lod": {
        "source": "authored",
        "distances": [
          0,
          400
        ],
        "hysteresis": 0.1,
        "tris": [
          556,
          144
        ]
      },
      "sockets": [
        {
          "name": "DOCK_PORT",
          "kind": "DOCK",
          "position": [
            0,
            2.799999,
            -17.5
          ],
          "quaternion": [
            0,
            0.707107,
            -0.707107,
            0
          ],
          "params": {
            "size": "S"
          }
        }
      ],
      "collider": {
        "kind": "convexHulls",
        "nodes": [
          "COL_BIN_1",
          "COL_BIN_2",
          "COL_BIN_3",
          "COL_CAB",
          "COL_ENGINE",
          "COL_PLATE",
          "COL_SPINE"
        ],
        "hullVerts": [
          8,
          8,
          8,
          8,
          8,
          8,
          8
        ]
      },
      "bounds": {
        "min": [
          -5.052234,
          -5.619632,
          -21.099998
        ],
        "max": [
          7.324145,
          5.237588,
          20
        ],
        "center": [
          1.135956,
          -0.191022,
          -0.549999
        ],
        "radius": 21.163249
      }
    },
    {
      "id": "prop.column_nine_settler",
      "class": "poi_prop",
      "budget": "poi_prop",
      "path": "/assets/placeholder/prop.column_nine_settler.1dee61a5.glb",
      "bytes": 45672,
      "sha256": "1dee61a573f3667fe61693a92473bf849674700159ed67c2f72ea1e8b47ef932",
      "ledgerLine": "placeholders_m7",
      "placeholder": true,
      "provenance": {
        "source": "greybox",
        "tool": "Blender 5.2.0 LTS + tools/blender/greybox_story.py",
        "humanContribution": "none",
        "license": "LicenseRef-Eclipse-Owned",
        "aiGenerated": true
      },
      "kind": "model",
      "materialSlots": [
        "hull",
        "glass"
      ],
      "lod": {
        "source": "authored",
        "distances": [
          0,
          400
        ],
        "hysteresis": 0.1,
        "tris": [
          540,
          172
        ]
      },
      "sockets": [
        {
          "name": "DOCK_PORT",
          "kind": "DOCK",
          "position": [
            -4.65,
            0,
            -9
          ],
          "quaternion": [
            0,
            0.707107,
            0,
            0.707107
          ],
          "params": {
            "size": "S"
          }
        }
      ],
      "collider": {
        "kind": "convexHulls",
        "nodes": [
          "COL_BREACH",
          "COL_CAB",
          "COL_ENGINE",
          "COL_HAB",
          "COL_MAST",
          "COL_PANEL"
        ],
        "hullVerts": [
          8,
          8,
          8,
          24,
          8,
          8
        ]
      },
      "bounds": {
        "min": [
          -4.8,
          -4.800001,
          -18.099998
        ],
        "max": [
          4.854559,
          10.006705,
          14
        ],
        "center": [
          0.027279,
          2.603352,
          -2.049999
        ],
        "radius": 16.81811
      }
    },
    {
      "id": "prop.component.cargo_pod",
      "class": "prop",
      "budget": "prop",
      "path": "/assets/prop/prop.component.cargo_pod.8ea86980.glb",
      "bytes": 136092,
      "sha256": "8ea86980d10fc16d83bd400e6d52a07ce3aff2b52935d73e6e69dad75c9fcf9c",
      "ledgerLine": "streamed.props",
      "placeholder": false,
      "provenance": {
        "source": "procedural-ts",
        "tool": "Node 24.15.0 + tools/assetkit + assets-src/prop.component.cargo_pod/build.ts @ sha256:cefaf20d9e8e",
        "humanContribution": "none",
        "license": "LicenseRef-Eclipse-Owned",
        "aiGenerated": true,
        "manifestRef": "prop.component.cargo_pod"
      },
      "kind": "model",
      "materialSlots": [
        "hull",
        "emissive",
        "decal"
      ],
      "lod": {
        "source": "authored",
        "distances": [
          0,
          60,
          250
        ],
        "hysteresis": 0.1,
        "tris": [
          5646,
          1146,
          296
        ]
      },
      "sockets": [],
      "collider": {
        "kind": "convexHulls",
        "nodes": [
          "COL_HULL_00"
        ],
        "hullVerts": [
          18
        ]
      },
      "bounds": {
        "min": [
          -0.845,
          -0.91395,
          -1.279997
        ],
        "max": [
          0.926608,
          1.003018,
          1.284999
        ],
        "center": [
          0.040804,
          0.044534,
          0.002501
        ],
        "radius": 1.728154
      }
    },
    {
      "id": "prop.component.data_core",
      "class": "prop",
      "budget": "prop",
      "path": "/assets/placeholder/prop.component.data_core.f81efaef.glb",
      "bytes": 20788,
      "sha256": "f81efaef1abcb49ae5ec8a65b2224768d64d8d3d20c92f51b4d1d31ee52a3808",
      "ledgerLine": "placeholders",
      "placeholder": true,
      "provenance": {
        "source": "greybox",
        "tool": "Blender 5.2.0 LTS + tools/blender/m2_placeholders.py",
        "humanContribution": "none",
        "license": "LicenseRef-Eclipse-Owned",
        "aiGenerated": true
      },
      "kind": "model",
      "materialSlots": [
        "hull",
        "emissive"
      ],
      "lod": {
        "source": "authored",
        "distances": [
          0,
          60,
          250
        ],
        "hysteresis": 0.1,
        "tris": [
          92,
          80,
          40
        ]
      },
      "sockets": [
        {
          "name": "LIGHT_CORE",
          "kind": "LIGHT",
          "position": [
            0,
            0.4,
            0
          ],
          "quaternion": [
            0,
            0.707107,
            -0.707107,
            0
          ],
          "params": {
            "blinkHz": 0.5,
            "color": "#3FE0FF",
            "phase": 0,
            "type": "sensor"
          }
        }
      ],
      "collider": {
        "kind": "convexHulls",
        "nodes": [
          "COL_HULL"
        ],
        "hullVerts": [
          12
        ]
      },
      "bounds": {
        "min": [
          -0.216506,
          -0.4,
          -0.25
        ],
        "max": [
          0.216506,
          0.4,
          0.25
        ],
        "center": [
          0,
          0,
          0
        ],
        "radius": 0.447214
      }
    },
    {
      "id": "prop.component.radiator",
      "class": "prop",
      "budget": "prop",
      "path": "/assets/placeholder/prop.component.radiator.837bcd0b.glb",
      "bytes": 20604,
      "sha256": "837bcd0b41795efd02b09c33e10bc81f46183c8228e923564454a0e2827aa43d",
      "ledgerLine": "placeholders",
      "placeholder": true,
      "provenance": {
        "source": "greybox",
        "tool": "Blender 5.2.0 LTS + tools/blender/m2_placeholders.py",
        "humanContribution": "none",
        "license": "LicenseRef-Eclipse-Owned",
        "aiGenerated": true
      },
      "kind": "model",
      "materialSlots": [
        "hull"
      ],
      "lod": {
        "source": "authored",
        "distances": [
          0,
          60,
          250
        ],
        "hysteresis": 0.1,
        "tris": [
          132,
          108,
          72
        ]
      },
      "sockets": [],
      "collider": {
        "kind": "convexHulls",
        "nodes": [
          "COL_HULL"
        ],
        "hullVerts": [
          8
        ]
      },
      "bounds": {
        "min": [
          -1.5,
          -0.76,
          -0.35
        ],
        "max": [
          1.5,
          0.76,
          0.34
        ],
        "center": [
          0,
          0,
          -0.005
        ],
        "radius": 1.684822
      }
    },
    {
      "id": "prop.component.reactor",
      "class": "prop",
      "budget": "prop",
      "path": "/assets/placeholder/prop.component.reactor.0ed383f2.glb",
      "bytes": 27640,
      "sha256": "0ed383f24a6c6e03cda3c19a9713f0cbb248a2df83e3c76dcdfffe5511622c30",
      "ledgerLine": "placeholders",
      "placeholder": true,
      "provenance": {
        "source": "greybox",
        "tool": "Blender 5.2.0 LTS + tools/blender/m2_placeholders.py",
        "humanContribution": "none",
        "license": "LicenseRef-Eclipse-Owned",
        "aiGenerated": true
      },
      "kind": "model",
      "materialSlots": [
        "hull",
        "emissive"
      ],
      "lod": {
        "source": "authored",
        "distances": [
          0,
          60,
          250
        ],
        "hysteresis": 0.1,
        "tris": [
          208,
          124,
          72
        ]
      },
      "sockets": [],
      "collider": {
        "kind": "convexHulls",
        "nodes": [
          "COL_HULL"
        ],
        "hullVerts": [
          20
        ]
      },
      "bounds": {
        "min": [
          -0.9,
          -1.25,
          -0.9
        ],
        "max": [
          1,
          1.25,
          0.9
        ],
        "center": [
          0.05,
          0,
          0
        ],
        "radius": 1.457738
      }
    },
    {
      "id": "prop.component.shield_gen",
      "class": "prop",
      "budget": "prop",
      "path": "/assets/placeholder/prop.component.shield_gen.e7638156.glb",
      "bytes": 25612,
      "sha256": "e76381569305e09b0758e783c3750f162b6e91c483768885cdfcce62016c91da",
      "ledgerLine": "placeholders",
      "placeholder": true,
      "provenance": {
        "source": "greybox",
        "tool": "Blender 5.2.0 LTS + tools/blender/m2_placeholders.py",
        "humanContribution": "none",
        "license": "LicenseRef-Eclipse-Owned",
        "aiGenerated": true
      },
      "kind": "model",
      "materialSlots": [
        "hull",
        "emissive"
      ],
      "lod": {
        "source": "authored",
        "distances": [
          0,
          60,
          250
        ],
        "hysteresis": 0.1,
        "tris": [
          156,
          108,
          72
        ]
      },
      "sockets": [],
      "collider": {
        "kind": "convexHulls",
        "nodes": [
          "COL_HULL"
        ],
        "hullVerts": [
          14
        ]
      },
      "bounds": {
        "min": [
          -0.8,
          -1,
          -0.8
        ],
        "max": [
          0.8,
          0.7,
          0.8
        ],
        "center": [
          0,
          -0.15,
          0
        ],
        "radius": 1.415097
      }
    },
    {
      "id": "prop.component.thruster",
      "class": "prop",
      "budget": "prop",
      "path": "/assets/placeholder/prop.component.thruster.d78a5f32.glb",
      "bytes": 26996,
      "sha256": "d78a5f32e3e485055df3aae342d5c22f088308f8fa8223fae7eed6b32c276241",
      "ledgerLine": "placeholders",
      "placeholder": true,
      "provenance": {
        "source": "greybox",
        "tool": "Blender 5.2.0 LTS + tools/blender/m2_placeholders.py",
        "humanContribution": "none",
        "license": "LicenseRef-Eclipse-Owned",
        "aiGenerated": true
      },
      "kind": "model",
      "materialSlots": [
        "hull",
        "emissive"
      ],
      "lod": {
        "source": "authored",
        "distances": [
          0,
          60,
          250
        ],
        "hysteresis": 0.1,
        "tris": [
          176,
          112,
          60
        ]
      },
      "sockets": [],
      "collider": {
        "kind": "convexHulls",
        "nodes": [
          "COL_HULL"
        ],
        "hullVerts": [
          14
        ]
      },
      "bounds": {
        "min": [
          -0.85,
          -0.85,
          -1
        ],
        "max": [
          0.85,
          0.85,
          1.02
        ],
        "center": [
          0,
          0,
          0.01
        ],
        "radius": 1.304837
      }
    },
    {
      "id": "prop.component.weapon",
      "class": "prop",
      "budget": "prop",
      "path": "/assets/placeholder/prop.component.weapon.8345ae7c.glb",
      "bytes": 17428,
      "sha256": "8345ae7cf2bb24dd56431d474b8192ed55f0f40c737f0c5e544d08231c24e447",
      "ledgerLine": "placeholders",
      "placeholder": true,
      "provenance": {
        "source": "greybox",
        "tool": "Blender 5.2.0 LTS + tools/blender/m2_placeholders.py",
        "humanContribution": "none",
        "license": "LicenseRef-Eclipse-Owned",
        "aiGenerated": true
      },
      "kind": "model",
      "materialSlots": [
        "hull"
      ],
      "lod": {
        "source": "authored",
        "distances": [
          0,
          60,
          250
        ],
        "hysteresis": 0.1,
        "tris": [
          124,
          80,
          32
        ]
      },
      "sockets": [],
      "collider": {
        "kind": "convexHulls",
        "nodes": [
          "COL_HULL"
        ],
        "hullVerts": [
          18
        ]
      },
      "bounds": {
        "min": [
          -0.4,
          -0.3,
          -1
        ],
        "max": [
          0.43,
          0.4,
          1
        ],
        "center": [
          0.015,
          0.05,
          0
        ],
        "radius": 1.13786
      }
    },
    {
      "id": "prop.ore_chunk",
      "class": "prop",
      "budget": "prop",
      "path": "/assets/prop/prop.ore_chunk.2d6a5254.glb",
      "bytes": 55756,
      "sha256": "2d6a5254528031cbc384f2290a9f01a9a2927d0bde269864b53a63e2f4ff55e3",
      "ledgerLine": "streamed.props",
      "placeholder": false,
      "provenance": {
        "source": "procedural-ts",
        "tool": "Node 24.15.0 + tools/assetkit + assets-src/prop.ore_chunk/build.ts @ sha256:9d9385739c0a",
        "humanContribution": "none",
        "license": "LicenseRef-Eclipse-Owned",
        "aiGenerated": true,
        "manifestRef": "prop.ore_chunk"
      },
      "kind": "model",
      "materialSlots": [
        "hull",
        "emissive"
      ],
      "lod": {
        "source": "authored",
        "distances": [
          0,
          60,
          250
        ],
        "hysteresis": 0.1,
        "tris": [
          1432,
          572,
          232
        ]
      },
      "sockets": [],
      "collider": null,
      "bounds": {
        "min": [
          -0.386603,
          -0.486512,
          -0.305955
        ],
        "max": [
          0.364175,
          0.490764,
          0.365128
        ],
        "center": [
          -0.011214,
          0.002126,
          0.029586
        ],
        "radius": 0.52953
      }
    },
    {
      "id": "reach.anomaly",
      "class": "poi_prop",
      "budget": "poi_prop",
      "path": "/assets/placeholder/reach.anomaly.fd294269.glb",
      "bytes": 31220,
      "sha256": "fd2942696e533963781373db4c14a7405c3be7b4689df883fe02e5f2bbc028b6",
      "ledgerLine": "placeholders",
      "placeholder": true,
      "provenance": {
        "source": "greybox",
        "tool": "Blender 5.2.0 LTS + tools/blender/reach_placeholders.py",
        "humanContribution": "none",
        "license": "LicenseRef-Eclipse-Owned",
        "aiGenerated": true
      },
      "kind": "model",
      "materialSlots": [
        "hull",
        "emissive"
      ],
      "lod": {
        "source": "authored",
        "distances": [
          0,
          400
        ],
        "hysteresis": 0.1,
        "tris": [
          136,
          84
        ]
      },
      "sockets": [
        {
          "name": "DOCK_PORT",
          "kind": "DOCK",
          "position": [
            0,
            -10.000001,
            -15.999999
          ],
          "quaternion": [
            0,
            0,
            0,
            1
          ],
          "params": {
            "size": "S"
          }
        }
      ],
      "collider": {
        "kind": "convexHulls",
        "nodes": [
          "COL_CRYSTAL_0",
          "COL_CRYSTAL_1",
          "COL_CRYSTAL_2",
          "COL_CRYSTAL_3",
          "COL_CRYSTAL_4",
          "COL_CRYSTAL_5",
          "COL_ROCK"
        ],
        "hullVerts": [
          8,
          8,
          8,
          8,
          8,
          8,
          34
        ]
      },
      "bounds": {
        "min": [
          -36.25193,
          -22.63555,
          -38.98801
        ],
        "max": [
          35.615929,
          65,
          38.78986
        ],
        "center": [
          -0.318001,
          21.182225,
          -0.099075
        ],
        "radius": 44.098068
      }
    },
    {
      "id": "reach.base_guardian",
      "class": "structure",
      "budget": "structure",
      "path": "/assets/placeholder/reach.base_guardian.05fed043.glb",
      "bytes": 75340,
      "sha256": "05fed0433cdd88dc6ff5907c8b037c77edf83d3c4f150d327eb7cac8d4994478",
      "ledgerLine": "placeholders",
      "placeholder": true,
      "provenance": {
        "aiGenerated": true,
        "humanContribution": "none",
        "license": "LicenseRef-Eclipse-Owned",
        "source": "greybox",
        "tool": "Blender 5.2.0 LTS + tools/blender/reach_placeholders.py"
      },
      "kind": "model",
      "materialSlots": [
        "hull",
        "emissive"
      ],
      "lod": {
        "distances": [
          0,
          2498
        ],
        "hysteresis": 0.1,
        "source": "authored",
        "tris": [
          992,
          472
        ]
      },
      "sockets": [
        {
          "kind": "DOCK",
          "name": "DOCK_BAY_0",
          "params": {
            "bayD": 80,
            "bayH": 30,
            "bayW": 50,
            "size": "M"
          },
          "position": [
            -15.7,
            -68.700012,
            -240.5
          ],
          "quaternion": [
            0,
            0,
            0,
            1
          ]
        },
        {
          "kind": "LIGHT",
          "name": "LIGHT_BAY_0",
          "params": {
            "blinkHz": 0,
            "color": "#7CFFD1",
            "phase": 0,
            "type": "work"
          },
          "position": [
            -43.700001,
            -45.700024,
            -281
          ],
          "quaternion": [
            0,
            0,
            0,
            1
          ]
        },
        {
          "kind": "LIGHT",
          "name": "LIGHT_BAY_1",
          "params": {
            "blinkHz": 0,
            "color": "#7CFFD1",
            "phase": 0,
            "type": "work"
          },
          "position": [
            12.3,
            -45.700024,
            -281
          ],
          "quaternion": [
            0,
            0,
            0,
            1
          ]
        },
        {
          "kind": "LIGHT",
          "name": "LIGHT_NAV_0",
          "params": {
            "blinkHz": 0,
            "color": "#4FA3FF",
            "phase": 0,
            "type": "nav"
          },
          "position": [
            21.299999,
            185.300003,
            39.499985
          ],
          "quaternion": [
            0,
            0.707107,
            -0.707107,
            0
          ]
        }
      ],
      "collider": {
        "kind": "trimesh",
        "nodes": [
          "COL_BAY",
          "COL_HULL"
        ],
        "triangles": 540
      },
      "bounds": {
        "center": [
          0.010864,
          0.002335,
          0
        ],
        "max": [
          308.721741,
          185.300003,
          281.5
        ],
        "min": [
          -308.700012,
          -185.295334,
          -281.5
        ],
        "radius": 348.376246
      }
    },
    {
      "id": "reach.base_raider",
      "class": "structure",
      "budget": "structure",
      "path": "/assets/placeholder/reach.base_raider.23c5432a.glb",
      "bytes": 84728,
      "sha256": "23c5432aa76343ff82877f7acfc328e369662a2c52d96e36a4d98f0b42de7d26",
      "ledgerLine": "placeholders",
      "placeholder": true,
      "provenance": {
        "aiGenerated": true,
        "humanContribution": "none",
        "license": "LicenseRef-Eclipse-Owned",
        "source": "greybox",
        "tool": "Blender 5.2.0 LTS + tools/blender/reach_placeholders.py"
      },
      "kind": "model",
      "materialSlots": [
        "hull",
        "emissive"
      ],
      "lod": {
        "distances": [
          0,
          2365
        ],
        "hysteresis": 0.1,
        "source": "authored",
        "tris": [
          1068,
          468
        ]
      },
      "sockets": [
        {
          "kind": "DOCK",
          "name": "DOCK_BAY_0",
          "params": {
            "bayD": 80,
            "bayH": 30,
            "bayW": 50,
            "size": "M"
          },
          "position": [
            8.9,
            -22.700014,
            -175
          ],
          "quaternion": [
            0,
            0,
            0,
            1
          ]
        },
        {
          "kind": "LIGHT",
          "name": "LIGHT_BAY_0",
          "params": {
            "blinkHz": 0,
            "color": "#FF2F24",
            "phase": 0,
            "type": "work"
          },
          "position": [
            -19.1,
            0.299984,
            -215.5
          ],
          "quaternion": [
            0,
            0,
            0,
            1
          ]
        },
        {
          "kind": "LIGHT",
          "name": "LIGHT_BAY_1",
          "params": {
            "blinkHz": 0,
            "color": "#FF2F24",
            "phase": 0,
            "type": "work"
          },
          "position": [
            36.900002,
            0.299984,
            -215.5
          ],
          "quaternion": [
            0,
            0,
            0,
            1
          ]
        },
        {
          "kind": "LIGHT",
          "name": "LIGHT_SENSOR_0",
          "params": {
            "blinkHz": 0,
            "color": "#FF2F24",
            "phase": 0,
            "type": "sensor"
          },
          "position": [
            -33.099998,
            5.299984,
            -216
          ],
          "quaternion": [
            0,
            0,
            0,
            1
          ]
        },
        {
          "kind": "LIGHT",
          "name": "LIGHT_SENSOR_1",
          "params": {
            "blinkHz": 0,
            "color": "#FF2F24",
            "phase": 0,
            "type": "sensor"
          },
          "position": [
            50.900002,
            5.299984,
            -216
          ],
          "quaternion": [
            0,
            0,
            0,
            1
          ]
        }
      ],
      "collider": {
        "kind": "trimesh",
        "nodes": [
          "COL_BAY",
          "COL_HULL"
        ],
        "triangles": 360
      },
      "bounds": {
        "center": [
          0.010323,
          -0.003807,
          0.462074
        ],
        "max": [
          243.120651,
          205.017014,
          255.924149
        ],
        "min": [
          -243.100006,
          -205.024628,
          -255
        ],
        "radius": 276.617539
      }
    },
    {
      "id": "reach.beacon",
      "class": "poi_prop",
      "budget": "poi_prop",
      "path": "/assets/placeholder/reach.beacon.56436a70.glb",
      "bytes": 12808,
      "sha256": "56436a70b2a3219b2831c49a4cb7fac737a362b1dfa5a8884a8cfe6626d5557d",
      "ledgerLine": "placeholders",
      "placeholder": true,
      "provenance": {
        "source": "greybox",
        "tool": "Blender 5.2.0 LTS + tools/blender/reach_placeholders.py",
        "humanContribution": "none",
        "license": "LicenseRef-Eclipse-Owned",
        "aiGenerated": true
      },
      "kind": "model",
      "materialSlots": [
        "hull",
        "emissive"
      ],
      "lod": {
        "source": "authored",
        "distances": [
          0,
          400
        ],
        "hysteresis": 0.1,
        "tris": [
          48,
          36
        ]
      },
      "sockets": [
        {
          "name": "DOCK_PORT",
          "kind": "DOCK",
          "position": [
            0,
            -6,
            -1.6
          ],
          "quaternion": [
            0,
            0,
            0,
            1
          ],
          "params": {
            "size": "S"
          }
        },
        {
          "name": "LIGHT_BEACON",
          "kind": "LIGHT",
          "position": [
            0,
            11,
            0
          ],
          "quaternion": [
            0,
            0.707107,
            -0.707107,
            0
          ],
          "params": {
            "blinkHz": 1,
            "color": "#FFB347",
            "phase": 0,
            "type": "strobe"
          }
        }
      ],
      "collider": {
        "kind": "convexHulls",
        "nodes": [
          "COL_BASE",
          "COL_MAST"
        ],
        "hullVerts": [
          8,
          16
        ]
      },
      "bounds": {
        "min": [
          -3,
          -12,
          -2.999999
        ],
        "max": [
          3,
          11,
          3.000001
        ],
        "center": [
          0,
          -0.5,
          0.000001
        ],
        "radius": 12.257651
      }
    },
    {
      "id": "reach.cache",
      "class": "poi_prop",
      "budget": "poi_prop",
      "path": "/assets/placeholder/reach.cache.1af64838.glb",
      "bytes": 12792,
      "sha256": "1af64838568b8d04872c1fb2ea91920baf5178c60ec47ea63c4eea8da2e37352",
      "ledgerLine": "placeholders",
      "placeholder": true,
      "provenance": {
        "source": "greybox",
        "tool": "Blender 5.2.0 LTS + tools/blender/reach_placeholders.py",
        "humanContribution": "none",
        "license": "LicenseRef-Eclipse-Owned",
        "aiGenerated": true
      },
      "kind": "model",
      "materialSlots": [
        "hull",
        "emissive"
      ],
      "lod": {
        "source": "authored",
        "distances": [
          0,
          400
        ],
        "hysteresis": 0.1,
        "tris": [
          48,
          36
        ]
      },
      "sockets": [
        {
          "name": "DOCK_PORT",
          "kind": "DOCK",
          "position": [
            0,
            -2,
            -2.5
          ],
          "quaternion": [
            0,
            0,
            0,
            1
          ],
          "params": {
            "size": "S"
          }
        }
      ],
      "collider": {
        "kind": "convexHulls",
        "nodes": [
          "COL_LOWER",
          "COL_UPPER"
        ],
        "hullVerts": [
          8,
          8
        ]
      },
      "bounds": {
        "min": [
          -6,
          -3.5,
          -2.6
        ],
        "max": [
          6,
          4.5,
          2.915209
        ],
        "center": [
          0,
          0.5,
          0.157604
        ],
        "radius": 7.685237
      }
    },
    {
      "id": "reach.lane_ring",
      "class": "structure",
      "budget": "structure",
      "path": "/assets/placeholder/reach.lane_ring.0cca4014.glb",
      "bytes": 33956,
      "sha256": "0cca4014c11fad4f743aa139b5fd6456e324dfd4b8726fdfff523d9605d25e8a",
      "ledgerLine": "placeholders",
      "placeholder": true,
      "provenance": {
        "source": "greybox",
        "tool": "Blender 5.2.0 LTS + tools/blender/reach_placeholders.py",
        "humanContribution": "none",
        "license": "LicenseRef-Eclipse-Owned",
        "aiGenerated": true
      },
      "kind": "model",
      "materialSlots": [
        "hull",
        "emissive"
      ],
      "lod": {
        "source": "authored",
        "distances": [
          0,
          1500
        ],
        "hysteresis": 0.1,
        "tris": [
          420,
          132
        ]
      },
      "sockets": [
        {
          "name": "DOCK_REPAIR",
          "kind": "DOCK",
          "position": [
            0,
            70,
            -0.000005
          ],
          "quaternion": [
            0,
            0.707107,
            -0.707107,
            0
          ],
          "params": {
            "size": "S"
          }
        },
        {
          "name": "DOCK_TRANSIT",
          "kind": "DOCK",
          "position": [
            0,
            0,
            0
          ],
          "quaternion": [
            0,
            0,
            0,
            1
          ],
          "params": {
            "radius": 50,
            "size": "M"
          }
        },
        {
          "name": "LIGHT_NAV_0",
          "kind": "LIGHT",
          "position": [
            -70,
            0,
            0
          ],
          "quaternion": [
            0,
            0.707107,
            0,
            0.707107
          ],
          "params": {
            "blinkHz": 0,
            "color": "#FF2A1F",
            "phase": 0,
            "type": "nav"
          }
        },
        {
          "name": "LIGHT_NAV_1",
          "kind": "LIGHT",
          "position": [
            70,
            0,
            0
          ],
          "quaternion": [
            0,
            -0.707107,
            0,
            0.707107
          ],
          "params": {
            "blinkHz": 0,
            "color": "#2BFF6A",
            "phase": 0,
            "type": "nav"
          }
        }
      ],
      "collider": {
        "kind": "trimesh",
        "nodes": [
          "COL_RING"
        ],
        "triangles": 204
      },
      "bounds": {
        "min": [
          -70,
          -70,
          -8.000005
        ],
        "max": [
          70,
          70,
          7.999995
        ],
        "center": [
          0,
          0,
          -0.000005
        ],
        "radius": 70.256673
      }
    },
    {
      "id": "reach.relay",
      "class": "structure",
      "budget": "structure",
      "path": "/assets/structure/reach.relay.bd99fc32.glb",
      "bytes": 1651548,
      "sha256": "bd99fc32ca9b4a9a77e73f093eafb8beff577593bcca342d0655ef4da410bd45",
      "ledgerLine": "streamed.reach",
      "placeholder": false,
      "provenance": {
        "source": "procedural-ts",
        "tool": "Node 24.15.0 + tools/assetkit + assets-src/reach.relay/build.ts @ sha256:2211e9ecac4b",
        "humanContribution": "none",
        "license": "LicenseRef-Eclipse-Owned",
        "aiGenerated": true,
        "manifestRef": "reach.relay"
      },
      "kind": "model",
      "materialSlots": [
        "hull",
        "emissive",
        "decal"
      ],
      "lod": {
        "source": "authored",
        "distances": [
          0,
          1500,
          6000,
          20000
        ],
        "hysteresis": 0.1,
        "tris": [
          53372,
          24508,
          5464,
          1514
        ]
      },
      "sockets": [
        {
          "name": "DOCK_REPAIR",
          "kind": "DOCK",
          "position": [
            0,
            240,
            -0.000018
          ],
          "quaternion": [
            0,
            0.707107,
            -0.707107,
            0
          ],
          "params": {
            "size": "M"
          }
        },
        {
          "name": "DOCK_TRANSIT",
          "kind": "DOCK",
          "position": [
            0,
            0,
            0
          ],
          "quaternion": [
            0,
            0,
            0,
            1
          ],
          "params": {
            "radius": 180,
            "size": "L"
          }
        },
        {
          "name": "LIGHT_BEACON_0",
          "kind": "LIGHT",
          "position": [
            169.705627,
            169.705627,
            -0.000013
          ],
          "quaternion": [
            -0.270598,
            -0.653281,
            0.653282,
            0.270598
          ],
          "params": {
            "blinkHz": 0.5,
            "color": "#6FD8FF",
            "phase": 0,
            "type": "nav"
          }
        },
        {
          "name": "LIGHT_BEACON_1",
          "kind": "LIGHT",
          "position": [
            -169.705627,
            169.705627,
            -0.000013
          ],
          "quaternion": [
            -0.270598,
            0.653281,
            -0.653282,
            0.270598
          ],
          "params": {
            "blinkHz": 0.5,
            "color": "#6FD8FF",
            "phase": 0.25,
            "type": "nav"
          }
        },
        {
          "name": "LIGHT_BEACON_2",
          "kind": "LIGHT",
          "position": [
            -169.705627,
            -169.705627,
            0.000013
          ],
          "quaternion": [
            -0.653282,
            0.270598,
            -0.270598,
            0.653281
          ],
          "params": {
            "blinkHz": 0.5,
            "color": "#6FD8FF",
            "phase": 0.5,
            "type": "nav"
          }
        },
        {
          "name": "LIGHT_BEACON_3",
          "kind": "LIGHT",
          "position": [
            169.705627,
            -169.705627,
            0.000013
          ],
          "quaternion": [
            -0.653282,
            -0.270598,
            0.270598,
            0.653281
          ],
          "params": {
            "blinkHz": 0.5,
            "color": "#6FD8FF",
            "phase": 0.75,
            "type": "nav"
          }
        }
      ],
      "collider": {
        "kind": "trimesh",
        "nodes": [
          "COL_TRIMESH_00"
        ],
        "triangles": 5464
      },
      "bounds": {
        "min": [
          -240.64624,
          -240.64624,
          -45.403
        ],
        "max": [
          240.646251,
          240.315769,
          45.406211
        ],
        "center": [
          0.000006,
          -0.165236,
          0.001606
        ],
        "radius": 320.635747
      }
    },
    {
      "bounds": {
        "center": [
          -0.000031,
          -0.000031,
          -0.039948
        ],
        "max": [
          646.858765,
          900,
          579.600037
        ],
        "min": [
          -646.858826,
          -900.000061,
          -579.679932
        ],
        "radius": 1159.12179
      },
      "budget": "station",
      "bytes": 78004,
      "class": "station",
      "collider": {
        "kind": "trimesh",
        "nodes": [
          "COL_BAY",
          "COL_HULL"
        ],
        "triangles": 564
      },
      "id": "reach.station_habitat",
      "kind": "model",
      "ledgerLine": "placeholders",
      "lod": {
        "distances": [
          0,
          4637
        ],
        "hysteresis": 0.1,
        "source": "authored",
        "tris": [
          1252,
          396
        ]
      },
      "materialSlots": [
        "hull",
        "emissive"
      ],
      "path": "/assets/placeholder/reach.station_habitat.2c47a260.glb",
      "placeholder": true,
      "provenance": {
        "aiGenerated": true,
        "humanContribution": "none",
        "license": "LicenseRef-Eclipse-Owned",
        "source": "greybox",
        "tool": "Blender 5.2.0 LTS + tools/blender/reach_placeholders.py"
      },
      "sha256": "2c47a260e6860dd6c4a4654ef668f2080dc0fff5e8fce75874eb0925670ac6fa",
      "sockets": [
        {
          "kind": "DOCK",
          "name": "DOCK_BAY_0",
          "params": {
            "bayD": 80,
            "bayH": 30,
            "bayW": 50,
            "size": "M"
          },
          "position": [
            0,
            -870.000061,
            -522.399963
          ],
          "quaternion": [
            0,
            0,
            0,
            1
          ]
        },
        {
          "kind": "LIGHT",
          "name": "LIGHT_BAY_0",
          "params": {
            "blinkHz": 0,
            "color": "#FFB36B",
            "phase": 0,
            "type": "work"
          },
          "position": [
            -28,
            -847.000061,
            -562.899963
          ],
          "quaternion": [
            0,
            0,
            0,
            1
          ]
        },
        {
          "kind": "LIGHT",
          "name": "LIGHT_BAY_1",
          "params": {
            "blinkHz": 0,
            "color": "#FFB36B",
            "phase": 0,
            "type": "work"
          },
          "position": [
            28,
            -847.000061,
            -562.899963
          ],
          "quaternion": [
            0,
            0,
            0,
            1
          ]
        },
        {
          "kind": "LIGHT",
          "name": "LIGHT_NAV_0",
          "params": {
            "blinkHz": 0,
            "color": "#FFF6E8",
            "phase": 0,
            "type": "nav"
          },
          "position": [
            0,
            -769.999939,
            579.600037
          ],
          "quaternion": [
            0,
            1,
            0,
            0
          ]
        }
      ]
    },
    {
      "bounds": {
        "center": [
          0,
          0,
          -0.160187
        ],
        "max": [
          923.879517,
          912,
          1012.279602
        ],
        "min": [
          -923.879517,
          -912,
          -1012.599976
        ],
        "radius": 1238.501057
      },
      "budget": "station",
      "bytes": 70320,
      "class": "station",
      "collider": {
        "kind": "trimesh",
        "nodes": [
          "COL_BAY",
          "COL_HULL"
        ],
        "triangles": 596
      },
      "id": "reach.station_hub",
      "kind": "model",
      "ledgerLine": "placeholders",
      "lod": {
        "distances": [
          0,
          4955
        ],
        "hysteresis": 0.1,
        "source": "authored",
        "tris": [
          1234,
          368
        ]
      },
      "materialSlots": [
        "hull",
        "emissive"
      ],
      "path": "/assets/placeholder/reach.station_hub.6c100df0.glb",
      "placeholder": true,
      "provenance": {
        "aiGenerated": true,
        "humanContribution": "none",
        "license": "LicenseRef-Eclipse-Owned",
        "source": "greybox",
        "tool": "Blender 5.2.0 LTS + tools/blender/reach_placeholders.py"
      },
      "sha256": "6c100df080a00df129c3e95ac34193acac8ebe43bc7401b8b68eb06f26a3bc83",
      "sockets": [
        {
          "kind": "DOCK",
          "name": "DOCK_BAY_0",
          "params": {
            "bayD": 80,
            "bayH": 30,
            "bayW": 50,
            "size": "M"
          },
          "position": [
            -111,
            -362.000061,
            -971.599976
          ],
          "quaternion": [
            0,
            0,
            0,
            1
          ]
        },
        {
          "kind": "LIGHT",
          "name": "LIGHT_BAY_0",
          "params": {
            "blinkHz": 0,
            "color": "#CFE6FF",
            "phase": 0,
            "type": "work"
          },
          "position": [
            -139,
            -339.000092,
            -1012.099976
          ],
          "quaternion": [
            0,
            0,
            0,
            1
          ]
        },
        {
          "kind": "LIGHT",
          "name": "LIGHT_BAY_1",
          "params": {
            "blinkHz": 0,
            "color": "#CFE6FF",
            "phase": 0,
            "type": "work"
          },
          "position": [
            -83,
            -339.000092,
            -1012.099976
          ],
          "quaternion": [
            0,
            0,
            0,
            1
          ]
        },
        {
          "kind": "LIGHT",
          "name": "LIGHT_BEACON",
          "params": {
            "blinkHz": 0.333,
            "color": "#FF2A1F",
            "phase": 0,
            "type": "strobe"
          },
          "position": [
            0,
            912,
            88.399933
          ],
          "quaternion": [
            0,
            0.707107,
            -0.707107,
            0
          ]
        }
      ]
    },
    {
      "id": "reach.station_outpost",
      "class": "station",
      "budget": "station",
      "path": "/assets/placeholder/reach.station_outpost.bf54d164.glb",
      "bytes": 61008,
      "sha256": "bf54d16489887dc845636b9118bb0bc4d1057ff9e6fb7ac1d84461044ec56091",
      "ledgerLine": "placeholders",
      "placeholder": true,
      "provenance": {
        "aiGenerated": true,
        "humanContribution": "none",
        "license": "LicenseRef-Eclipse-Owned",
        "source": "greybox",
        "tool": "Blender 5.2.0 LTS + tools/blender/reach_placeholders.py"
      },
      "kind": "model",
      "materialSlots": [
        "hull",
        "emissive"
      ],
      "lod": {
        "distances": [
          0,
          2287
        ],
        "hysteresis": 0.1,
        "source": "authored",
        "tris": [
          808,
          276
        ]
      },
      "sockets": [
        {
          "kind": "DOCK",
          "name": "DOCK_BAY_0",
          "params": {
            "bayD": 80,
            "bayH": 30,
            "bayW": 50,
            "size": "M"
          },
          "position": [
            -47,
            -37.000011,
            -149
          ],
          "quaternion": [
            0,
            0,
            0,
            1
          ]
        },
        {
          "kind": "LIGHT",
          "name": "LIGHT_BAY_0",
          "params": {
            "blinkHz": 0,
            "color": "#FFC36B",
            "phase": 0,
            "type": "work"
          },
          "position": [
            -75,
            -14.000014,
            -189.5
          ],
          "quaternion": [
            0,
            0,
            0,
            1
          ]
        },
        {
          "kind": "LIGHT",
          "name": "LIGHT_BAY_1",
          "params": {
            "blinkHz": 0,
            "color": "#FFC36B",
            "phase": 0,
            "type": "work"
          },
          "position": [
            -19,
            -14.000014,
            -189.5
          ],
          "quaternion": [
            0,
            0,
            0,
            1
          ]
        },
        {
          "kind": "LIGHT",
          "name": "LIGHT_BEACON",
          "params": {
            "blinkHz": 0.25,
            "color": "#FFC36B",
            "phase": 0,
            "type": "strobe"
          },
          "position": [
            0,
            200,
            55.999985
          ],
          "quaternion": [
            0,
            0.707107,
            -0.707107,
            0
          ]
        }
      ],
      "collider": {
        "kind": "trimesh",
        "nodes": [
          "COL_BAY",
          "COL_HULL"
        ],
        "triangles": 452
      },
      "bounds": {
        "center": [
          0.120575,
          -0.22905,
          -0.615524
        ],
        "max": [
          150.120575,
          200,
          188.768951
        ],
        "min": [
          -149.879425,
          -200.458099,
          -190
        ],
        "radius": 234.24131
      }
    },
    {
      "id": "reach.station_patrol",
      "class": "station",
      "budget": "station",
      "path": "/assets/placeholder/reach.station_patrol.ada2b3ee.glb",
      "bytes": 61604,
      "sha256": "ada2b3ee6abaee596811f886325f8f9da6013677e95750bf16dd08a582965ee5",
      "ledgerLine": "placeholders",
      "placeholder": true,
      "provenance": {
        "aiGenerated": true,
        "humanContribution": "none",
        "license": "LicenseRef-Eclipse-Owned",
        "source": "greybox",
        "tool": "Blender 5.2.0 LTS + tools/blender/reach_placeholders.py"
      },
      "kind": "model",
      "materialSlots": [
        "hull",
        "emissive"
      ],
      "lod": {
        "distances": [
          0,
          2705
        ],
        "hysteresis": 0.1,
        "source": "authored",
        "tris": [
          920,
          364
        ]
      },
      "sockets": [
        {
          "kind": "DOCK",
          "name": "DOCK_BAY_0",
          "params": {
            "bayD": 80,
            "bayH": 30,
            "bayW": 50,
            "size": "M"
          },
          "position": [
            -37,
            -173.000015,
            -259
          ],
          "quaternion": [
            0,
            0,
            0,
            1
          ]
        },
        {
          "kind": "LIGHT",
          "name": "LIGHT_BAY_0",
          "params": {
            "blinkHz": 0,
            "color": "#CFE6FF",
            "phase": 0,
            "type": "work"
          },
          "position": [
            -65,
            -150.000015,
            -299.5
          ],
          "quaternion": [
            0,
            0,
            0,
            1
          ]
        },
        {
          "kind": "LIGHT",
          "name": "LIGHT_BAY_1",
          "params": {
            "blinkHz": 0,
            "color": "#CFE6FF",
            "phase": 0,
            "type": "work"
          },
          "position": [
            -9,
            -150.000015,
            -299.5
          ],
          "quaternion": [
            0,
            0,
            0,
            1
          ]
        },
        {
          "kind": "LIGHT",
          "name": "LIGHT_STROBE",
          "params": {
            "blinkHz": 1,
            "color": "#FFFFFF",
            "phase": 0,
            "type": "strobe"
          },
          "position": [
            0,
            273,
            58.999981
          ],
          "quaternion": [
            0,
            0.707107,
            -0.707107,
            0
          ]
        }
      ],
      "collider": {
        "kind": "trimesh",
        "nodes": [
          "COL_BAY",
          "COL_HULL"
        ],
        "triangles": 436
      },
      "bounds": {
        "center": [
          0,
          0,
          0.205963
        ],
        "max": [
          286.411896,
          273,
          300.411926
        ],
        "min": [
          -286.411896,
          -273,
          -300
        ],
        "radius": 460.08981
      }
    },
    {
      "bounds": {
        "center": [
          0,
          -0.000031,
          0.000031
        ],
        "max": [
          420,
          600,
          635
        ],
        "min": [
          -420,
          -600.000061,
          -634.999939
        ],
        "radius": 916.092241
      },
      "budget": "station",
      "bytes": 78048,
      "class": "station",
      "collider": {
        "kind": "trimesh",
        "nodes": [
          "COL_BAY",
          "COL_HULL"
        ],
        "triangles": 600
      },
      "id": "reach.station_refinery",
      "kind": "model",
      "ledgerLine": "placeholders",
      "lod": {
        "distances": [
          0,
          3665
        ],
        "hysteresis": 0.1,
        "source": "authored",
        "tris": [
          1136,
          516
        ]
      },
      "materialSlots": [
        "hull",
        "emissive"
      ],
      "path": "/assets/placeholder/reach.station_refinery.9b01de66.glb",
      "placeholder": true,
      "provenance": {
        "aiGenerated": true,
        "humanContribution": "none",
        "license": "LicenseRef-Eclipse-Owned",
        "source": "greybox",
        "tool": "Blender 5.2.0 LTS + tools/blender/reach_placeholders.py"
      },
      "sha256": "9b01de66913767337aa6e702b28c1f94360856e6e1da4d88c1e36593dc16463b",
      "sockets": [
        {
          "kind": "DOCK",
          "name": "DOCK_BAY_0",
          "params": {
            "bayD": 80,
            "bayH": 30,
            "bayW": 50,
            "size": "M"
          },
          "position": [
            -74,
            -520.000061,
            -474.999969
          ],
          "quaternion": [
            0,
            0,
            0,
            1
          ]
        },
        {
          "kind": "LIGHT",
          "name": "LIGHT_BAY_0",
          "params": {
            "blinkHz": 0,
            "color": "#FFB347",
            "phase": 0,
            "type": "work"
          },
          "position": [
            -102,
            -497.000031,
            -515.499939
          ],
          "quaternion": [
            0,
            0,
            0,
            1
          ]
        },
        {
          "kind": "LIGHT",
          "name": "LIGHT_BAY_1",
          "params": {
            "blinkHz": 0,
            "color": "#FFB347",
            "phase": 0,
            "type": "work"
          },
          "position": [
            -46,
            -497.000031,
            -515.499939
          ],
          "quaternion": [
            0,
            0,
            0,
            1
          ]
        },
        {
          "kind": "LIGHT",
          "name": "LIGHT_BEACON",
          "params": {
            "blinkHz": 0.333,
            "color": "#FF2A1F",
            "phase": 0,
            "type": "strobe"
          },
          "position": [
            0,
            600,
            184.999954
          ],
          "quaternion": [
            0,
            0.707107,
            -0.707107,
            0
          ]
        }
      ]
    },
    {
      "bounds": {
        "center": [
          0,
          -0.040009,
          0.000031
        ],
        "max": [
          507.938873,
          579.820007,
          252.000031
        ],
        "min": [
          -507.938873,
          -579.900024,
          -251.999969
        ],
        "radius": 673.284465
      },
      "budget": "station",
      "bytes": 62556,
      "class": "station",
      "collider": {
        "kind": "trimesh",
        "nodes": [
          "COL_BAY",
          "COL_HULL"
        ],
        "triangles": 500
      },
      "id": "reach.station_scrapyard",
      "kind": "model",
      "ledgerLine": "placeholders",
      "lod": {
        "distances": [
          0,
          3099
        ],
        "hysteresis": 0.1,
        "source": "authored",
        "tris": [
          828,
          416
        ]
      },
      "materialSlots": [
        "hull",
        "emissive"
      ],
      "path": "/assets/placeholder/reach.station_scrapyard.567a9516.glb",
      "placeholder": true,
      "provenance": {
        "aiGenerated": true,
        "humanContribution": "none",
        "license": "LicenseRef-Eclipse-Owned",
        "source": "greybox",
        "tool": "Blender 5.2.0 LTS + tools/blender/reach_placeholders.py"
      },
      "sha256": "567a95168c9ec4fb528a84cb084053889e8baa91dfa9479cc67438100626ec6e",
      "sockets": [
        {
          "kind": "DOCK",
          "name": "DOCK_BAY_0",
          "params": {
            "bayD": 80,
            "bayH": 30,
            "bayW": 50,
            "size": "M"
          },
          "position": [
            -37,
            -479.900024,
            -209.999969
          ],
          "quaternion": [
            0,
            0,
            0,
            1
          ]
        },
        {
          "kind": "LIGHT",
          "name": "LIGHT_BAY_0",
          "params": {
            "blinkHz": 0,
            "color": "#FFC36B",
            "phase": 0,
            "type": "work"
          },
          "position": [
            -65,
            -456.900024,
            -250.499969
          ],
          "quaternion": [
            0,
            0,
            0,
            1
          ]
        },
        {
          "kind": "LIGHT",
          "name": "LIGHT_BAY_1",
          "params": {
            "blinkHz": 0,
            "color": "#FFC36B",
            "phase": 0,
            "type": "work"
          },
          "position": [
            -9,
            -456.900024,
            -250.499969
          ],
          "quaternion": [
            0,
            0,
            0,
            1
          ]
        },
        {
          "kind": "LIGHT",
          "name": "LIGHT_WORK_0",
          "params": {
            "blinkHz": 0,
            "color": "#FFB347",
            "phase": 0,
            "type": "work"
          },
          "position": [
            -69.254425,
            320.820007,
            129.999969
          ],
          "quaternion": [
            -0.707107,
            0,
            0,
            0.707107
          ]
        }
      ]
    },
    {
      "bounds": {
        "center": [
          0,
          0,
          0.000031
        ],
        "max": [
          704,
          907,
          828.000061
        ],
        "min": [
          -704,
          -907,
          -828
        ],
        "radius": 1053.876761
      },
      "budget": "station",
      "bytes": 85292,
      "class": "station",
      "collider": {
        "kind": "trimesh",
        "nodes": [
          "COL_BAY",
          "COL_HULL"
        ],
        "triangles": 692
      },
      "id": "reach.station_trade",
      "kind": "model",
      "ledgerLine": "placeholders",
      "lod": {
        "distances": [
          0,
          4216
        ],
        "hysteresis": 0.1,
        "source": "authored",
        "tris": [
          1428,
          476
        ]
      },
      "materialSlots": [
        "hull",
        "emissive"
      ],
      "path": "/assets/placeholder/reach.station_trade.0e0ab6e4.glb",
      "placeholder": true,
      "provenance": {
        "aiGenerated": true,
        "humanContribution": "none",
        "license": "LicenseRef-Eclipse-Owned",
        "source": "greybox",
        "tool": "Blender 5.2.0 LTS + tools/blender/reach_placeholders.py"
      },
      "sha256": "0e0ab6e429a6584cffc464bdb1e20d29de04c4bd348601be1434609a658506e0",
      "sockets": [
        {
          "kind": "DOCK",
          "name": "DOCK_BAY_0",
          "params": {
            "bayD": 80,
            "bayH": 30,
            "bayW": 50,
            "size": "M"
          },
          "position": [
            -111,
            -487.000061,
            -785.999939
          ],
          "quaternion": [
            0,
            0,
            0,
            1
          ]
        },
        {
          "kind": "LIGHT",
          "name": "LIGHT_BAY_0",
          "params": {
            "blinkHz": 0,
            "color": "#7FE3D2",
            "phase": 0,
            "type": "work"
          },
          "position": [
            -139,
            -464.000061,
            -826.499939
          ],
          "quaternion": [
            0,
            0,
            0,
            1
          ]
        },
        {
          "kind": "LIGHT",
          "name": "LIGHT_BAY_1",
          "params": {
            "blinkHz": 0,
            "color": "#7FE3D2",
            "phase": 0,
            "type": "work"
          },
          "position": [
            -83,
            -464.000061,
            -826.499939
          ],
          "quaternion": [
            0,
            0,
            0,
            1
          ]
        },
        {
          "kind": "LIGHT",
          "name": "LIGHT_BEACON",
          "params": {
            "blinkHz": 0.333,
            "color": "#FF2A1F",
            "phase": 0,
            "type": "strobe"
          },
          "position": [
            0,
            907,
            123.999931
          ],
          "quaternion": [
            0,
            0.707107,
            -0.707107,
            0
          ]
        }
      ]
    },
    {
      "id": "ship.corvette",
      "class": "ship",
      "budget": "ship_medium",
      "path": "/assets/placeholder/ship.corvette.f6504dd0.glb",
      "bytes": 137300,
      "sha256": "f6504dd07761b03a9ef12ed98e723580e6fc9c523e7ccf0b6b6d6e0160a2df7c",
      "ledgerLine": "streamed.ships",
      "placeholder": true,
      "provenance": {
        "source": "greybox",
        "tool": "Blender 5.2.0 LTS + tools/blender/greybox_fleet.py",
        "humanContribution": "none",
        "license": "LicenseRef-Eclipse-Owned",
        "aiGenerated": true
      },
      "kind": "model",
      "materialSlots": [
        "hull",
        "glass",
        "emissive"
      ],
      "lod": {
        "source": "authored",
        "distances": [
          0,
          90,
          350,
          1200
        ],
        "hysteresis": 0.1,
        "tris": [
          1096,
          536,
          496,
          320
        ]
      },
      "sockets": [
        {
          "name": "ENG_MAIN_L",
          "kind": "ENG",
          "position": [
            -2.6,
            1.200001,
            18.1
          ],
          "quaternion": [
            0,
            -1,
            0,
            0
          ],
          "params": {
            "radius": 1.1
          }
        },
        {
          "name": "ENG_MAIN_L2",
          "kind": "ENG",
          "position": [
            -2.6,
            -1.199999,
            18.1
          ],
          "quaternion": [
            0,
            -1,
            0,
            0
          ],
          "params": {
            "radius": 1.1
          }
        },
        {
          "name": "ENG_MAIN_R",
          "kind": "ENG",
          "position": [
            2.6,
            1.200001,
            18.1
          ],
          "quaternion": [
            0,
            -1,
            0,
            0
          ],
          "params": {
            "radius": 1.1
          }
        },
        {
          "name": "ENG_MAIN_R2",
          "kind": "ENG",
          "position": [
            2.6,
            -1.199999,
            18.1
          ],
          "quaternion": [
            0,
            -1,
            0,
            0
          ],
          "params": {
            "radius": 1.1
          }
        },
        {
          "name": "ENG_RETRO_L",
          "kind": "ENG",
          "position": [
            -6,
            0,
            -2
          ],
          "quaternion": [
            0,
            0,
            0,
            1
          ],
          "params": {
            "radius": 0.5
          }
        },
        {
          "name": "ENG_RETRO_R",
          "kind": "ENG",
          "position": [
            6,
            0,
            -2
          ],
          "quaternion": [
            0,
            0,
            0,
            1
          ],
          "params": {
            "radius": 0.5
          }
        },
        {
          "name": "EYE_PILOT",
          "kind": "EYE",
          "position": [
            0,
            4.2,
            -3
          ],
          "quaternion": [
            0,
            0,
            0,
            1
          ],
          "params": {}
        },
        {
          "name": "HP_LASER_L",
          "kind": "HP",
          "position": [
            -7.55,
            -0.800001,
            -12
          ],
          "quaternion": [
            0,
            0,
            0,
            1
          ],
          "params": {
            "size": "S"
          }
        },
        {
          "name": "HP_LASER_R",
          "kind": "HP",
          "position": [
            7.55,
            -0.800001,
            -12
          ],
          "quaternion": [
            0,
            0,
            0,
            1
          ],
          "params": {
            "size": "S"
          }
        },
        {
          "name": "HP_PDC_L",
          "kind": "HP",
          "position": [
            -7.55,
            0.599999,
            -13
          ],
          "quaternion": [
            0,
            0,
            0,
            1
          ],
          "params": {
            "size": "S"
          }
        },
        {
          "name": "HP_PDC_R",
          "kind": "HP",
          "position": [
            7.55,
            0.599999,
            -13
          ],
          "quaternion": [
            0,
            0,
            0,
            1
          ],
          "params": {
            "size": "S"
          }
        },
        {
          "name": "HP_TURRET_A",
          "kind": "HP",
          "position": [
            0,
            3.600001,
            10
          ],
          "quaternion": [
            0,
            0,
            0,
            1
          ],
          "params": {
            "size": "M"
          }
        },
        {
          "name": "HP_TURRET_F",
          "kind": "HP",
          "position": [
            0,
            3.6,
            0
          ],
          "quaternion": [
            0,
            0,
            0,
            1
          ],
          "params": {
            "size": "M"
          }
        },
        {
          "name": "LIGHT_NAV_PORT",
          "kind": "LIGHT",
          "position": [
            -8.6,
            0,
            0
          ],
          "quaternion": [
            0,
            0.707107,
            0,
            0.707107
          ],
          "params": {
            "blinkHz": 0,
            "color": "#FF2A1F",
            "phase": 0,
            "type": "nav"
          }
        },
        {
          "name": "LIGHT_NAV_STBD",
          "kind": "LIGHT",
          "position": [
            8.6,
            0,
            0
          ],
          "quaternion": [
            0,
            -0.707107,
            0,
            0.707107
          ],
          "params": {
            "blinkHz": 0,
            "color": "#2BFF6A",
            "phase": 0,
            "type": "nav"
          }
        },
        {
          "name": "LIGHT_STROBE",
          "kind": "LIGHT",
          "position": [
            0,
            9.2,
            1.999999
          ],
          "quaternion": [
            0,
            0.707107,
            -0.707107,
            0
          ],
          "params": {
            "blinkHz": 1,
            "color": "#FFFFFF",
            "phase": 0,
            "type": "strobe"
          }
        }
      ],
      "collider": {
        "kind": "convexHulls",
        "nodes": [
          "COL_AFT",
          "COL_BRIDGE",
          "COL_FWD",
          "COL_KEEL",
          "COL_MAIN",
          "COL_MAST",
          "COL_PROW",
          "COL_SPONSON_L",
          "COL_SPONSON_R"
        ],
        "hullVerts": [
          8,
          8,
          8,
          8,
          8,
          8,
          8,
          8,
          8
        ]
      },
      "bounds": {
        "min": [
          -8.6,
          -3.600001,
          -20
        ],
        "max": [
          8.6,
          9.2,
          18.099998
        ],
        "center": [
          0,
          2.799999,
          -0.950001
        ],
        "radius": 19.933739
      }
    },
    {
      "id": "ship.cutter",
      "class": "ship",
      "budget": "ship_medium",
      "path": "/assets/placeholder/ship.cutter.d9b634c0.glb",
      "bytes": 112712,
      "sha256": "d9b634c067304081f01b6b8acc66f380da3856d0aa719aed3e840480374977f5",
      "ledgerLine": "streamed.ships",
      "placeholder": true,
      "provenance": {
        "source": "greybox",
        "tool": "Blender 5.2.0 LTS + tools/blender/greybox_charter.py",
        "humanContribution": "none",
        "license": "LicenseRef-Eclipse-Owned",
        "aiGenerated": true
      },
      "kind": "model",
      "materialSlots": [
        "hull",
        "glass",
        "emissive"
      ],
      "lod": {
        "source": "authored",
        "distances": [
          0,
          90,
          350,
          1200
        ],
        "hysteresis": 0.1,
        "tris": [
          1028,
          308,
          244,
          176
        ]
      },
      "sockets": [
        {
          "name": "ENG_MAIN_L",
          "kind": "ENG",
          "position": [
            -2.4,
            0,
            13.6
          ],
          "quaternion": [
            0,
            -1,
            0,
            0
          ],
          "params": {
            "radius": 1.1
          }
        },
        {
          "name": "ENG_MAIN_R",
          "kind": "ENG",
          "position": [
            2.4,
            0,
            13.6
          ],
          "quaternion": [
            0,
            -1,
            0,
            0
          ],
          "params": {
            "radius": 1.1
          }
        },
        {
          "name": "EYE_PILOT",
          "kind": "EYE",
          "position": [
            0,
            2.2,
            -5.8
          ],
          "quaternion": [
            0,
            0,
            0,
            1
          ],
          "params": {}
        },
        {
          "name": "HP_TURRET_L",
          "kind": "HP",
          "position": [
            -5.3,
            1,
            -3.7
          ],
          "quaternion": [
            0,
            0,
            0,
            1
          ],
          "params": {
            "size": "M"
          }
        },
        {
          "name": "HP_TURRET_R",
          "kind": "HP",
          "position": [
            5.3,
            1,
            -3.7
          ],
          "quaternion": [
            0,
            0,
            0,
            1
          ],
          "params": {
            "size": "M"
          }
        },
        {
          "name": "LIGHT_NAV_PORT",
          "kind": "LIGHT",
          "position": [
            -12.2,
            0,
            10.5
          ],
          "quaternion": [
            0,
            0.707107,
            0,
            0.707107
          ],
          "params": {
            "blinkHz": 0,
            "color": "#FF2A1F",
            "phase": 0,
            "type": "nav"
          }
        },
        {
          "name": "LIGHT_NAV_STBD",
          "kind": "LIGHT",
          "position": [
            12.2,
            0,
            10.5
          ],
          "quaternion": [
            0,
            -0.707107,
            0,
            0.707107
          ],
          "params": {
            "blinkHz": 0,
            "color": "#2BFF6A",
            "phase": 0,
            "type": "nav"
          }
        },
        {
          "name": "LIGHT_SENSOR_MAST",
          "kind": "LIGHT",
          "position": [
            0,
            10.6,
            2.999999
          ],
          "quaternion": [
            0,
            0,
            0,
            1
          ],
          "params": {
            "blinkHz": 0.5,
            "color": "#CFE6FF",
            "phase": 0,
            "type": "sensor"
          }
        },
        {
          "name": "LIGHT_STROBE",
          "kind": "LIGHT",
          "position": [
            0,
            2.200001,
            10.5
          ],
          "quaternion": [
            0,
            0.707107,
            -0.707107,
            0
          ],
          "params": {
            "blinkHz": 1,
            "color": "#FFFFFF",
            "phase": 0,
            "type": "strobe"
          }
        }
      ],
      "collider": {
        "kind": "convexHulls",
        "nodes": [
          "COL_AFT",
          "COL_FWD",
          "COL_MAST",
          "COL_MID",
          "COL_NOSE",
          "COL_SPONSON_L",
          "COL_SPONSON_R",
          "COL_WING_L",
          "COL_WING_R"
        ],
        "hullVerts": [
          8,
          8,
          8,
          8,
          8,
          8,
          8,
          8,
          8
        ]
      },
      "bounds": {
        "min": [
          -12.200001,
          -2.600001,
          -14
        ],
        "max": [
          12.200001,
          10.6,
          13.6
        ],
        "center": [
          0,
          4,
          -0.2
        ],
        "radius": 17.809127
      }
    },
    {
      "id": "ship.gunship",
      "class": "ship",
      "budget": "ship_medium",
      "path": "/assets/ship/ship.gunship.3656d683.glb",
      "bytes": 760316,
      "sha256": "3656d683a92895e8bc79c772c6c220108bb7d8c95bbc1fc9c961b399bf0dfc93",
      "ledgerLine": "streamed.ships",
      "placeholder": false,
      "provenance": {
        "source": "procedural-ts",
        "tool": "Node 24.15.0 + tools/assetkit + assets-src/ship.gunship/build.ts @ sha256:54b48992162b",
        "humanContribution": "none",
        "license": "LicenseRef-Eclipse-Owned",
        "aiGenerated": true,
        "manifestRef": "ship.gunship"
      },
      "kind": "model",
      "materialSlots": [
        "hull",
        "glass",
        "emissive",
        "decal"
      ],
      "lod": {
        "source": "authored",
        "distances": [
          0,
          90,
          350,
          1200
        ],
        "hysteresis": 0.1,
        "tris": [
          35836,
          9812,
          2080,
          600
        ]
      },
      "sockets": [
        {
          "name": "ENG_MAIN_L",
          "kind": "ENG",
          "position": [
            -1.9,
            0.700001,
            10
          ],
          "quaternion": [
            0,
            1,
            0,
            0
          ],
          "params": {
            "radius": 0.65
          }
        },
        {
          "name": "ENG_MAIN_L2",
          "kind": "ENG",
          "position": [
            -1.9,
            -1.199999,
            10
          ],
          "quaternion": [
            0,
            1,
            0,
            0
          ],
          "params": {
            "radius": 0.65
          }
        },
        {
          "name": "ENG_MAIN_R",
          "kind": "ENG",
          "position": [
            1.9,
            0.700001,
            10
          ],
          "quaternion": [
            0,
            1,
            0,
            0
          ],
          "params": {
            "radius": 0.65
          }
        },
        {
          "name": "ENG_MAIN_R2",
          "kind": "ENG",
          "position": [
            1.9,
            -1.199999,
            10
          ],
          "quaternion": [
            0,
            1,
            0,
            0
          ],
          "params": {
            "radius": 0.65
          }
        },
        {
          "name": "ENG_RCS_AL",
          "kind": "ENG",
          "position": [
            -4.6,
            0,
            6
          ],
          "quaternion": [
            0,
            0.707107,
            0,
            0.707107
          ],
          "params": {
            "radius": 0.15
          }
        },
        {
          "name": "ENG_RCS_AR",
          "kind": "ENG",
          "position": [
            4.6,
            0,
            6
          ],
          "quaternion": [
            0,
            -0.707107,
            0,
            0.707107
          ],
          "params": {
            "radius": 0.15
          }
        },
        {
          "name": "ENG_RCS_FL",
          "kind": "ENG",
          "position": [
            -4.8,
            0,
            -5
          ],
          "quaternion": [
            0,
            0.707107,
            0,
            0.707107
          ],
          "params": {
            "radius": 0.15
          }
        },
        {
          "name": "ENG_RCS_FR",
          "kind": "ENG",
          "position": [
            4.8,
            0,
            -5
          ],
          "quaternion": [
            0,
            -0.707107,
            0,
            0.707107
          ],
          "params": {
            "radius": 0.15
          }
        },
        {
          "name": "EYE_PILOT",
          "kind": "EYE",
          "position": [
            0,
            2.549999,
            -4.8
          ],
          "quaternion": [
            0,
            0,
            0,
            1
          ],
          "params": {}
        },
        {
          "name": "HP_TURRET_L",
          "kind": "HP",
          "position": [
            -5.3,
            -0.5,
            -6.6
          ],
          "quaternion": [
            0,
            0,
            0,
            1
          ],
          "params": {
            "size": "M"
          }
        },
        {
          "name": "HP_TURRET_R",
          "kind": "HP",
          "position": [
            5.3,
            -0.5,
            -6.6
          ],
          "quaternion": [
            0,
            0,
            0,
            1
          ],
          "params": {
            "size": "M"
          }
        },
        {
          "name": "LIGHT_SENSOR_EYE_L",
          "kind": "LIGHT",
          "position": [
            -1.55,
            2.099999,
            -5.85
          ],
          "quaternion": [
            0,
            0,
            0,
            1
          ],
          "params": {
            "blinkHz": 0,
            "color": "#FF2F24",
            "phase": 0,
            "type": "sensor"
          }
        },
        {
          "name": "LIGHT_SENSOR_EYE_R",
          "kind": "LIGHT",
          "position": [
            1.55,
            2.099999,
            -5.85
          ],
          "quaternion": [
            0,
            0,
            0,
            1
          ],
          "params": {
            "blinkHz": 0,
            "color": "#FF2F24",
            "phase": 0,
            "type": "sensor"
          }
        },
        {
          "name": "LIGHT_SENSOR_MAST",
          "kind": "LIGHT",
          "position": [
            0,
            4.13,
            0.46
          ],
          "quaternion": [
            0,
            0,
            0,
            1
          ],
          "params": {
            "blinkHz": 0.5,
            "color": "#FF2F24",
            "phase": 0,
            "type": "sensor"
          }
        }
      ],
      "collider": {
        "kind": "convexHulls",
        "nodes": [
          "COL_BRIDGE_00",
          "COL_ENGINE_01",
          "COL_HULL_02",
          "COL_PROW_03",
          "COL_SKIRT_L_04",
          "COL_SKIRT_R_05",
          "COL_SPONSON_L_06",
          "COL_SPONSON_R_07",
          "COL_TANKS_08"
        ],
        "hullVerts": [
          48,
          32,
          48,
          48,
          46,
          48,
          30,
          30,
          48
        ]
      },
      "bounds": {
        "min": [
          -6.4015,
          -2.8,
          -10.15
        ],
        "max": [
          6.401462,
          4.350394,
          10.030001
        ],
        "center": [
          -0.000019,
          0.775197,
          -0.059999
        ],
        "radius": 10.866683
      }
    },
    {
      "id": "ship.hauler",
      "class": "ship",
      "budget": "ship_medium",
      "path": "/assets/placeholder/ship.hauler.9c7add23.glb",
      "bytes": 108044,
      "sha256": "9c7add2314d41b3ada2a824e34773bd14052b6cb9819ae515ea88673510bf6e9",
      "ledgerLine": "streamed.ships",
      "placeholder": true,
      "provenance": {
        "source": "greybox",
        "tool": "Blender 5.2.0 LTS + tools/blender/greybox_economy.py",
        "humanContribution": "none",
        "license": "LicenseRef-Eclipse-Owned",
        "aiGenerated": true
      },
      "kind": "model",
      "materialSlots": [
        "hull",
        "glass",
        "emissive"
      ],
      "lod": {
        "source": "authored",
        "distances": [
          0,
          90,
          350,
          1200
        ],
        "hysteresis": 0.1,
        "tris": [
          860,
          444,
          396,
          228
        ]
      },
      "sockets": [
        {
          "name": "ENG_MAIN_L",
          "kind": "ENG",
          "position": [
            -2,
            1.500002,
            22.5
          ],
          "quaternion": [
            0,
            -1,
            0,
            0
          ],
          "params": {
            "radius": 1
          }
        },
        {
          "name": "ENG_MAIN_L2",
          "kind": "ENG",
          "position": [
            -2,
            -1.499998,
            22.5
          ],
          "quaternion": [
            0,
            -1,
            0,
            0
          ],
          "params": {
            "radius": 1
          }
        },
        {
          "name": "ENG_MAIN_R",
          "kind": "ENG",
          "position": [
            2,
            1.500002,
            22.5
          ],
          "quaternion": [
            0,
            -1,
            0,
            0
          ],
          "params": {
            "radius": 1
          }
        },
        {
          "name": "ENG_MAIN_R2",
          "kind": "ENG",
          "position": [
            2,
            -1.499998,
            22.5
          ],
          "quaternion": [
            0,
            -1,
            0,
            0
          ],
          "params": {
            "radius": 1
          }
        },
        {
          "name": "ENG_RETRO_L",
          "kind": "ENG",
          "position": [
            -3,
            0,
            -15.5
          ],
          "quaternion": [
            0,
            0,
            0,
            1
          ],
          "params": {
            "radius": 0.4
          }
        },
        {
          "name": "ENG_RETRO_R",
          "kind": "ENG",
          "position": [
            3,
            0,
            -15.5
          ],
          "quaternion": [
            0,
            0,
            0,
            1
          ],
          "params": {
            "radius": 0.4
          }
        },
        {
          "name": "EYE_PILOT",
          "kind": "EYE",
          "position": [
            0,
            0.999998,
            -20.5
          ],
          "quaternion": [
            0,
            0,
            0,
            1
          ],
          "params": {}
        },
        {
          "name": "HP_TURRET_T",
          "kind": "HP",
          "position": [
            0,
            3.399999,
            -14
          ],
          "quaternion": [
            0,
            0,
            0,
            1
          ],
          "params": {
            "size": "M"
          }
        },
        {
          "name": "LIGHT_NAV_PORT",
          "kind": "LIGHT",
          "position": [
            -4.6,
            0,
            2.5
          ],
          "quaternion": [
            0,
            0.707107,
            0,
            0.707107
          ],
          "params": {
            "blinkHz": 0,
            "color": "#FF2A1F",
            "phase": 0,
            "type": "nav"
          }
        },
        {
          "name": "LIGHT_NAV_STBD",
          "kind": "LIGHT",
          "position": [
            4.6,
            0,
            2.5
          ],
          "quaternion": [
            0,
            -0.707107,
            0,
            0.707107
          ],
          "params": {
            "blinkHz": 0,
            "color": "#2BFF6A",
            "phase": 0,
            "type": "nav"
          }
        },
        {
          "name": "LIGHT_STROBE",
          "kind": "LIGHT",
          "position": [
            0,
            3.000001,
            17
          ],
          "quaternion": [
            0,
            0.707107,
            -0.707107,
            0
          ],
          "params": {
            "blinkHz": 1,
            "color": "#FFFFFF",
            "phase": 0,
            "type": "strobe"
          }
        }
      ],
      "collider": {
        "kind": "convexHulls",
        "nodes": [
          "COL_CAB",
          "COL_ENGINE",
          "COL_POD_0",
          "COL_POD_1",
          "COL_POD_2",
          "COL_SPINE"
        ],
        "hullVerts": [
          8,
          8,
          8,
          8,
          8,
          8
        ]
      },
      "bounds": {
        "min": [
          -4.55,
          -4.000001,
          -22.099998
        ],
        "max": [
          4.55,
          3.399999,
          22.5
        ],
        "center": [
          0,
          -0.300001,
          0.200001
        ],
        "radius": 22.592762
      }
    },
    {
      "id": "ship.hauler_large",
      "class": "ship",
      "budget": "ship_medium",
      "path": "/assets/placeholder/ship.hauler_large.e67b6a97.glb",
      "bytes": 156944,
      "sha256": "e67b6a973821fcbfbd5a232161da7bafa7938109a44cac417b964e361ec0f168",
      "ledgerLine": "streamed.ships",
      "placeholder": true,
      "provenance": {
        "source": "greybox",
        "tool": "Blender 5.2.0 LTS + tools/blender/greybox_fleet.py",
        "humanContribution": "none",
        "license": "LicenseRef-Eclipse-Owned",
        "aiGenerated": true
      },
      "kind": "model",
      "materialSlots": [
        "hull",
        "glass",
        "emissive"
      ],
      "lod": {
        "source": "authored",
        "distances": [
          0,
          90,
          350,
          1200
        ],
        "hysteresis": 0.1,
        "tris": [
          1312,
          672,
          588,
          348
        ]
      },
      "sockets": [
        {
          "name": "ENG_MAIN_C",
          "kind": "ENG",
          "position": [
            0,
            2.200002,
            20.6
          ],
          "quaternion": [
            0,
            -1,
            0,
            0
          ],
          "params": {
            "radius": 1.4
          }
        },
        {
          "name": "ENG_MAIN_C2",
          "kind": "ENG",
          "position": [
            0,
            -2.199998,
            20.6
          ],
          "quaternion": [
            0,
            -1,
            0,
            0
          ],
          "params": {
            "radius": 1.4
          }
        },
        {
          "name": "ENG_MAIN_L",
          "kind": "ENG",
          "position": [
            -4,
            2.200002,
            20.6
          ],
          "quaternion": [
            0,
            -1,
            0,
            0
          ],
          "params": {
            "radius": 1.4
          }
        },
        {
          "name": "ENG_MAIN_L2",
          "kind": "ENG",
          "position": [
            -4,
            -2.199998,
            20.6
          ],
          "quaternion": [
            0,
            -1,
            0,
            0
          ],
          "params": {
            "radius": 1.4
          }
        },
        {
          "name": "ENG_MAIN_R",
          "kind": "ENG",
          "position": [
            4,
            2.200002,
            20.6
          ],
          "quaternion": [
            0,
            -1,
            0,
            0
          ],
          "params": {
            "radius": 1.4
          }
        },
        {
          "name": "ENG_MAIN_R2",
          "kind": "ENG",
          "position": [
            4,
            -2.199998,
            20.6
          ],
          "quaternion": [
            0,
            -1,
            0,
            0
          ],
          "params": {
            "radius": 1.4
          }
        },
        {
          "name": "ENG_RETRO_L",
          "kind": "ENG",
          "position": [
            -3.5,
            0,
            -15.5
          ],
          "quaternion": [
            0,
            0,
            0,
            1
          ],
          "params": {
            "radius": 0.5
          }
        },
        {
          "name": "ENG_RETRO_R",
          "kind": "ENG",
          "position": [
            3.5,
            0,
            -15.5
          ],
          "quaternion": [
            0,
            0,
            0,
            1
          ],
          "params": {
            "radius": 0.5
          }
        },
        {
          "name": "EYE_PILOT",
          "kind": "EYE",
          "position": [
            0,
            0.999998,
            -20.5
          ],
          "quaternion": [
            0,
            0,
            0,
            1
          ],
          "params": {}
        },
        {
          "name": "HP_TURRET_A",
          "kind": "HP",
          "position": [
            0,
            6.400002,
            16.5
          ],
          "quaternion": [
            0,
            0,
            0,
            1
          ],
          "params": {
            "size": "M"
          }
        },
        {
          "name": "HP_TURRET_T",
          "kind": "HP",
          "position": [
            0,
            3.999999,
            -14
          ],
          "quaternion": [
            0,
            0,
            0,
            1
          ],
          "params": {
            "size": "M"
          }
        },
        {
          "name": "LIGHT_NAV_PORT",
          "kind": "LIGHT",
          "position": [
            -7.7,
            0,
            2.5
          ],
          "quaternion": [
            0,
            0.707107,
            0,
            0.707107
          ],
          "params": {
            "blinkHz": 0,
            "color": "#FF2A1F",
            "phase": 0,
            "type": "nav"
          }
        },
        {
          "name": "LIGHT_NAV_STBD",
          "kind": "LIGHT",
          "position": [
            7.7,
            0,
            2.5
          ],
          "quaternion": [
            0,
            -0.707107,
            0,
            0.707107
          ],
          "params": {
            "blinkHz": 0,
            "color": "#2BFF6A",
            "phase": 0,
            "type": "nav"
          }
        },
        {
          "name": "LIGHT_STROBE",
          "kind": "LIGHT",
          "position": [
            0,
            5.6,
            2.5
          ],
          "quaternion": [
            0,
            0.707107,
            -0.707107,
            0
          ],
          "params": {
            "blinkHz": 1,
            "color": "#FFFFFF",
            "phase": 0,
            "type": "strobe"
          }
        }
      ],
      "collider": {
        "kind": "convexHulls",
        "nodes": [
          "COL_CAB",
          "COL_ENGINE",
          "COL_POD_L0",
          "COL_POD_L1",
          "COL_POD_L2",
          "COL_POD_R0",
          "COL_POD_R1",
          "COL_POD_R2",
          "COL_SPINE"
        ],
        "hullVerts": [
          8,
          8,
          8,
          8,
          8,
          8,
          8,
          8,
          8
        ]
      },
      "bounds": {
        "min": [
          -7.65,
          -5.600001,
          -22.099998
        ],
        "max": [
          7.65,
          6.400002,
          20.599998
        ],
        "center": [
          0,
          0.4,
          -0.75
        ],
        "radius": 22.213597
      }
    },
    {
      "id": "ship.hauler_large_block",
      "kind": "model",
      "class": "ship",
      "budget": "ship_large",
      "path": "/assets/placeholder/ship.hauler_large_block.90b08b7d.glb",
      "bytes": 233492,
      "sha256": "90b08b7d9edf96da47bf0bbd3d586cd6e2cf98c2693b420d25d947568053540f",
      "ledgerLine": "streamed.ships",
      "placeholder": true,
      "materialSlots": [
        "hull",
        "glass",
        "emissive"
      ],
      "lod": {
        "source": "authored",
        "distances": [
          0,
          270,
          1050,
          3600
        ],
        "hysteresis": 0.1,
        "tris": [
          2392,
          984,
          612,
          384
        ]
      },
      "sockets": [
        {
          "name": "DOCK_CRADLE",
          "kind": "DOCK",
          "position": [
            0,
            -2.5,
            0
          ],
          "quaternion": [
            0,
            -0.707107,
            0,
            0.707107
          ],
          "params": {
            "bayD": 30,
            "bayH": 15,
            "bayW": 30,
            "size": "S"
          }
        },
        {
          "name": "ENG_MAIN_C",
          "kind": "ENG",
          "position": [
            0,
            5.000007,
            95
          ],
          "quaternion": [
            0,
            -1,
            0,
            0
          ],
          "params": {
            "radius": 3
          }
        },
        {
          "name": "ENG_MAIN_C2",
          "kind": "ENG",
          "position": [
            0,
            -4.999993,
            95
          ],
          "quaternion": [
            0,
            -1,
            0,
            0
          ],
          "params": {
            "radius": 3
          }
        },
        {
          "name": "ENG_MAIN_L",
          "kind": "ENG",
          "position": [
            -7,
            5.000007,
            95
          ],
          "quaternion": [
            0,
            -1,
            0,
            0
          ],
          "params": {
            "radius": 3
          }
        },
        {
          "name": "ENG_MAIN_L2",
          "kind": "ENG",
          "position": [
            -7,
            -4.999993,
            95
          ],
          "quaternion": [
            0,
            -1,
            0,
            0
          ],
          "params": {
            "radius": 3
          }
        },
        {
          "name": "ENG_MAIN_R",
          "kind": "ENG",
          "position": [
            7,
            5.000007,
            95
          ],
          "quaternion": [
            0,
            -1,
            0,
            0
          ],
          "params": {
            "radius": 3
          }
        },
        {
          "name": "ENG_MAIN_R2",
          "kind": "ENG",
          "position": [
            7,
            -4.999993,
            95
          ],
          "quaternion": [
            0,
            -1,
            0,
            0
          ],
          "params": {
            "radius": 3
          }
        },
        {
          "name": "ENG_RETRO_L",
          "kind": "ENG",
          "position": [
            -6,
            -4.000007,
            -95
          ],
          "quaternion": [
            0,
            0,
            0,
            1
          ],
          "params": {
            "radius": 1
          }
        },
        {
          "name": "ENG_RETRO_R",
          "kind": "ENG",
          "position": [
            6,
            -4.000007,
            -95
          ],
          "quaternion": [
            0,
            0,
            0,
            1
          ],
          "params": {
            "radius": 1
          }
        },
        {
          "name": "EYE_PILOT",
          "kind": "EYE",
          "position": [
            0,
            7.999993,
            -94
          ],
          "quaternion": [
            0,
            0,
            0,
            1
          ],
          "params": {}
        },
        {
          "name": "HP_TURRET_A",
          "kind": "HP",
          "position": [
            0,
            15.000004,
            55
          ],
          "quaternion": [
            0,
            0,
            0,
            1
          ],
          "params": {
            "size": "M"
          }
        },
        {
          "name": "HP_TURRET_T",
          "kind": "HP",
          "position": [
            0,
            14.999995,
            -60
          ],
          "quaternion": [
            0,
            0,
            0,
            1
          ],
          "params": {
            "size": "M"
          }
        },
        {
          "name": "LIGHT_NAV_PORT",
          "kind": "LIGHT",
          "position": [
            -16.1,
            -0.000003,
            -46
          ],
          "quaternion": [
            0,
            0.707107,
            0,
            0.707107
          ],
          "params": {
            "blinkHz": 0,
            "color": "#FF2A1F",
            "phase": 0,
            "type": "nav"
          }
        },
        {
          "name": "LIGHT_NAV_STBD",
          "kind": "LIGHT",
          "position": [
            16.1,
            -0.000003,
            -46
          ],
          "quaternion": [
            0,
            -0.707107,
            0,
            0.707107
          ],
          "params": {
            "blinkHz": 0,
            "color": "#2BFF6A",
            "phase": 0,
            "type": "nav"
          }
        },
        {
          "name": "LIGHT_STROBE",
          "kind": "LIGHT",
          "position": [
            0,
            14.6,
            0
          ],
          "quaternion": [
            0,
            0.707107,
            -0.707107,
            0
          ],
          "params": {
            "blinkHz": 1,
            "color": "#FFFFFF",
            "phase": 0,
            "type": "strobe"
          }
        }
      ],
      "collider": {
        "kind": "convexHulls",
        "nodes": [
          "COL_BRIDGE",
          "COL_CORE_A",
          "COL_CORE_F",
          "COL_CRADLE_FLOOR",
          "COL_CRADLE_ROOF",
          "COL_CRADLE_WALL",
          "COL_ENGINE",
          "COL_POD_L0",
          "COL_POD_L1",
          "COL_POD_L2",
          "COL_POD_L3",
          "COL_POD_L4",
          "COL_POD_L5",
          "COL_POD_R0",
          "COL_POD_R1",
          "COL_POD_R2",
          "COL_POD_R3",
          "COL_POD_R4",
          "COL_POD_R5",
          "COL_SPINE"
        ],
        "hullVerts": [
          8,
          8,
          8,
          8,
          8,
          8,
          8,
          8,
          8,
          8,
          8,
          8,
          8,
          8,
          8,
          8,
          8,
          8,
          8,
          8
        ]
      },
      "bounds": {
        "min": [
          -16.049999,
          -13.000006,
          -95.100006
        ],
        "max": [
          16.049999,
          15.000005,
          95
        ],
        "center": [
          0,
          1,
          -0.050003
        ],
        "radius": 96.149581
      },
      "provenance": {
        "source": "greybox",
        "tool": "Blender 5.2.0 LTS + tools/blender/greybox_m10.py",
        "humanContribution": "none",
        "license": "LicenseRef-Eclipse-Owned",
        "aiGenerated": true
      }
    },
    {
      "id": "ship.holdfast_picket_block",
      "kind": "model",
      "class": "ship",
      "budget": "ship_light",
      "path": "/assets/placeholder/ship.holdfast_picket_block.0c6687c7.glb",
      "bytes": 124812,
      "sha256": "0c6687c765b06ed04f133835dbb57f8e612cb9314d3e975e353999c1b45be1bc",
      "ledgerLine": "streamed.ships",
      "placeholder": true,
      "materialSlots": [
        "hull",
        "glass",
        "emissive"
      ],
      "lod": {
        "source": "authored",
        "distances": [
          0,
          50,
          200,
          700
        ],
        "hysteresis": 0.1,
        "tris": [
          956,
          556,
          464,
          264
        ]
      },
      "sockets": [
        {
          "name": "ENG_MAIN_C",
          "kind": "ENG",
          "position": [
            0.0,
            0.600001,
            9.0
          ],
          "quaternion": [
            0.0,
            -1.0,
            0.0,
            0.0
          ],
          "params": {
            "radius": 0.65
          }
        },
        {
          "name": "ENG_MAIN_L",
          "kind": "ENG",
          "position": [
            -1.3,
            -0.599999,
            9.0
          ],
          "quaternion": [
            0.0,
            -1.0,
            0.0,
            0.0
          ],
          "params": {
            "radius": 0.65
          }
        },
        {
          "name": "ENG_MAIN_R",
          "kind": "ENG",
          "position": [
            1.3,
            -0.599999,
            9.0
          ],
          "quaternion": [
            0.0,
            -1.0,
            0.0,
            0.0
          ],
          "params": {
            "radius": 0.65
          }
        },
        {
          "name": "ENG_RCS_AL",
          "kind": "ENG",
          "position": [
            -3.1,
            0.0,
            3.75
          ],
          "quaternion": [
            0.0,
            0.707107,
            0.0,
            0.707107
          ],
          "params": {
            "radius": 0.12
          }
        },
        {
          "name": "ENG_RCS_AR",
          "kind": "ENG",
          "position": [
            3.1,
            0.0,
            3.75
          ],
          "quaternion": [
            0.0,
            -0.707107,
            0.0,
            0.707107
          ],
          "params": {
            "radius": 0.12
          }
        },
        {
          "name": "ENG_RCS_FL",
          "kind": "ENG",
          "position": [
            -3.1,
            0.0,
            -3.75
          ],
          "quaternion": [
            0.0,
            0.707107,
            0.0,
            0.707107
          ],
          "params": {
            "radius": 0.12
          }
        },
        {
          "name": "ENG_RCS_FR",
          "kind": "ENG",
          "position": [
            3.1,
            0.0,
            -3.75
          ],
          "quaternion": [
            0.0,
            -0.707107,
            0.0,
            0.707107
          ],
          "params": {
            "radius": 0.12
          }
        },
        {
          "name": "EYE_PILOT",
          "kind": "EYE",
          "position": [
            0.0,
            2.599999,
            -5.0
          ],
          "quaternion": [
            0.0,
            0.0,
            0.0,
            1.0
          ],
          "params": {}
        },
        {
          "name": "HP_LASER_L",
          "kind": "HP",
          "position": [
            -3.9,
            0.0,
            -4.5
          ],
          "quaternion": [
            0.0,
            0.0,
            0.0,
            1.0
          ],
          "params": {
            "size": "S"
          }
        },
        {
          "name": "HP_LASER_R",
          "kind": "HP",
          "position": [
            3.9,
            0.0,
            -4.5
          ],
          "quaternion": [
            0.0,
            0.0,
            0.0,
            1.0
          ],
          "params": {
            "size": "S"
          }
        },
        {
          "name": "LIGHT_NAV_PORT",
          "kind": "LIGHT",
          "position": [
            -4.2,
            0.0,
            -2.0
          ],
          "quaternion": [
            0.0,
            0.707107,
            0.0,
            0.707107
          ],
          "params": {
            "blinkHz": 0,
            "color": "#FF2A1F",
            "phase": 0,
            "type": "nav"
          }
        },
        {
          "name": "LIGHT_NAV_STBD",
          "kind": "LIGHT",
          "position": [
            4.2,
            0.0,
            -2.0
          ],
          "quaternion": [
            0.0,
            -0.707107,
            0.0,
            0.707107
          ],
          "params": {
            "blinkHz": 0,
            "color": "#2BFF6A",
            "phase": 0,
            "type": "nav"
          }
        },
        {
          "name": "LIGHT_STROBE",
          "kind": "LIGHT",
          "position": [
            0.0,
            3.2,
            -2.0
          ],
          "quaternion": [
            0.0,
            0.707107,
            -0.707107,
            0.0
          ],
          "params": {
            "blinkHz": 1,
            "color": "#FFFFFF",
            "phase": 0,
            "type": "strobe"
          }
        }
      ],
      "collider": {
        "kind": "convexHulls",
        "nodes": [
          "COL_CAB",
          "COL_DRUM",
          "COL_ENGINE",
          "COL_GUN_L",
          "COL_GUN_R",
          "COL_SPAR"
        ],
        "hullVerts": [
          8,
          20,
          8,
          8,
          8,
          8
        ]
      },
      "bounds": {
        "min": [
          -4.2,
          -3.15,
          -9.0
        ],
        "max": [
          4.2,
          3.2,
          9.0
        ],
        "center": [
          0.0,
          0.025,
          0.0
        ],
        "radius": 9.239128
      },
      "provenance": {
        "source": "greybox",
        "tool": "Blender 5.2.0 LTS + tools/blender/greybox_m10_relic.py",
        "humanContribution": "none",
        "license": "LicenseRef-Eclipse-Owned",
        "aiGenerated": true
      }
    },
    {
      "id": "ship.holdfast_wayfinder_block",
      "kind": "model",
      "class": "ship",
      "budget": "ship_light",
      "path": "/assets/placeholder/ship.holdfast_wayfinder_block.1c60d6c3.glb",
      "bytes": 110788,
      "sha256": "1c60d6c3408206aded6571a6232b78391e6915acb01233327cf6445826c00bca",
      "ledgerLine": "streamed.ships",
      "placeholder": true,
      "materialSlots": [
        "hull",
        "glass",
        "emissive"
      ],
      "lod": {
        "source": "authored",
        "distances": [
          0,
          50,
          200,
          700
        ],
        "hysteresis": 0.1,
        "tris": [
          828,
          492,
          368,
          232
        ]
      },
      "sockets": [
        {
          "name": "ENG_MAIN_L",
          "kind": "ENG",
          "position": [
            -1.1,
            0.0,
            11.7
          ],
          "quaternion": [
            0.0,
            -1.0,
            0.0,
            0.0
          ],
          "params": {
            "radius": 0.8
          }
        },
        {
          "name": "ENG_MAIN_R",
          "kind": "ENG",
          "position": [
            1.1,
            0.0,
            11.7
          ],
          "quaternion": [
            0.0,
            -1.0,
            0.0,
            0.0
          ],
          "params": {
            "radius": 0.8
          }
        },
        {
          "name": "ENG_RCS_AL",
          "kind": "ENG",
          "position": [
            -2.8,
            0.0,
            7.5
          ],
          "quaternion": [
            0.0,
            0.707107,
            0.0,
            0.707107
          ],
          "params": {
            "radius": 0.12
          }
        },
        {
          "name": "ENG_RCS_AR",
          "kind": "ENG",
          "position": [
            2.8,
            0.0,
            7.5
          ],
          "quaternion": [
            0.0,
            -0.707107,
            0.0,
            0.707107
          ],
          "params": {
            "radius": 0.12
          }
        },
        {
          "name": "ENG_RCS_FL",
          "kind": "ENG",
          "position": [
            -2.8,
            0.0,
            -2.0
          ],
          "quaternion": [
            0.0,
            0.707107,
            0.0,
            0.707107
          ],
          "params": {
            "radius": 0.12
          }
        },
        {
          "name": "ENG_RCS_FR",
          "kind": "ENG",
          "position": [
            2.8,
            0.0,
            -2.0
          ],
          "quaternion": [
            0.0,
            -0.707107,
            0.0,
            0.707107
          ],
          "params": {
            "radius": 0.12
          }
        },
        {
          "name": "EYE_PILOT",
          "kind": "EYE",
          "position": [
            0.0,
            3.1,
            -2.5
          ],
          "quaternion": [
            0.0,
            0.0,
            0.0,
            1.0
          ],
          "params": {}
        },
        {
          "name": "HP_LASER_L",
          "kind": "HP",
          "position": [
            -3.1,
            0.0,
            -1.0
          ],
          "quaternion": [
            0.0,
            0.0,
            0.0,
            1.0
          ],
          "params": {
            "size": "S"
          }
        },
        {
          "name": "HP_LASER_R",
          "kind": "HP",
          "position": [
            3.1,
            0.0,
            -1.0
          ],
          "quaternion": [
            0.0,
            0.0,
            0.0,
            1.0
          ],
          "params": {
            "size": "S"
          }
        },
        {
          "name": "LIGHT_NAV_PORT",
          "kind": "LIGHT",
          "position": [
            -3.6,
            0.0,
            1.0
          ],
          "quaternion": [
            0.0,
            0.707107,
            0.0,
            0.707107
          ],
          "params": {
            "blinkHz": 0,
            "color": "#FF2A1F",
            "phase": 0,
            "type": "nav"
          }
        },
        {
          "name": "LIGHT_NAV_STBD",
          "kind": "LIGHT",
          "position": [
            3.6,
            0.0,
            1.0
          ],
          "quaternion": [
            0.0,
            -0.707107,
            0.0,
            0.707107
          ],
          "params": {
            "blinkHz": 0,
            "color": "#2BFF6A",
            "phase": 0,
            "type": "nav"
          }
        },
        {
          "name": "LIGHT_STROBE",
          "kind": "LIGHT",
          "position": [
            0.0,
            3.700001,
            6.0
          ],
          "quaternion": [
            0.0,
            0.707107,
            -0.707107,
            0.0
          ],
          "params": {
            "blinkHz": 1,
            "color": "#FFFFFF",
            "phase": 0,
            "type": "strobe"
          }
        }
      ],
      "collider": {
        "kind": "convexHulls",
        "nodes": [
          "COL_BOOM",
          "COL_CAB",
          "COL_DRUM",
          "COL_ENGINE",
          "COL_GUN_L",
          "COL_GUN_R",
          "COL_HEAD"
        ],
        "hullVerts": [
          8,
          8,
          20,
          8,
          8,
          8,
          8
        ]
      },
      "bounds": {
        "min": [
          -3.6,
          -2.95,
          -11.7
        ],
        "max": [
          3.6,
          3.7,
          11.699999
        ],
        "center": [
          0.0,
          0.375,
          0.0
        ],
        "radius": 11.871018
      },
      "provenance": {
        "source": "greybox",
        "tool": "Blender 5.2.0 LTS + tools/blender/greybox_m10_relic.py",
        "humanContribution": "none",
        "license": "LicenseRef-Eclipse-Owned",
        "aiGenerated": true
      }
    },
    {
      "id": "ship.interceptor",
      "class": "ship",
      "budget": "ship_light",
      "path": "/assets/ship/ship.interceptor.a75f752e.glb",
      "bytes": 574212,
      "sha256": "a75f752ef6be95cd449904d9c206acb0c1380d6d8321c348af96a6d9517613dc",
      "ledgerLine": "streamed.ships",
      "placeholder": false,
      "provenance": {
        "source": "procedural-ts",
        "tool": "Node 24.15.0 + tools/assetkit + assets-src/ship.interceptor/build.ts @ sha256:922921c71da1",
        "humanContribution": "none",
        "license": "LicenseRef-Eclipse-Owned",
        "aiGenerated": true,
        "manifestRef": "ship.interceptor"
      },
      "kind": "model",
      "materialSlots": [
        "hull",
        "glass",
        "emissive",
        "decal"
      ],
      "lod": {
        "source": "authored",
        "distances": [
          0,
          50,
          200,
          700
        ],
        "hysteresis": 0.1,
        "tris": [
          25468,
          6100,
          2260,
          588
        ]
      },
      "sockets": [
        {
          "name": "ENG_MAIN_C",
          "kind": "ENG",
          "position": [
            0,
            -0.04,
            5.6
          ],
          "quaternion": [
            0,
            1,
            0,
            0
          ],
          "params": {
            "radius": 0.75
          }
        },
        {
          "name": "ENG_MAIN_L",
          "kind": "ENG",
          "position": [
            -1,
            -0.85,
            4.9
          ],
          "quaternion": [
            0,
            1,
            0,
            0
          ],
          "params": {
            "radius": 0.18
          }
        },
        {
          "name": "ENG_MAIN_R",
          "kind": "ENG",
          "position": [
            1,
            -0.85,
            4.9
          ],
          "quaternion": [
            0,
            1,
            0,
            0
          ],
          "params": {
            "radius": 0.18
          }
        },
        {
          "name": "ENG_RCS_AL",
          "kind": "ENG",
          "position": [
            -4.55,
            -0.82,
            -0.5
          ],
          "quaternion": [
            0,
            0.707107,
            0,
            0.707107
          ],
          "params": {
            "radius": 0.1
          }
        },
        {
          "name": "ENG_RCS_AR",
          "kind": "ENG",
          "position": [
            4.55,
            -0.82,
            -0.5
          ],
          "quaternion": [
            0,
            -0.707107,
            0,
            0.707107
          ],
          "params": {
            "radius": 0.1
          }
        },
        {
          "name": "ENG_RCS_FL",
          "kind": "ENG",
          "position": [
            -0.6,
            0,
            -3.4
          ],
          "quaternion": [
            0,
            0.707107,
            0,
            0.707107
          ],
          "params": {
            "radius": 0.1
          }
        },
        {
          "name": "ENG_RCS_FR",
          "kind": "ENG",
          "position": [
            0.6,
            0,
            -3.4
          ],
          "quaternion": [
            0,
            -0.707107,
            0,
            0.707107
          ],
          "params": {
            "radius": 0.1
          }
        },
        {
          "name": "EYE_PILOT",
          "kind": "EYE",
          "position": [
            0,
            0.62,
            -1.5
          ],
          "quaternion": [
            0,
            0,
            0,
            1
          ],
          "params": {}
        },
        {
          "name": "HP_LASER_L",
          "kind": "HP",
          "position": [
            -4.35,
            -0.82,
            -3.3
          ],
          "quaternion": [
            0,
            0,
            0,
            1
          ],
          "params": {
            "size": "S"
          }
        },
        {
          "name": "HP_LASER_R",
          "kind": "HP",
          "position": [
            4.35,
            -0.82,
            -3.3
          ],
          "quaternion": [
            0,
            0,
            0,
            1
          ],
          "params": {
            "size": "S"
          }
        },
        {
          "name": "LIGHT_SENSOR_EYE",
          "kind": "LIGHT",
          "position": [
            0,
            -0.2,
            -4.9
          ],
          "quaternion": [
            0,
            0,
            0,
            1
          ],
          "params": {
            "blinkHz": 0,
            "color": "#FF2F24",
            "phase": 0,
            "type": "sensor"
          }
        }
      ],
      "collider": {
        "kind": "convexHulls",
        "nodes": [
          "COL_BLADES_00",
          "COL_ENGINE_01",
          "COL_FUSELAGE_02",
          "COL_NOSE_03",
          "COL_TANK_04",
          "COL_WING_L_05",
          "COL_WING_R_06"
        ],
        "hullVerts": [
          46,
          48,
          48,
          48,
          48,
          48,
          48
        ]
      },
      "bounds": {
        "min": [
          -4.6,
          -1.175,
          -5.9
        ],
        "max": [
          4.599719,
          2.065188,
          5.6
        ],
        "center": [
          -0.00014,
          0.445094,
          -0.15
        ],
        "radius": 5.913973
      }
    },
    {
      "id": "ship.kestrel",
      "class": "ship",
      "budget": "ship_player",
      "path": "/assets/ship/ship.kestrel.e4098cd5.glb",
      "bytes": 1182372,
      "sha256": "e4098cd59abd413824b0b2badab786941c1bc48c3c4133d4189dd0b364162830",
      "ledgerLine": "ship.kestrel",
      "placeholder": false,
      "provenance": {
        "source": "procedural-ts",
        "tool": "Node 24.15.0 + tools/assetkit + assets-src/ship.kestrel/build.ts @ sha256:cde8875d6b01",
        "humanContribution": "none",
        "license": "LicenseRef-Eclipse-Owned",
        "aiGenerated": true,
        "manifestRef": "ship.kestrel"
      },
      "kind": "model",
      "materialSlots": [
        "hull",
        "glass",
        "emissive",
        "decal"
      ],
      "lod": {
        "source": "authored",
        "distances": [
          0,
          60,
          250,
          900
        ],
        "hysteresis": 0.1,
        "tris": [
          44946,
          17526,
          5750,
          1496
        ]
      },
      "sockets": [
        {
          "name": "ENG_MAIN_L",
          "kind": "ENG",
          "position": [
            -4.2,
            0.15,
            6.6
          ],
          "quaternion": [
            0,
            1,
            0,
            0
          ],
          "params": {
            "radius": 0.65
          }
        },
        {
          "name": "ENG_MAIN_R",
          "kind": "ENG",
          "position": [
            4.2,
            0.15,
            6.6
          ],
          "quaternion": [
            0,
            1,
            0,
            0
          ],
          "params": {
            "radius": 0.65
          }
        },
        {
          "name": "ENG_RCS_AL",
          "kind": "ENG",
          "position": [
            -5.6,
            0.15,
            4.72
          ],
          "quaternion": [
            0,
            0.707107,
            0,
            0.707107
          ],
          "params": {
            "radius": 0.12
          }
        },
        {
          "name": "ENG_RCS_AR",
          "kind": "ENG",
          "position": [
            5.6,
            0.15,
            4.72
          ],
          "quaternion": [
            0,
            -0.707107,
            0,
            0.707107
          ],
          "params": {
            "radius": 0.12
          }
        },
        {
          "name": "ENG_RCS_FL",
          "kind": "ENG",
          "position": [
            -5.6,
            0.15,
            -1.6
          ],
          "quaternion": [
            0,
            0.707107,
            0,
            0.707107
          ],
          "params": {
            "radius": 0.12
          }
        },
        {
          "name": "ENG_RCS_FR",
          "kind": "ENG",
          "position": [
            5.6,
            0.15,
            -1.6
          ],
          "quaternion": [
            0,
            -0.707107,
            0,
            0.707107
          ],
          "params": {
            "radius": 0.12
          }
        },
        {
          "name": "ENG_RETRO_L",
          "kind": "ENG",
          "position": [
            -4.2,
            0.15,
            -2.4
          ],
          "quaternion": [
            0,
            0,
            0,
            1
          ],
          "params": {
            "radius": 0.5
          }
        },
        {
          "name": "ENG_RETRO_R",
          "kind": "ENG",
          "position": [
            4.2,
            0.15,
            -2.4
          ],
          "quaternion": [
            0,
            0,
            0,
            1
          ],
          "params": {
            "radius": 0.5
          }
        },
        {
          "name": "EYE_PILOT",
          "kind": "EYE",
          "position": [
            0,
            0.75,
            -3.4
          ],
          "quaternion": [
            0,
            0,
            0,
            1
          ],
          "params": {}
        },
        {
          "name": "HP_LASER_C",
          "kind": "HP",
          "position": [
            0,
            -0.75,
            -6
          ],
          "quaternion": [
            0,
            0,
            0,
            1
          ],
          "params": {
            "size": "S"
          }
        },
        {
          "name": "HP_PDC_L",
          "kind": "HP",
          "position": [
            -1.75,
            -0.58,
            -7.26
          ],
          "quaternion": [
            0,
            0,
            0,
            1
          ],
          "params": {
            "size": "S"
          }
        },
        {
          "name": "HP_PDC_R",
          "kind": "HP",
          "position": [
            1.75,
            -0.58,
            -7.26
          ],
          "quaternion": [
            0,
            0,
            0,
            1
          ],
          "params": {
            "size": "S"
          }
        },
        {
          "name": "HP_TORP_V",
          "kind": "HP",
          "position": [
            0,
            -1.6,
            -0.2
          ],
          "quaternion": [
            0,
            0,
            0,
            1
          ],
          "params": {
            "size": "M"
          }
        },
        {
          "name": "LIGHT_NAV_PORT",
          "kind": "LIGHT",
          "position": [
            -5.4,
            0.9,
            1
          ],
          "quaternion": [
            0,
            0.707107,
            0,
            0.707107
          ],
          "params": {
            "blinkHz": 0,
            "color": "#FF2A1F",
            "phase": 0,
            "type": "nav"
          }
        },
        {
          "name": "LIGHT_NAV_STBD",
          "kind": "LIGHT",
          "position": [
            5.4,
            0.9,
            1
          ],
          "quaternion": [
            0,
            -0.707107,
            0,
            0.707107
          ],
          "params": {
            "blinkHz": 0,
            "color": "#2BFF6A",
            "phase": 0,
            "type": "nav"
          }
        },
        {
          "name": "LIGHT_NAV_TAIL",
          "kind": "LIGHT",
          "position": [
            0,
            0.12,
            6.18
          ],
          "quaternion": [
            0,
            1,
            0,
            0
          ],
          "params": {
            "blinkHz": 0,
            "color": "#FFF6E8",
            "phase": 0,
            "type": "nav"
          }
        },
        {
          "name": "LIGHT_STROBE",
          "kind": "LIGHT",
          "position": [
            0,
            1.77,
            -0.45
          ],
          "quaternion": [
            0,
            -0.707107,
            0.707107,
            0
          ],
          "params": {
            "blinkHz": 1,
            "color": "#FFFFFF",
            "phase": 0,
            "type": "strobe"
          }
        },
        {
          "name": "LIGHT_WORK_L",
          "kind": "LIGHT",
          "position": [
            -0.7,
            1.12,
            -3.87
          ],
          "quaternion": [
            0.094683,
            0.126262,
            -0.012108,
            0.987394
          ],
          "params": {
            "blinkHz": 0,
            "color": "#FFB347",
            "phase": 0,
            "type": "work"
          }
        },
        {
          "name": "LIGHT_WORK_R",
          "kind": "LIGHT",
          "position": [
            0.7,
            1.12,
            -3.87
          ],
          "quaternion": [
            0.094683,
            -0.126262,
            0.012108,
            0.987394
          ],
          "params": {
            "blinkHz": 0,
            "color": "#FFB347",
            "phase": 0,
            "type": "work"
          }
        }
      ],
      "collider": {
        "kind": "convexHulls",
        "nodes": [
          "COL_ARM_L_00",
          "COL_ARM_R_01",
          "COL_BODY_02",
          "COL_CAB_03",
          "COL_NACELLE_L_04",
          "COL_NACELLE_R_05",
          "COL_PYLON_L_06",
          "COL_PYLON_R_07",
          "COL_RADIATORS_08"
        ],
        "hullVerts": [
          48,
          48,
          48,
          48,
          48,
          48,
          48,
          48,
          48
        ]
      },
      "bounds": {
        "min": [
          -5.6,
          -1.7,
          -7.266
        ],
        "max": [
          5.599949,
          2.910997,
          6.599999
        ],
        "center": [
          -0.000025,
          0.605498,
          -0.333
        ],
        "radius": 8.608653
      }
    },
    {
      "id": "ship.kit_mutual_block",
      "kind": "model",
      "class": "poi_prop",
      "budget": "poi_prop",
      "path": "/assets/placeholder/ship.kit_mutual_block.a8e8c21c.glb",
      "bytes": 69168,
      "sha256": "a8e8c21c01610949d2aada1380f93eb992147ee373689f333b65cc17c08375e0",
      "ledgerLine": "streamed.ships",
      "placeholder": true,
      "materialSlots": [
        "hull",
        "glass",
        "emissive"
      ],
      "lod": {
        "source": "authored",
        "distances": [
          0,
          400
        ],
        "hysteresis": 0.1,
        "tris": [
          1012,
          208
        ]
      },
      "sockets": [
        {
          "name": "CON_HOMESTEAD_HAB_POD",
          "kind": "CON",
          "position": [
            28.0,
            0.0,
            0.0
          ],
          "quaternion": [
            0.0,
            0.0,
            0.0,
            1.0
          ],
          "params": {
            "face": "dorsal",
            "kit": "homestead",
            "part": "hab_pod",
            "refLen": 40.0,
            "size": "M",
            "x0": 21.0,
            "x1": 35.0
          }
        },
        {
          "name": "CON_LIFELINE_POD",
          "kind": "CON",
          "position": [
            0.0,
            0.0,
            0.0
          ],
          "quaternion": [
            0.0,
            0.0,
            0.0,
            1.0
          ],
          "params": {
            "face": "flank",
            "kit": "lifeline",
            "part": "pod",
            "refLen": 45.0,
            "size": "M",
            "x0": -7.0,
            "x1": 7.0
          }
        },
        {
          "name": "CON_NEIGHBOUR_STRAP_ON",
          "kind": "CON",
          "position": [
            42.0,
            0.0,
            0.0
          ],
          "quaternion": [
            0.0,
            0.0,
            0.0,
            1.0
          ],
          "params": {
            "face": "flank",
            "kit": "neighbour",
            "part": "strap_on",
            "refLen": 12.0,
            "size": "S",
            "x0": 35.0,
            "x1": 49.0
          }
        },
        {
          "name": "CON_PICKUP_CLAW_RACK",
          "kind": "CON",
          "position": [
            14.0,
            0.0,
            0.0
          ],
          "quaternion": [
            0.0,
            0.0,
            0.0,
            1.0
          ],
          "params": {
            "face": "ventral",
            "kit": "pickup",
            "part": "claw_rack",
            "refLen": 40.0,
            "size": "M",
            "x0": 7.0,
            "x1": 21.0
          }
        }
      ],
      "collider": {
        "kind": "convexHulls",
        "nodes": [
          "COL_HOMESTEAD",
          "COL_LIFELINE",
          "COL_NEIGHBOUR",
          "COL_PICKUP"
        ],
        "hullVerts": [
          8,
          8,
          8,
          8
        ]
      },
      "bounds": {
        "min": [
          0.0,
          -1.900001,
          -7.5
        ],
        "max": [
          44.200001,
          6.200001,
          5.0
        ],
        "center": [
          22.1,
          2.15,
          -1.25
        ],
        "radius": 22.536611
      },
      "provenance": {
        "source": "greybox",
        "tool": "Blender 5.2.0 LTS + tools/blender/greybox_m10_kits.py",
        "humanContribution": "none",
        "license": "LicenseRef-Eclipse-Owned",
        "aiGenerated": true
      }
    },
    {
      "id": "ship.kit_wreckers_block",
      "kind": "model",
      "class": "poi_prop",
      "budget": "poi_prop",
      "path": "/assets/placeholder/ship.kit_wreckers_block.4f09f61c.glb",
      "bytes": 80972,
      "sha256": "4f09f61c72854750171b2daa532388c12ca950c619715515492e6230e09e5fc6",
      "ledgerLine": "streamed.ships",
      "placeholder": true,
      "materialSlots": [
        "hull",
        "emissive"
      ],
      "lod": {
        "source": "authored",
        "distances": [
          0,
          400
        ],
        "hysteresis": 0.1,
        "tris": [
          1188,
          292
        ]
      },
      "sockets": [
        {
          "name": "CON_HARPOON_SLED",
          "kind": "CON",
          "position": [
            56.0,
            0.0,
            0.0
          ],
          "quaternion": [
            0.0,
            0.0,
            0.0,
            1.0
          ],
          "params": {
            "face": "flank",
            "kit": "harpoon",
            "part": "sled",
            "refLen": 20.0,
            "size": "S",
            "x0": 49.0,
            "x1": 63.0
          }
        },
        {
          "name": "CON_PRIZE_CLAMP",
          "kind": "CON",
          "position": [
            42.0,
            0.0,
            0.0
          ],
          "quaternion": [
            0.0,
            0.0,
            0.0,
            1.0
          ],
          "params": {
            "face": "bow",
            "kit": "prize",
            "part": "clamp",
            "refLen": 38.0,
            "size": "M",
            "x0": 35.0,
            "x1": 49.0
          }
        },
        {
          "name": "CON_RAM_PLATE",
          "kind": "CON",
          "position": [
            0.0,
            0.0,
            0.0
          ],
          "quaternion": [
            0.0,
            0.0,
            0.0,
            1.0
          ],
          "params": {
            "face": "bow",
            "kit": "ram",
            "part": "plate",
            "refLen": 35.0,
            "size": "M",
            "x0": -7.0,
            "x1": 7.0
          }
        },
        {
          "name": "CON_RUNNER_PANEL",
          "kind": "CON",
          "position": [
            14.0,
            0.0,
            0.0
          ],
          "quaternion": [
            0.0,
            0.0,
            0.0,
            1.0
          ],
          "params": {
            "face": "flank",
            "kit": "runner",
            "part": "panel",
            "refLen": 15.0,
            "size": "S",
            "x0": 7.0,
            "x1": 21.0
          }
        },
        {
          "name": "CON_STRIPPER_RACK",
          "kind": "CON",
          "position": [
            28.0,
            0.0,
            0.0
          ],
          "quaternion": [
            0.0,
            0.0,
            0.0,
            1.0
          ],
          "params": {
            "face": "dorsal",
            "kit": "stripper",
            "part": "rack",
            "refLen": 35.0,
            "size": "M",
            "x0": 21.0,
            "x1": 35.0
          }
        }
      ],
      "collider": {
        "kind": "convexHulls",
        "nodes": [
          "COL_HARPOON",
          "COL_PRIZE",
          "COL_RAM",
          "COL_RUNNER",
          "COL_STRIPPER"
        ],
        "hullVerts": [
          8,
          8,
          8,
          8,
          8
        ]
      },
      "bounds": {
        "min": [
          -4.0,
          -3.0,
          -5.8
        ],
        "max": [
          57.900002,
          3.099999,
          5.0
        ],
        "center": [
          26.950001,
          0.05,
          -0.4
        ],
        "radius": 31.127156
      },
      "provenance": {
        "source": "greybox",
        "tool": "Blender 5.2.0 LTS + tools/blender/greybox_m10_kits.py",
        "humanContribution": "none",
        "license": "LicenseRef-Eclipse-Owned",
        "aiGenerated": true
      }
    },
    {
      "id": "ship.meridian_courier",
      "class": "ship",
      "budget": "ship_light",
      "path": "/assets/placeholder/ship.meridian_courier.d527ce77.glb",
      "bytes": 83796,
      "sha256": "d527ce77453d7ee19e2fe722433a2cc51efdddd035b8444b762b6a6f4dfa1fef",
      "ledgerLine": "streamed.ships",
      "placeholder": true,
      "provenance": {
        "source": "greybox",
        "tool": "Blender 5.2.0 LTS + tools/blender/greybox_story.py",
        "humanContribution": "none",
        "license": "LicenseRef-Eclipse-Owned",
        "aiGenerated": true
      },
      "kind": "model",
      "materialSlots": [
        "hull",
        "glass",
        "emissive"
      ],
      "lod": {
        "source": "authored",
        "distances": [
          0,
          50,
          200,
          700
        ],
        "hysteresis": 0.1,
        "tris": [
          628,
          276,
          252,
          156
        ]
      },
      "sockets": [
        {
          "name": "DOCK_CASE",
          "kind": "DOCK",
          "position": [
            0,
            2.25,
            0
          ],
          "quaternion": [
            0,
            0.707107,
            -0.707107,
            0
          ],
          "params": {
            "size": "S"
          }
        },
        {
          "name": "ENG_MAIN_L",
          "kind": "ENG",
          "position": [
            -2.3,
            0,
            6.9
          ],
          "quaternion": [
            0,
            -1,
            0,
            0
          ],
          "params": {
            "radius": 0.75
          }
        },
        {
          "name": "ENG_MAIN_R",
          "kind": "ENG",
          "position": [
            2.3,
            0,
            6.9
          ],
          "quaternion": [
            0,
            -1,
            0,
            0
          ],
          "params": {
            "radius": 0.75
          }
        },
        {
          "name": "EYE_PILOT",
          "kind": "EYE",
          "position": [
            0,
            1.1,
            -6.5
          ],
          "quaternion": [
            0,
            0,
            0,
            1
          ],
          "params": {}
        },
        {
          "name": "HP_LASER_L",
          "kind": "HP",
          "position": [
            -2.3,
            0,
            -1.05
          ],
          "quaternion": [
            0,
            0,
            0,
            1
          ],
          "params": {
            "size": "S"
          }
        },
        {
          "name": "HP_LASER_R",
          "kind": "HP",
          "position": [
            2.3,
            0,
            -1.05
          ],
          "quaternion": [
            0,
            0,
            0,
            1
          ],
          "params": {
            "size": "S"
          }
        },
        {
          "name": "LIGHT_NAV_PORT",
          "kind": "LIGHT",
          "position": [
            -5.5,
            0,
            4
          ],
          "quaternion": [
            0,
            0.707107,
            0,
            0.707107
          ],
          "params": {
            "blinkHz": 0,
            "color": "#FF2A1F",
            "phase": 0,
            "type": "nav"
          }
        },
        {
          "name": "LIGHT_NAV_STBD",
          "kind": "LIGHT",
          "position": [
            5.5,
            0,
            4
          ],
          "quaternion": [
            0,
            -0.707107,
            0,
            0.707107
          ],
          "params": {
            "blinkHz": 0,
            "color": "#2BFF6A",
            "phase": 0,
            "type": "nav"
          }
        },
        {
          "name": "LIGHT_STROBE",
          "kind": "LIGHT",
          "position": [
            0,
            2.25,
            2
          ],
          "quaternion": [
            0,
            0.707107,
            -0.707107,
            0
          ],
          "params": {
            "blinkHz": 1,
            "color": "#FFFFFF",
            "phase": 0,
            "type": "strobe"
          }
        }
      ],
      "collider": {
        "kind": "convexHulls",
        "nodes": [
          "COL_BODY",
          "COL_CASE",
          "COL_NACELLE_L",
          "COL_NACELLE_R",
          "COL_NOSE",
          "COL_WING_L",
          "COL_WING_R"
        ],
        "hullVerts": [
          8,
          8,
          8,
          8,
          8,
          8,
          8
        ]
      },
      "bounds": {
        "min": [
          -5.5,
          -1.05,
          -8
        ],
        "max": [
          5.5,
          2.25,
          6.900001
        ],
        "center": [
          0,
          0.6,
          -0.55
        ],
        "radius": 8.060055
      }
    },
    {
      "id": "ship.miner",
      "class": "ship",
      "budget": "ship_medium",
      "path": "/assets/placeholder/ship.miner.38c72f1a.glb",
      "bytes": 96056,
      "sha256": "38c72f1a012bee23e31cc7067e28ee2d4257ab01f426ba9c1092d8d3bc2d2ec6",
      "ledgerLine": "streamed.ships",
      "placeholder": true,
      "provenance": {
        "source": "greybox",
        "tool": "Blender 5.2.0 LTS + tools/blender/greybox_economy.py",
        "humanContribution": "none",
        "license": "LicenseRef-Eclipse-Owned",
        "aiGenerated": true
      },
      "kind": "model",
      "materialSlots": [
        "hull",
        "glass",
        "emissive"
      ],
      "lod": {
        "source": "authored",
        "distances": [
          0,
          90,
          350,
          1200
        ],
        "hysteresis": 0.1,
        "tris": [
          724,
          372,
          268,
          184
        ]
      },
      "sockets": [
        {
          "name": "ENG_MAIN_L",
          "kind": "ENG",
          "position": [
            -1.8,
            0,
            16.1
          ],
          "quaternion": [
            0,
            -1,
            0,
            0
          ],
          "params": {
            "radius": 1.2
          }
        },
        {
          "name": "ENG_MAIN_R",
          "kind": "ENG",
          "position": [
            1.8,
            0,
            16.1
          ],
          "quaternion": [
            0,
            -1,
            0,
            0
          ],
          "params": {
            "radius": 1.2
          }
        },
        {
          "name": "ENG_RETRO_L",
          "kind": "ENG",
          "position": [
            -4,
            0.499999,
            -12
          ],
          "quaternion": [
            0,
            0,
            0,
            1
          ],
          "params": {
            "radius": 0.6
          }
        },
        {
          "name": "ENG_RETRO_R",
          "kind": "ENG",
          "position": [
            4,
            0.499999,
            -12
          ],
          "quaternion": [
            0,
            0,
            0,
            1
          ],
          "params": {
            "radius": 0.6
          }
        },
        {
          "name": "EYE_PILOT",
          "kind": "EYE",
          "position": [
            0,
            2.599999,
            -14.5
          ],
          "quaternion": [
            0,
            0,
            0,
            1
          ],
          "params": {}
        },
        {
          "name": "HP_MINING_L",
          "kind": "HP",
          "position": [
            -4.9,
            -1.000001,
            -19
          ],
          "quaternion": [
            0,
            0,
            0,
            1
          ],
          "params": {
            "size": "S"
          }
        },
        {
          "name": "HP_MINING_R",
          "kind": "HP",
          "position": [
            4.9,
            -1.000001,
            -19
          ],
          "quaternion": [
            0,
            0,
            0,
            1
          ],
          "params": {
            "size": "S"
          }
        },
        {
          "name": "LIGHT_NAV_PORT",
          "kind": "LIGHT",
          "position": [
            -4.1,
            0,
            10
          ],
          "quaternion": [
            0,
            0.707107,
            0,
            0.707107
          ],
          "params": {
            "blinkHz": 0,
            "color": "#FF2A1F",
            "phase": 0,
            "type": "nav"
          }
        },
        {
          "name": "LIGHT_NAV_STBD",
          "kind": "LIGHT",
          "position": [
            4.1,
            0,
            10
          ],
          "quaternion": [
            0,
            -0.707107,
            0,
            0.707107
          ],
          "params": {
            "blinkHz": 0,
            "color": "#2BFF6A",
            "phase": 0,
            "type": "nav"
          }
        },
        {
          "name": "LIGHT_WORK_L",
          "kind": "LIGHT",
          "position": [
            -4.6,
            2.999999,
            -9.1
          ],
          "quaternion": [
            -0.145213,
            0,
            0,
            0.9894
          ],
          "params": {
            "blinkHz": 0,
            "color": "#FFD27A",
            "phase": 0,
            "type": "work"
          }
        },
        {
          "name": "LIGHT_WORK_R",
          "kind": "LIGHT",
          "position": [
            4.6,
            2.999999,
            -9.1
          ],
          "quaternion": [
            -0.145213,
            0,
            0,
            0.9894
          ],
          "params": {
            "blinkHz": 0,
            "color": "#FFD27A",
            "phase": 0,
            "type": "work"
          }
        }
      ],
      "collider": {
        "kind": "convexHulls",
        "nodes": [
          "COL_ARM_L",
          "COL_ARM_R",
          "COL_CAB",
          "COL_CHASSIS",
          "COL_ENGINE",
          "COL_HOPPER"
        ],
        "hullVerts": [
          8,
          8,
          8,
          8,
          8,
          16
        ]
      },
      "bounds": {
        "min": [
          -6.2,
          -3.050001,
          -19
        ],
        "max": [
          6.2,
          7.400001,
          16.099998
        ],
        "center": [
          0,
          2.175,
          -1.450001
        ],
        "radius": 19.187251
      }
    },
    {
      "id": "ship.prisoner_transport",
      "class": "ship",
      "budget": "ship_medium",
      "path": "/assets/placeholder/ship.prisoner_transport.17521376.glb",
      "bytes": 82056,
      "sha256": "1752137654aa1c55e694e80a53bc00219524288df99992ae4e2c152ec2f2248c",
      "ledgerLine": "streamed.ships",
      "placeholder": true,
      "provenance": {
        "source": "greybox",
        "tool": "Blender 5.2.0 LTS + tools/blender/greybox_story.py",
        "humanContribution": "none",
        "license": "LicenseRef-Eclipse-Owned",
        "aiGenerated": true
      },
      "kind": "model",
      "materialSlots": [
        "hull",
        "glass",
        "emissive"
      ],
      "lod": {
        "source": "authored",
        "distances": [
          0,
          90,
          350,
          1200
        ],
        "hysteresis": 0.1,
        "tris": [
          672,
          288,
          216,
          120
        ]
      },
      "sockets": [
        {
          "name": "DOCK_AIRLOCK",
          "kind": "DOCK",
          "position": [
            -6.25,
            0,
            -2
          ],
          "quaternion": [
            0,
            0.707107,
            0,
            0.707107
          ],
          "params": {
            "size": "S"
          }
        },
        {
          "name": "ENG_MAIN_L",
          "kind": "ENG",
          "position": [
            -2,
            0,
            14.1
          ],
          "quaternion": [
            0,
            -1,
            0,
            0
          ],
          "params": {
            "radius": 1.3
          }
        },
        {
          "name": "ENG_MAIN_R",
          "kind": "ENG",
          "position": [
            2,
            0,
            14.1
          ],
          "quaternion": [
            0,
            -1,
            0,
            0
          ],
          "params": {
            "radius": 1.3
          }
        },
        {
          "name": "ENG_RETRO_L",
          "kind": "ENG",
          "position": [
            -4,
            0,
            -11
          ],
          "quaternion": [
            0,
            0,
            0,
            1
          ],
          "params": {
            "radius": 0.5
          }
        },
        {
          "name": "ENG_RETRO_R",
          "kind": "ENG",
          "position": [
            4,
            0,
            -11
          ],
          "quaternion": [
            0,
            0,
            0,
            1
          ],
          "params": {
            "radius": 0.5
          }
        },
        {
          "name": "EYE_PILOT",
          "kind": "EYE",
          "position": [
            0,
            1.399999,
            -16
          ],
          "quaternion": [
            0,
            0,
            0,
            1
          ],
          "params": {}
        },
        {
          "name": "HP_TURRET_T",
          "kind": "HP",
          "position": [
            0,
            4.3,
            -7.5
          ],
          "quaternion": [
            0,
            0,
            0,
            1
          ],
          "params": {
            "size": "M"
          }
        },
        {
          "name": "LIGHT_NAV_PORT",
          "kind": "LIGHT",
          "position": [
            -5.1,
            0,
            7
          ],
          "quaternion": [
            0,
            0.707107,
            0,
            0.707107
          ],
          "params": {
            "blinkHz": 0,
            "color": "#FF2A1F",
            "phase": 0,
            "type": "nav"
          }
        },
        {
          "name": "LIGHT_NAV_STBD",
          "kind": "LIGHT",
          "position": [
            5.1,
            0,
            7
          ],
          "quaternion": [
            0,
            -0.707107,
            0,
            0.707107
          ],
          "params": {
            "blinkHz": 0,
            "color": "#2BFF6A",
            "phase": 0,
            "type": "nav"
          }
        },
        {
          "name": "LIGHT_STROBE",
          "kind": "LIGHT",
          "position": [
            0,
            3.6,
            4
          ],
          "quaternion": [
            0,
            0.707107,
            -0.707107,
            0
          ],
          "params": {
            "blinkHz": 1,
            "color": "#FFFFFF",
            "phase": 0,
            "type": "strobe"
          }
        }
      ],
      "collider": {
        "kind": "convexHulls",
        "nodes": [
          "COL_AIRLOCK",
          "COL_BLOCK",
          "COL_CAB",
          "COL_ENGINE",
          "COL_TURRET"
        ],
        "hullVerts": [
          8,
          8,
          8,
          8,
          8
        ]
      },
      "bounds": {
        "min": [
          -6.25,
          -3.6,
          -17.099998
        ],
        "max": [
          5.1,
          4.3,
          14.1
        ],
        "center": [
          -0.575,
          0.35,
          -1.499999
        ],
        "radius": 16.127791
      }
    },
    {
      "id": "ship.relic_escort_block",
      "kind": "model",
      "class": "ship",
      "budget": "ship_light",
      "path": "/assets/placeholder/ship.relic_escort_block.cc88e774.glb",
      "bytes": 126804,
      "sha256": "cc88e7744339f0b7a6478444261b128fa3bbc2669f1b8f048e3da880afce058d",
      "ledgerLine": "streamed.ships",
      "placeholder": true,
      "materialSlots": [
        "hull",
        "glass"
      ],
      "lod": {
        "source": "authored",
        "distances": [
          0,
          50,
          200,
          700
        ],
        "hysteresis": 0.1,
        "tris": [
          1044,
          580,
          476,
          264
        ]
      },
      "sockets": [
        {
          "name": "ENG_MAIN_C",
          "kind": "ENG",
          "position": [
            0.0,
            0.600001,
            9.0
          ],
          "quaternion": [
            0.0,
            -1.0,
            0.0,
            0.0
          ],
          "params": {
            "radius": 0.65
          }
        },
        {
          "name": "ENG_MAIN_L",
          "kind": "ENG",
          "position": [
            -1.3,
            -0.599999,
            9.0
          ],
          "quaternion": [
            0.0,
            -1.0,
            0.0,
            0.0
          ],
          "params": {
            "radius": 0.65
          }
        },
        {
          "name": "ENG_MAIN_R",
          "kind": "ENG",
          "position": [
            1.3,
            -0.599999,
            9.0
          ],
          "quaternion": [
            0.0,
            -1.0,
            0.0,
            0.0
          ],
          "params": {
            "radius": 0.65
          }
        },
        {
          "name": "ENG_RCS_AL",
          "kind": "ENG",
          "position": [
            -3.1,
            0.0,
            3.75
          ],
          "quaternion": [
            0.0,
            0.707107,
            0.0,
            0.707107
          ],
          "params": {
            "radius": 0.12
          }
        },
        {
          "name": "ENG_RCS_AR",
          "kind": "ENG",
          "position": [
            3.1,
            0.0,
            3.75
          ],
          "quaternion": [
            0.0,
            -0.707107,
            0.0,
            0.707107
          ],
          "params": {
            "radius": 0.12
          }
        },
        {
          "name": "ENG_RCS_FL",
          "kind": "ENG",
          "position": [
            -3.1,
            0.0,
            -3.75
          ],
          "quaternion": [
            0.0,
            0.707107,
            0.0,
            0.707107
          ],
          "params": {
            "radius": 0.12
          }
        },
        {
          "name": "ENG_RCS_FR",
          "kind": "ENG",
          "position": [
            3.1,
            0.0,
            -3.75
          ],
          "quaternion": [
            0.0,
            -0.707107,
            0.0,
            0.707107
          ],
          "params": {
            "radius": 0.12
          }
        },
        {
          "name": "EYE_PILOT",
          "kind": "EYE",
          "position": [
            0.0,
            2.599999,
            -5.0
          ],
          "quaternion": [
            0.0,
            0.0,
            0.0,
            1.0
          ],
          "params": {}
        },
        {
          "name": "HP_LASER_L",
          "kind": "HP",
          "position": [
            -3.9,
            0.0,
            -4.5
          ],
          "quaternion": [
            0.0,
            0.0,
            0.0,
            1.0
          ],
          "params": {
            "size": "S"
          }
        },
        {
          "name": "HP_LASER_R",
          "kind": "HP",
          "position": [
            3.9,
            0.0,
            -4.5
          ],
          "quaternion": [
            0.0,
            0.0,
            0.0,
            1.0
          ],
          "params": {
            "size": "S"
          }
        }
      ],
      "collider": {
        "kind": "convexHulls",
        "nodes": [
          "COL_ANTENNA",
          "COL_CAB",
          "COL_DRUM",
          "COL_ENGINE",
          "COL_GUN_L",
          "COL_GUN_R",
          "COL_SPAR"
        ],
        "hullVerts": [
          8,
          8,
          20,
          8,
          8,
          8,
          8
        ]
      },
      "bounds": {
        "min": [
          -4.2,
          -3.15,
          -9.0
        ],
        "max": [
          4.2,
          5.865455,
          9.0
        ],
        "center": [
          0.0,
          1.357727,
          0.0
        ],
        "radius": 9.486703
      },
      "provenance": {
        "source": "greybox",
        "tool": "Blender 5.2.0 LTS + tools/blender/greybox_m10_relic.py",
        "humanContribution": "none",
        "license": "LicenseRef-Eclipse-Owned",
        "aiGenerated": true
      }
    },
    {
      "id": "ship.relic_salvage_tug_block",
      "kind": "model",
      "class": "ship",
      "budget": "ship_medium",
      "path": "/assets/placeholder/ship.relic_salvage_tug_block.e05bb60b.glb",
      "bytes": 128156,
      "sha256": "e05bb60b27f71b0f3f6af0cf24bbd12f6bd836c4f4570d4d74350c33c60c493e",
      "ledgerLine": "streamed.ships",
      "placeholder": true,
      "materialSlots": [
        "hull",
        "glass"
      ],
      "lod": {
        "source": "authored",
        "distances": [
          0,
          90,
          350,
          1200
        ],
        "hysteresis": 0.1,
        "tris": [
          1272,
          536,
          296,
          196
        ]
      },
      "sockets": [
        {
          "name": "ENG_MAIN_L",
          "kind": "ENG",
          "position": [
            -1.8,
            0.0,
            14.0
          ],
          "quaternion": [
            0.0,
            -1.0,
            0.0,
            0.0
          ],
          "params": {
            "radius": 1.3
          }
        },
        {
          "name": "ENG_MAIN_R",
          "kind": "ENG",
          "position": [
            1.8,
            0.0,
            14.0
          ],
          "quaternion": [
            0.0,
            -1.0,
            0.0,
            0.0
          ],
          "params": {
            "radius": 1.3
          }
        },
        {
          "name": "ENG_RETRO_L",
          "kind": "ENG",
          "position": [
            -3.0,
            0.499999,
            -8.5
          ],
          "quaternion": [
            0.0,
            0.0,
            0.0,
            1.0
          ],
          "params": {
            "radius": 0.5
          }
        },
        {
          "name": "ENG_RETRO_R",
          "kind": "ENG",
          "position": [
            3.0,
            0.499999,
            -8.5
          ],
          "quaternion": [
            0.0,
            0.0,
            0.0,
            1.0
          ],
          "params": {
            "radius": 0.5
          }
        },
        {
          "name": "EYE_PILOT",
          "kind": "EYE",
          "position": [
            0.0,
            2.199999,
            -12.5
          ],
          "quaternion": [
            0.0,
            0.0,
            0.0,
            1.0
          ],
          "params": {}
        },
        {
          "name": "HP_CUTTER_L",
          "kind": "HP",
          "position": [
            -5.0,
            1.799999,
            -16.0
          ],
          "quaternion": [
            0.0,
            0.0,
            0.0,
            1.0
          ],
          "params": {
            "size": "S"
          }
        },
        {
          "name": "HP_CUTTER_R",
          "kind": "HP",
          "position": [
            5.0,
            1.799999,
            -11.0
          ],
          "quaternion": [
            0.0,
            0.0,
            0.0,
            1.0
          ],
          "params": {
            "size": "S"
          }
        },
        {
          "name": "HP_TRACTOR",
          "kind": "HP",
          "position": [
            0.0,
            -3.200001,
            -14.5
          ],
          "quaternion": [
            0.0,
            0.0,
            0.0,
            1.0
          ],
          "params": {
            "size": "M"
          }
        }
      ],
      "collider": {
        "kind": "convexHulls",
        "nodes": [
          "COL_CAB",
          "COL_CRADLE",
          "COL_DRUM",
          "COL_ENGINE",
          "COL_GANTRY_L",
          "COL_GANTRY_R",
          "COL_STUB",
          "COL_TRACTOR"
        ],
        "hullVerts": [
          8,
          8,
          20,
          8,
          8,
          8,
          8,
          20
        ]
      },
      "bounds": {
        "min": [
          -5.5,
          -5.600001,
          -16.0
        ],
        "max": [
          5.5,
          5.18188,
          14.0
        ],
        "center": [
          0.0,
          -0.209061,
          -1.0
        ],
        "radius": 16.498262
      },
      "provenance": {
        "source": "greybox",
        "tool": "Blender 5.2.0 LTS + tools/blender/greybox_m10_relic.py",
        "humanContribution": "none",
        "license": "LicenseRef-Eclipse-Owned",
        "aiGenerated": true
      }
    },
    {
      "id": "ship.relic_skiff_block",
      "kind": "model",
      "class": "ship",
      "budget": "ship_light",
      "path": "/assets/placeholder/ship.relic_skiff_block.175816ab.glb",
      "bytes": 106084,
      "sha256": "175816ab2f39e82d15aba70c17e56c4bac70e77472ce3ad08816fe3a4bef29af",
      "ledgerLine": "streamed.ships",
      "placeholder": true,
      "materialSlots": [
        "hull",
        "glass"
      ],
      "lod": {
        "source": "authored",
        "distances": [
          0,
          50,
          200,
          700
        ],
        "hysteresis": 0.1,
        "tris": [
          896,
          464,
          364,
          204
        ]
      },
      "sockets": [
        {
          "name": "ENG_MAIN_L",
          "kind": "ENG",
          "position": [
            -1.1,
            0.0,
            11.7
          ],
          "quaternion": [
            0.0,
            -1.0,
            0.0,
            0.0
          ],
          "params": {
            "radius": 0.8
          }
        },
        {
          "name": "ENG_MAIN_R",
          "kind": "ENG",
          "position": [
            1.1,
            0.0,
            11.7
          ],
          "quaternion": [
            0.0,
            -1.0,
            0.0,
            0.0
          ],
          "params": {
            "radius": 0.8
          }
        },
        {
          "name": "ENG_RCS_AL",
          "kind": "ENG",
          "position": [
            -2.8,
            0.0,
            7.5
          ],
          "quaternion": [
            0.0,
            0.707107,
            0.0,
            0.707107
          ],
          "params": {
            "radius": 0.12
          }
        },
        {
          "name": "ENG_RCS_AR",
          "kind": "ENG",
          "position": [
            2.8,
            0.0,
            7.5
          ],
          "quaternion": [
            0.0,
            -0.707107,
            0.0,
            0.707107
          ],
          "params": {
            "radius": 0.12
          }
        },
        {
          "name": "ENG_RCS_FL",
          "kind": "ENG",
          "position": [
            -2.8,
            0.0,
            -2.0
          ],
          "quaternion": [
            0.0,
            0.707107,
            0.0,
            0.707107
          ],
          "params": {
            "radius": 0.12
          }
        },
        {
          "name": "ENG_RCS_FR",
          "kind": "ENG",
          "position": [
            2.8,
            0.0,
            -2.0
          ],
          "quaternion": [
            0.0,
            -0.707107,
            0.0,
            0.707107
          ],
          "params": {
            "radius": 0.12
          }
        },
        {
          "name": "EYE_PILOT",
          "kind": "EYE",
          "position": [
            0.0,
            3.1,
            -2.5
          ],
          "quaternion": [
            0.0,
            0.0,
            0.0,
            1.0
          ],
          "params": {}
        },
        {
          "name": "HP_LASER_L",
          "kind": "HP",
          "position": [
            -3.1,
            0.0,
            -1.0
          ],
          "quaternion": [
            0.0,
            0.0,
            0.0,
            1.0
          ],
          "params": {
            "size": "S"
          }
        },
        {
          "name": "HP_LASER_R",
          "kind": "HP",
          "position": [
            3.1,
            0.0,
            -1.0
          ],
          "quaternion": [
            0.0,
            0.0,
            0.0,
            1.0
          ],
          "params": {
            "size": "S"
          }
        }
      ],
      "collider": {
        "kind": "convexHulls",
        "nodes": [
          "COL_CAB",
          "COL_DRUM",
          "COL_ENGINE",
          "COL_GUN_L",
          "COL_GUN_R",
          "COL_RING"
        ],
        "hullVerts": [
          8,
          20,
          8,
          8,
          8,
          8
        ]
      },
      "bounds": {
        "min": [
          -4.5,
          -4.5,
          -3.4
        ],
        "max": [
          4.5,
          3.700001,
          11.699999
        ],
        "center": [
          0.0,
          -0.4,
          4.149999
        ],
        "radius": 8.334008
      },
      "provenance": {
        "source": "greybox",
        "tool": "Blender 5.2.0 LTS + tools/blender/greybox_m10_relic.py",
        "humanContribution": "none",
        "license": "LicenseRef-Eclipse-Owned",
        "aiGenerated": true
      }
    },
    {
      "id": "ship.salvager",
      "class": "ship",
      "budget": "ship_medium",
      "path": "/assets/placeholder/ship.salvager.f536c6f2.glb",
      "bytes": 99072,
      "sha256": "f536c6f2f1ba9730fd1b631ebec26c07c843ebeb01bcc19db2f71cd17f3ba544",
      "ledgerLine": "streamed.ships",
      "placeholder": true,
      "provenance": {
        "source": "greybox",
        "tool": "Blender 5.2.0 LTS + tools/blender/greybox_fleet.py",
        "humanContribution": "none",
        "license": "LicenseRef-Eclipse-Owned",
        "aiGenerated": true
      },
      "kind": "model",
      "materialSlots": [
        "hull",
        "glass",
        "emissive"
      ],
      "lod": {
        "source": "authored",
        "distances": [
          0,
          90,
          350,
          1200
        ],
        "hysteresis": 0.1,
        "tris": [
          700,
          348,
          336,
          216
        ]
      },
      "sockets": [
        {
          "name": "ENG_MAIN_L",
          "kind": "ENG",
          "position": [
            -2,
            0,
            14.1
          ],
          "quaternion": [
            0,
            -1,
            0,
            0
          ],
          "params": {
            "radius": 1.3
          }
        },
        {
          "name": "ENG_MAIN_R",
          "kind": "ENG",
          "position": [
            2,
            0,
            14.1
          ],
          "quaternion": [
            0,
            -1,
            0,
            0
          ],
          "params": {
            "radius": 1.3
          }
        },
        {
          "name": "ENG_RETRO_L",
          "kind": "ENG",
          "position": [
            -3.5,
            0.499999,
            -8
          ],
          "quaternion": [
            0,
            0,
            0,
            1
          ],
          "params": {
            "radius": 0.5
          }
        },
        {
          "name": "ENG_RETRO_R",
          "kind": "ENG",
          "position": [
            3.5,
            0.499999,
            -8
          ],
          "quaternion": [
            0,
            0,
            0,
            1
          ],
          "params": {
            "radius": 0.5
          }
        },
        {
          "name": "EYE_PILOT",
          "kind": "EYE",
          "position": [
            0,
            2.199999,
            -12.5
          ],
          "quaternion": [
            0,
            0,
            0,
            1
          ],
          "params": {}
        },
        {
          "name": "HP_CUTTER_L",
          "kind": "HP",
          "position": [
            -4.7,
            -1.100001,
            -16
          ],
          "quaternion": [
            0,
            0,
            0,
            1
          ],
          "params": {
            "size": "S"
          }
        },
        {
          "name": "HP_CUTTER_R",
          "kind": "HP",
          "position": [
            4.7,
            -1.100001,
            -16
          ],
          "quaternion": [
            0,
            0,
            0,
            1
          ],
          "params": {
            "size": "S"
          }
        },
        {
          "name": "HP_TRACTOR",
          "kind": "HP",
          "position": [
            0,
            -3.200001,
            -14.6
          ],
          "quaternion": [
            0,
            0,
            0,
            1
          ],
          "params": {
            "size": "M"
          }
        },
        {
          "name": "LIGHT_NAV_PORT",
          "kind": "LIGHT",
          "position": [
            -5.5,
            -3.5,
            2
          ],
          "quaternion": [
            0,
            0.707107,
            0,
            0.707107
          ],
          "params": {
            "blinkHz": 0,
            "color": "#FF2A1F",
            "phase": 0,
            "type": "nav"
          }
        },
        {
          "name": "LIGHT_NAV_STBD",
          "kind": "LIGHT",
          "position": [
            5.5,
            -3.5,
            2
          ],
          "quaternion": [
            0,
            -0.707107,
            0,
            0.707107
          ],
          "params": {
            "blinkHz": 0,
            "color": "#2BFF6A",
            "phase": 0,
            "type": "nav"
          }
        },
        {
          "name": "LIGHT_STROBE",
          "kind": "LIGHT",
          "position": [
            0,
            4,
            5
          ],
          "quaternion": [
            0,
            0.707107,
            -0.707107,
            0
          ],
          "params": {
            "blinkHz": 1,
            "color": "#FFFFFF",
            "phase": 0,
            "type": "strobe"
          }
        },
        {
          "name": "LIGHT_WORK_L",
          "kind": "LIGHT",
          "position": [
            -2.6,
            3.499999,
            -13
          ],
          "quaternion": [
            -0.189108,
            0,
            0,
            0.981956
          ],
          "params": {
            "blinkHz": 0,
            "color": "#FFD27A",
            "phase": 0,
            "type": "work"
          }
        },
        {
          "name": "LIGHT_WORK_R",
          "kind": "LIGHT",
          "position": [
            2.6,
            3.499999,
            -13
          ],
          "quaternion": [
            -0.189108,
            0,
            0,
            0.981956
          ],
          "params": {
            "blinkHz": 0,
            "color": "#FFD27A",
            "phase": 0,
            "type": "work"
          }
        }
      ],
      "collider": {
        "kind": "convexHulls",
        "nodes": [
          "COL_ARM_L",
          "COL_ARM_R",
          "COL_BODY",
          "COL_BOOM",
          "COL_CAB",
          "COL_CRADLE",
          "COL_ENGINE",
          "COL_TRACTOR"
        ],
        "hullVerts": [
          8,
          8,
          8,
          8,
          8,
          8,
          8,
          20
        ]
      },
      "bounds": {
        "min": [
          -5.5,
          -5.800001,
          -16
        ],
        "max": [
          5.5,
          4,
          14.1
        ],
        "center": [
          0,
          -0.9,
          -0.95
        ],
        "radius": 16.040808
      }
    },
    {
      "id": "ship.testbed_large",
      "kind": "model",
      "class": "ship",
      "budget": "ship_large",
      "path": "/assets/placeholder/ship.testbed_large.f308ad0e.glb",
      "bytes": 170796,
      "sha256": "f308ad0ec5f71e2dd0f2dcba76380c182c3be03755e61345097ff87ef71bbafc",
      "ledgerLine": "streamed.ships",
      "placeholder": true,
      "materialSlots": [
        "hull",
        "glass",
        "emissive"
      ],
      "lod": {
        "source": "authored",
        "distances": [
          0,
          270,
          1050,
          3600
        ],
        "hysteresis": 0.1,
        "tris": [
          1668,
          676,
          440,
          272
        ]
      },
      "sockets": [
        {
          "name": "DOCK_CRADLE",
          "kind": "DOCK",
          "position": [
            0,
            -0.499999,
            11
          ],
          "quaternion": [
            0,
            -0.707107,
            0,
            0.707107
          ],
          "params": {
            "bayD": 30,
            "bayH": 15,
            "bayW": 30,
            "size": "S"
          }
        },
        {
          "name": "ENG_MAIN_L",
          "kind": "ENG",
          "position": [
            -6,
            5.000005,
            72.599998
          ],
          "quaternion": [
            0,
            -1,
            0,
            0
          ],
          "params": {
            "radius": 3
          }
        },
        {
          "name": "ENG_MAIN_L2",
          "kind": "ENG",
          "position": [
            -6,
            -4.999995,
            72.599998
          ],
          "quaternion": [
            0,
            -1,
            0,
            0
          ],
          "params": {
            "radius": 3
          }
        },
        {
          "name": "ENG_MAIN_R",
          "kind": "ENG",
          "position": [
            6,
            5.000005,
            72.599998
          ],
          "quaternion": [
            0,
            -1,
            0,
            0
          ],
          "params": {
            "radius": 3
          }
        },
        {
          "name": "ENG_MAIN_R2",
          "kind": "ENG",
          "position": [
            6,
            -4.999995,
            72.599998
          ],
          "quaternion": [
            0,
            -1,
            0,
            0
          ],
          "params": {
            "radius": 3
          }
        },
        {
          "name": "EYE_PILOT",
          "kind": "EYE",
          "position": [
            0,
            5.999994,
            -74
          ],
          "quaternion": [
            0,
            0,
            0,
            1
          ],
          "params": {}
        },
        {
          "name": "HP_TURRET_A",
          "kind": "HP",
          "position": [
            0,
            14.000003,
            38
          ],
          "quaternion": [
            0,
            0,
            0,
            1
          ],
          "params": {
            "size": "M"
          }
        },
        {
          "name": "HP_TURRET_F",
          "kind": "HP",
          "position": [
            0,
            13.999997,
            -40
          ],
          "quaternion": [
            0,
            0,
            0,
            1
          ],
          "params": {
            "size": "M"
          }
        },
        {
          "name": "LIGHT_NAV_PORT",
          "kind": "LIGHT",
          "position": [
            -18.1,
            0,
            -20
          ],
          "quaternion": [
            0,
            0.707107,
            0,
            0.707107
          ],
          "params": {
            "blinkHz": 0,
            "color": "#FF2A1F",
            "phase": 0,
            "type": "nav"
          }
        },
        {
          "name": "LIGHT_NAV_STBD",
          "kind": "LIGHT",
          "position": [
            18.1,
            0,
            -20
          ],
          "quaternion": [
            0,
            -0.707107,
            0,
            0.707107
          ],
          "params": {
            "blinkHz": 0,
            "color": "#2BFF6A",
            "phase": 0,
            "type": "nav"
          }
        },
        {
          "name": "LIGHT_STROBE",
          "kind": "LIGHT",
          "position": [
            0,
            13.600001,
            9.999999
          ],
          "quaternion": [
            0,
            0.707107,
            -0.707107,
            0
          ],
          "params": {
            "blinkHz": 1,
            "color": "#FFFFFF",
            "phase": 0,
            "type": "strobe"
          }
        }
      ],
      "collider": {
        "kind": "convexHulls",
        "nodes": [
          "COL_BRIDGE",
          "COL_CORE_A",
          "COL_CORE_F",
          "COL_CRADLE_FLOOR",
          "COL_CRADLE_ROOF",
          "COL_CRADLE_WALL",
          "COL_ENGINE",
          "COL_KEEL",
          "COL_POD_L0",
          "COL_POD_L1",
          "COL_POD_L2",
          "COL_POD_R0",
          "COL_POD_R1",
          "COL_POD_R2",
          "COL_SPINE"
        ],
        "hullVerts": [
          8,
          8,
          8,
          8,
          8,
          8,
          8,
          8,
          8,
          8,
          8,
          8,
          8,
          8,
          8
        ]
      },
      "bounds": {
        "min": [
          -18.049999,
          -14.000004,
          -75.100006
        ],
        "max": [
          18.049999,
          14.000003,
          72.600006
        ],
        "center": [
          0,
          0,
          -1.25
        ],
        "radius": 74.708468
      },
      "provenance": {
        "source": "greybox",
        "tool": "Blender 5.2.0 LTS + tools/blender/greybox_m10.py",
        "humanContribution": "none",
        "license": "LicenseRef-Eclipse-Owned",
        "aiGenerated": true
      }
    },
    {
      "id": "ship.tethys_gannet_block",
      "kind": "model",
      "class": "ship",
      "budget": "ship_large",
      "path": "/assets/placeholder/ship.tethys_gannet_block.bc067879.glb",
      "bytes": 182684,
      "sha256": "bc067879283761154bde7beeadb60a1d8ca33b5479fe218e4581b4dd9d66f6b3",
      "ledgerLine": "streamed.ships",
      "placeholder": true,
      "materialSlots": [
        "hull",
        "glass",
        "emissive"
      ],
      "lod": {
        "source": "authored",
        "distances": [
          0,
          270,
          1050,
          3600
        ],
        "hysteresis": 0.1,
        "tris": [
          1712,
          688,
          524,
          368
        ]
      },
      "sockets": [
        {
          "name": "DOCK_CRADLE",
          "kind": "DOCK",
          "position": [
            0.0,
            4.0,
            7.0
          ],
          "quaternion": [
            0.5,
            0.5,
            -0.5,
            0.5
          ],
          "params": {
            "bayD": 30.0,
            "bayH": 15.0,
            "bayW": 30.0,
            "size": "S"
          }
        },
        {
          "name": "ENG_MAIN_L",
          "kind": "ENG",
          "position": [
            -18.0,
            0.500005,
            60.0
          ],
          "quaternion": [
            0.0,
            -1.0,
            0.0,
            0.0
          ],
          "params": {
            "radius": 2.8
          }
        },
        {
          "name": "ENG_MAIN_L2",
          "kind": "ENG",
          "position": [
            -18.0,
            -4.499996,
            60.0
          ],
          "quaternion": [
            0.0,
            -1.0,
            0.0,
            0.0
          ],
          "params": {
            "radius": 2.8
          }
        },
        {
          "name": "ENG_MAIN_R",
          "kind": "ENG",
          "position": [
            18.0,
            0.500005,
            60.0
          ],
          "quaternion": [
            0.0,
            -1.0,
            0.0,
            0.0
          ],
          "params": {
            "radius": 2.8
          }
        },
        {
          "name": "ENG_MAIN_R2",
          "kind": "ENG",
          "position": [
            18.0,
            -4.499996,
            60.0
          ],
          "quaternion": [
            0.0,
            -1.0,
            0.0,
            0.0
          ],
          "params": {
            "radius": 2.8
          }
        },
        {
          "name": "ENG_RETRO_L",
          "kind": "ENG",
          "position": [
            -16.0,
            -12.000002,
            -22.0
          ],
          "quaternion": [
            0.0,
            0.0,
            0.0,
            1.0
          ],
          "params": {
            "radius": 1.0
          }
        },
        {
          "name": "ENG_RETRO_R",
          "kind": "ENG",
          "position": [
            16.0,
            -12.000002,
            -22.0
          ],
          "quaternion": [
            0.0,
            0.0,
            0.0,
            1.0
          ],
          "params": {
            "radius": 1.0
          }
        },
        {
          "name": "EYE_PILOT",
          "kind": "EYE",
          "position": [
            0.0,
            18.499998,
            -27.000002
          ],
          "quaternion": [
            0.0,
            0.0,
            0.0,
            1.0
          ],
          "params": {}
        },
        {
          "name": "HP_BOOM_0",
          "kind": "HP",
          "position": [
            -15.0,
            10.999995,
            -60.0
          ],
          "quaternion": [
            0.0,
            0.0,
            0.0,
            1.0
          ],
          "params": {
            "size": "M"
          }
        },
        {
          "name": "HP_BOOM_1",
          "kind": "HP",
          "position": [
            15.0,
            10.999995,
            -60.0
          ],
          "quaternion": [
            0.0,
            0.0,
            0.0,
            1.0
          ],
          "params": {
            "size": "M"
          }
        },
        {
          "name": "HP_BOOM_2",
          "kind": "HP",
          "position": [
            -15.0,
            -11.000005,
            -60.0
          ],
          "quaternion": [
            0.0,
            0.0,
            0.0,
            1.0
          ],
          "params": {
            "size": "M"
          }
        },
        {
          "name": "HP_BOOM_3",
          "kind": "HP",
          "position": [
            15.0,
            -11.000005,
            -60.0
          ],
          "quaternion": [
            0.0,
            0.0,
            0.0,
            1.0
          ],
          "params": {
            "size": "M"
          }
        },
        {
          "name": "HP_TURRET_A",
          "kind": "HP",
          "position": [
            0.0,
            11.000002,
            27.0
          ],
          "quaternion": [
            0.0,
            0.0,
            0.0,
            1.0
          ],
          "params": {
            "size": "M"
          }
        },
        {
          "name": "HP_TURRET_T",
          "kind": "HP",
          "position": [
            0.0,
            21.999998,
            -19.000002
          ],
          "quaternion": [
            0.0,
            0.0,
            0.0,
            1.0
          ],
          "params": {
            "size": "M"
          }
        },
        {
          "name": "LIGHT_NAV_PORT",
          "kind": "LIGHT",
          "position": [
            -22.1,
            0.000003,
            38.0
          ],
          "quaternion": [
            0.0,
            0.707107,
            0.0,
            0.707107
          ],
          "params": {
            "blinkHz": 0,
            "color": "#FF2A1F",
            "phase": 0,
            "type": "nav"
          }
        },
        {
          "name": "LIGHT_NAV_STBD",
          "kind": "LIGHT",
          "position": [
            22.1,
            0.000003,
            38.0
          ],
          "quaternion": [
            0.0,
            -0.707107,
            0.0,
            0.707107
          ],
          "params": {
            "blinkHz": 0,
            "color": "#2BFF6A",
            "phase": 0,
            "type": "nav"
          }
        },
        {
          "name": "LIGHT_STROBE",
          "kind": "LIGHT",
          "position": [
            0.0,
            2.600003,
            35.0
          ],
          "quaternion": [
            0.0,
            0.707107,
            -0.707107,
            0.0
          ],
          "params": {
            "blinkHz": 1,
            "color": "#FFFFFF",
            "phase": 0,
            "type": "strobe"
          }
        }
      ],
      "collider": {
        "kind": "convexHulls",
        "nodes": [
          "COL_BOOM_LD",
          "COL_BOOM_LU",
          "COL_BOOM_RD",
          "COL_BOOM_RU",
          "COL_BRIDGE",
          "COL_COAM_A",
          "COL_COAM_F",
          "COL_COAM_L",
          "COL_COAM_R",
          "COL_COLLAR",
          "COL_CROSSBAR",
          "COL_MILL_A",
          "COL_MILL_F",
          "COL_MILL_FLOOR",
          "COL_MILL_L",
          "COL_MILL_R",
          "COL_NACELLE_L",
          "COL_NACELLE_R"
        ],
        "hullVerts": [
          8,
          8,
          8,
          8,
          8,
          8,
          8,
          8,
          8,
          8,
          8,
          8,
          8,
          8,
          8,
          8,
          8,
          8
        ]
      },
      "bounds": {
        "min": [
          -22.0,
          -15.000002,
          -60.0
        ],
        "max": [
          22.0,
          21.999998,
          60.0
        ],
        "center": [
          0.0,
          3.499998,
          0.0
        ],
        "radius": 65.133539
      },
      "provenance": {
        "source": "greybox",
        "tool": "Blender 5.2.0 LTS + tools/blender/greybox_m10_l.py",
        "humanContribution": "none",
        "license": "LicenseRef-Eclipse-Owned",
        "aiGenerated": true
      }
    },
    {
      "id": "ship.tethys_skua_block",
      "kind": "model",
      "class": "ship",
      "budget": "ship_large",
      "path": "/assets/placeholder/ship.tethys_skua_block.da401080.glb",
      "bytes": 155764,
      "sha256": "da4010805ce546f7106770bf8e1cba0118554c0fe294a182a0dc9b2ab51fecf5",
      "ledgerLine": "streamed.ships",
      "placeholder": true,
      "materialSlots": [
        "hull",
        "glass",
        "emissive"
      ],
      "lod": {
        "source": "authored",
        "distances": [
          0,
          270,
          1050,
          3600
        ],
        "hysteresis": 0.1,
        "tris": [
          1448,
          616,
          452,
          296
        ]
      },
      "sockets": [
        {
          "name": "ENG_MAIN_L",
          "kind": "ENG",
          "position": [
            -6.0,
            4.000004,
            55.0
          ],
          "quaternion": [
            0.0,
            -1.0,
            0.0,
            0.0
          ],
          "params": {
            "radius": 3.0
          }
        },
        {
          "name": "ENG_MAIN_L2",
          "kind": "ENG",
          "position": [
            -6.0,
            -3.999996,
            55.0
          ],
          "quaternion": [
            0.0,
            -1.0,
            0.0,
            0.0
          ],
          "params": {
            "radius": 3.0
          }
        },
        {
          "name": "ENG_MAIN_R",
          "kind": "ENG",
          "position": [
            6.0,
            4.000004,
            55.0
          ],
          "quaternion": [
            0.0,
            -1.0,
            0.0,
            0.0
          ],
          "params": {
            "radius": 3.0
          }
        },
        {
          "name": "ENG_MAIN_R2",
          "kind": "ENG",
          "position": [
            6.0,
            -3.999996,
            55.0
          ],
          "quaternion": [
            0.0,
            -1.0,
            0.0,
            0.0
          ],
          "params": {
            "radius": 3.0
          }
        },
        {
          "name": "ENG_RETRO_L",
          "kind": "ENG",
          "position": [
            -16.0,
            -13.000001,
            -11.999999
          ],
          "quaternion": [
            0.0,
            0.0,
            0.0,
            1.0
          ],
          "params": {
            "radius": 1.0
          }
        },
        {
          "name": "ENG_RETRO_R",
          "kind": "ENG",
          "position": [
            16.0,
            -13.000001,
            -11.999999
          ],
          "quaternion": [
            0.0,
            0.0,
            0.0,
            1.0
          ],
          "params": {
            "radius": 1.0
          }
        },
        {
          "name": "EYE_PILOT",
          "kind": "EYE",
          "position": [
            0.0,
            14.0,
            -5.000001
          ],
          "quaternion": [
            0.0,
            0.0,
            0.0,
            1.0
          ],
          "params": {}
        },
        {
          "name": "HP_TURRET_A",
          "kind": "HP",
          "position": [
            0.0,
            11.000002,
            28.0
          ],
          "quaternion": [
            0.0,
            0.0,
            0.0,
            1.0
          ],
          "params": {
            "size": "M"
          }
        },
        {
          "name": "HP_TURRET_T",
          "kind": "HP",
          "position": [
            0.0,
            17.0,
            0.0
          ],
          "quaternion": [
            0.0,
            0.0,
            0.0,
            1.0
          ],
          "params": {
            "size": "M"
          }
        },
        {
          "name": "LIGHT_NAV_PORT",
          "kind": "LIGHT",
          "position": [
            -14.1,
            0.000003,
            40.0
          ],
          "quaternion": [
            0.0,
            0.707107,
            0.0,
            0.707107
          ],
          "params": {
            "blinkHz": 0,
            "color": "#FF2A1F",
            "phase": 0,
            "type": "nav"
          }
        },
        {
          "name": "LIGHT_NAV_STBD",
          "kind": "LIGHT",
          "position": [
            14.1,
            0.000003,
            40.0
          ],
          "quaternion": [
            0.0,
            -0.707107,
            0.0,
            0.707107
          ],
          "params": {
            "blinkHz": 0,
            "color": "#2BFF6A",
            "phase": 0,
            "type": "nav"
          }
        },
        {
          "name": "LIGHT_STROBE",
          "kind": "LIGHT",
          "position": [
            0.0,
            8.600003,
            41.0
          ],
          "quaternion": [
            0.0,
            0.707107,
            -0.707107,
            0.0
          ],
          "params": {
            "blinkHz": 1,
            "color": "#FFFFFF",
            "phase": 0,
            "type": "strobe"
          }
        }
      ],
      "collider": {
        "kind": "convexHulls",
        "nodes": [
          "COL_BODY",
          "COL_BRIDGE",
          "COL_ENGINE",
          "COL_HOLD",
          "COL_JAW_D",
          "COL_JAW_U",
          "COL_RING_B",
          "COL_RING_L",
          "COL_RING_R",
          "COL_RING_T",
          "COL_SPAR_LD",
          "COL_SPAR_LU",
          "COL_SPAR_RD",
          "COL_SPAR_RU"
        ],
        "hullVerts": [
          8,
          8,
          8,
          8,
          8,
          8,
          8,
          8,
          8,
          8,
          8,
          8,
          8,
          8
        ]
      },
      "bounds": {
        "min": [
          -20.0,
          -16.0,
          -55.0
        ],
        "max": [
          20.0,
          17.0,
          55.0
        ],
        "center": [
          0.0,
          0.5,
          0.0
        ],
        "radius": 56.850531
      },
      "provenance": {
        "source": "greybox",
        "tool": "Blender 5.2.0 LTS + tools/blender/greybox_m10_l.py",
        "humanContribution": "none",
        "license": "LicenseRef-Eclipse-Owned",
        "aiGenerated": true
      }
    },
    {
      "id": "ship.varro_warhound_block",
      "kind": "model",
      "class": "ship",
      "budget": "ship_large",
      "path": "/assets/placeholder/ship.varro_warhound_block.6feced14.glb",
      "bytes": 126240,
      "sha256": "6feced148fb2d3400e5d779e31daea8b8de5f92dcfa0f699a3054bd679d1e2a4",
      "ledgerLine": "streamed.ships",
      "placeholder": true,
      "materialSlots": [
        "hull",
        "glass",
        "emissive"
      ],
      "lod": {
        "source": "authored",
        "distances": [
          0,
          270,
          1050,
          3600
        ],
        "hysteresis": 0.1,
        "tris": [
          1088,
          544,
          436,
          192
        ]
      },
      "sockets": [
        {
          "name": "ENG_MAIN_C",
          "kind": "ENG",
          "position": [
            0.0,
            0.000005,
            70.0
          ],
          "quaternion": [
            0.0,
            -1.0,
            0.0,
            0.0
          ],
          "params": {
            "radius": 3.0
          }
        },
        {
          "name": "ENG_MAIN_L",
          "kind": "ENG",
          "position": [
            -6.0,
            0.000005,
            70.0
          ],
          "quaternion": [
            0.0,
            -1.0,
            0.0,
            0.0
          ],
          "params": {
            "radius": 3.0
          }
        },
        {
          "name": "ENG_MAIN_R",
          "kind": "ENG",
          "position": [
            6.0,
            0.000005,
            70.0
          ],
          "quaternion": [
            0.0,
            -1.0,
            0.0,
            0.0
          ],
          "params": {
            "radius": 3.0
          }
        },
        {
          "name": "ENG_RETRO_L",
          "kind": "ENG",
          "position": [
            -5.0,
            -2.000005,
            -70.0
          ],
          "quaternion": [
            0.0,
            0.0,
            0.0,
            1.0
          ],
          "params": {
            "radius": 1.0
          }
        },
        {
          "name": "ENG_RETRO_R",
          "kind": "ENG",
          "position": [
            5.0,
            -2.000005,
            -70.0
          ],
          "quaternion": [
            0.0,
            0.0,
            0.0,
            1.0
          ],
          "params": {
            "radius": 1.0
          }
        },
        {
          "name": "EYE_PILOT",
          "kind": "EYE",
          "position": [
            0.0,
            12.999998,
            -19.000002
          ],
          "quaternion": [
            0.0,
            0.0,
            0.0,
            1.0
          ],
          "params": {}
        },
        {
          "name": "HP_TURRET_AL",
          "kind": "HP",
          "position": [
            -11.0,
            3.000001,
            20.0
          ],
          "quaternion": [
            0.0,
            0.0,
            0.0,
            1.0
          ],
          "params": {
            "size": "M"
          }
        },
        {
          "name": "HP_TURRET_AR",
          "kind": "HP",
          "position": [
            11.0,
            3.000001,
            20.0
          ],
          "quaternion": [
            0.0,
            0.0,
            0.0,
            1.0
          ],
          "params": {
            "size": "M"
          }
        },
        {
          "name": "HP_TURRET_FL",
          "kind": "HP",
          "position": [
            -11.0,
            2.999998,
            -30.0
          ],
          "quaternion": [
            0.0,
            0.0,
            0.0,
            1.0
          ],
          "params": {
            "size": "M"
          }
        },
        {
          "name": "HP_TURRET_FR",
          "kind": "HP",
          "position": [
            11.0,
            2.999998,
            -30.0
          ],
          "quaternion": [
            0.0,
            0.0,
            0.0,
            1.0
          ],
          "params": {
            "size": "M"
          }
        },
        {
          "name": "LIGHT_NAV_PORT",
          "kind": "LIGHT",
          "position": [
            -15.6,
            0.0,
            10.0
          ],
          "quaternion": [
            0.0,
            0.707107,
            0.0,
            0.707107
          ],
          "params": {
            "blinkHz": 0,
            "color": "#FF2A1F",
            "phase": 0,
            "type": "nav"
          }
        },
        {
          "name": "LIGHT_NAV_STBD",
          "kind": "LIGHT",
          "position": [
            15.6,
            0.0,
            10.0
          ],
          "quaternion": [
            0.0,
            -0.707107,
            0.0,
            0.707107
          ],
          "params": {
            "blinkHz": 0,
            "color": "#2BFF6A",
            "phase": 0,
            "type": "nav"
          }
        },
        {
          "name": "LIGHT_STROBE",
          "kind": "LIGHT",
          "position": [
            0.0,
            8.600004,
            53.0
          ],
          "quaternion": [
            0.0,
            0.707107,
            -0.707107,
            0.0
          ],
          "params": {
            "blinkHz": 1,
            "color": "#FFFFFF",
            "phase": 0,
            "type": "strobe"
          }
        }
      ],
      "collider": {
        "kind": "convexHulls",
        "nodes": [
          "COL_BRIDGE",
          "COL_CHINE_L",
          "COL_CHINE_R",
          "COL_ENGINE",
          "COL_KEEL",
          "COL_PROW",
          "COL_SPINE"
        ],
        "hullVerts": [
          8,
          8,
          8,
          8,
          8,
          8,
          8
        ]
      },
      "bounds": {
        "min": [
          -15.101816,
          -12.000003,
          -70.0
        ],
        "max": [
          15.101816,
          16.0,
          70.0
        ],
        "center": [
          0.0,
          1.999999,
          0.0
        ],
        "radius": 70.617645
      },
      "provenance": {
        "source": "greybox",
        "tool": "Blender 5.2.0 LTS + tools/blender/greybox_m10_l.py",
        "humanContribution": "none",
        "license": "LicenseRef-Eclipse-Owned",
        "aiGenerated": true
      }
    },
    {
      "id": "ship.voss_yacht",
      "class": "ship",
      "budget": "ship_light",
      "path": "/assets/placeholder/ship.voss_yacht.a7788efa.glb",
      "bytes": 90308,
      "sha256": "a7788efacf716cea635ca4e7c7d507300ce40371459c5b98a39fb83d39dc8516",
      "ledgerLine": "streamed.ships",
      "placeholder": true,
      "provenance": {
        "source": "greybox",
        "tool": "Blender 5.2.0 LTS + tools/blender/greybox_story.py",
        "humanContribution": "none",
        "license": "LicenseRef-Eclipse-Owned",
        "aiGenerated": true
      },
      "kind": "model",
      "materialSlots": [
        "hull",
        "glass",
        "emissive"
      ],
      "lod": {
        "source": "authored",
        "distances": [
          0,
          50,
          200,
          700
        ],
        "hysteresis": 0.1,
        "tris": [
          664,
          312,
          300,
          168
        ]
      },
      "sockets": [
        {
          "name": "DOCK_AIRLOCK",
          "kind": "DOCK",
          "position": [
            0,
            -1.2,
            -2
          ],
          "quaternion": [
            -0.707107,
            0,
            0,
            0.707107
          ],
          "params": {
            "size": "S"
          }
        },
        {
          "name": "ENG_MAIN_L",
          "kind": "ENG",
          "position": [
            -1.4,
            0,
            8.6
          ],
          "quaternion": [
            0,
            -1,
            0,
            0
          ],
          "params": {
            "radius": 1
          }
        },
        {
          "name": "ENG_MAIN_R",
          "kind": "ENG",
          "position": [
            1.4,
            0,
            8.6
          ],
          "quaternion": [
            0,
            -1,
            0,
            0
          ],
          "params": {
            "radius": 1
          }
        },
        {
          "name": "EYE_PILOT",
          "kind": "EYE",
          "position": [
            0,
            1.4,
            -5.5
          ],
          "quaternion": [
            0,
            0,
            0,
            1
          ],
          "params": {}
        },
        {
          "name": "HP_LASER_L",
          "kind": "HP",
          "position": [
            -2.45,
            -0.6,
            -5
          ],
          "quaternion": [
            0,
            0,
            0,
            1
          ],
          "params": {
            "size": "S"
          }
        },
        {
          "name": "HP_LASER_R",
          "kind": "HP",
          "position": [
            2.45,
            -0.6,
            -5
          ],
          "quaternion": [
            0,
            0,
            0,
            1
          ],
          "params": {
            "size": "S"
          }
        },
        {
          "name": "LIGHT_NAV_PORT",
          "kind": "LIGHT",
          "position": [
            -5.8,
            0,
            4
          ],
          "quaternion": [
            0,
            0.707107,
            0,
            0.707107
          ],
          "params": {
            "blinkHz": 0,
            "color": "#FF2A1F",
            "phase": 0,
            "type": "nav"
          }
        },
        {
          "name": "LIGHT_NAV_STBD",
          "kind": "LIGHT",
          "position": [
            5.8,
            0,
            4
          ],
          "quaternion": [
            0,
            -0.707107,
            0,
            0.707107
          ],
          "params": {
            "blinkHz": 0,
            "color": "#2BFF6A",
            "phase": 0,
            "type": "nav"
          }
        },
        {
          "name": "LIGHT_STROBE",
          "kind": "LIGHT",
          "position": [
            0,
            3.200001,
            6
          ],
          "quaternion": [
            0,
            0.707107,
            -0.707107,
            0
          ],
          "params": {
            "blinkHz": 1,
            "color": "#FFFFFF",
            "phase": 0,
            "type": "strobe"
          }
        }
      ],
      "collider": {
        "kind": "convexHulls",
        "nodes": [
          "COL_FIN",
          "COL_HULL",
          "COL_NOSE",
          "COL_PODS",
          "COL_WING_L",
          "COL_WING_R"
        ],
        "hullVerts": [
          8,
          8,
          20,
          8,
          8,
          8
        ]
      },
      "bounds": {
        "min": [
          -5.8,
          -1.8,
          -10
        ],
        "max": [
          5.8,
          3.200001,
          8.6
        ],
        "center": [
          0,
          0.7,
          -0.7
        ],
        "radius": 9.619565
      }
    },
    {
      "id": "station.clinic",
      "kind": "model",
      "class": "station",
      "budget": "station",
      "path": "/assets/placeholder/station.clinic.711bb8de.glb",
      "bytes": 98524,
      "sha256": "711bb8de6b1dd6a0574000ff928dbda61d56b8afd0c4b15d044234e3201d2db9",
      "ledgerLine": "placeholders_m4",
      "placeholder": true,
      "materialSlots": [
        "hull",
        "emissive"
      ],
      "lod": {
        "source": "authored",
        "distances": [
          0,
          2357,
          3636
        ],
        "hysteresis": 0.1,
        "tris": [
          1192,
          572,
          216
        ]
      },
      "sockets": [
        {
          "name": "DOCK_BAY_0",
          "kind": "DOCK",
          "position": [
            0,
            -87.500015,
            -187.25
          ],
          "quaternion": [
            0,
            0,
            0,
            1
          ],
          "params": {
            "bayD": 80,
            "bayH": 26,
            "bayW": 44,
            "size": "M"
          }
        },
        {
          "name": "LIGHT_BAY_BL",
          "kind": "LIGHT",
          "position": [
            -21,
            -99.500015,
            -226.25
          ],
          "quaternion": [
            -0.001656,
            -0.969635,
            -0.006567,
            0.244462
          ],
          "params": {
            "blinkHz": 0,
            "color": "#FFD27A",
            "phase": 0,
            "type": "work"
          }
        },
        {
          "name": "LIGHT_BAY_BR",
          "kind": "LIGHT",
          "position": [
            21,
            -99.500015,
            -226.25
          ],
          "quaternion": [
            -0.001656,
            0.969635,
            0.006567,
            0.244462
          ],
          "params": {
            "blinkHz": 0,
            "color": "#FFD27A",
            "phase": 0,
            "type": "work"
          }
        },
        {
          "name": "LIGHT_BAY_TL",
          "kind": "LIGHT",
          "position": [
            -21,
            -75.500015,
            -226.25
          ],
          "quaternion": [
            -0.061306,
            -0.938673,
            -0.243165,
            0.236656
          ],
          "params": {
            "blinkHz": 0,
            "color": "#FFD27A",
            "phase": 0,
            "type": "work"
          }
        },
        {
          "name": "LIGHT_BAY_TR",
          "kind": "LIGHT",
          "position": [
            21,
            -75.500015,
            -226.25
          ],
          "quaternion": [
            -0.061306,
            0.938673,
            0.243165,
            0.236656
          ],
          "params": {
            "blinkHz": 0,
            "color": "#FFD27A",
            "phase": 0,
            "type": "work"
          }
        },
        {
          "name": "LIGHT_BEACON",
          "kind": "LIGHT",
          "position": [
            0,
            246.899994,
            52.749981
          ],
          "quaternion": [
            0,
            0.707107,
            -0.707107,
            0
          ],
          "params": {
            "blinkHz": 0.5,
            "color": "#FF2A1F",
            "phase": 0,
            "type": "strobe"
          }
        },
        {
          "name": "LIGHT_NAV_PORT",
          "kind": "LIGHT",
          "position": [
            -25,
            -87.500015,
            -228.25
          ],
          "quaternion": [
            0,
            0.707107,
            0,
            0.707107
          ],
          "params": {
            "blinkHz": 0,
            "color": "#FF2A1F",
            "phase": 0,
            "type": "nav"
          }
        },
        {
          "name": "LIGHT_NAV_STBD",
          "kind": "LIGHT",
          "position": [
            25,
            -87.500015,
            -228.25
          ],
          "quaternion": [
            0,
            -0.707107,
            0,
            0.707107
          ],
          "params": {
            "blinkHz": 0,
            "color": "#2BFF6A",
            "phase": 0,
            "type": "nav"
          }
        }
      ],
      "collider": {
        "kind": "trimesh",
        "nodes": [
          "COL_STATION"
        ],
        "triangles": 432
      },
      "bounds": {
        "min": [
          -176.5,
          -245.5,
          -227.75
        ],
        "max": [
          176.5,
          245.5,
          227.75
        ],
        "center": [
          0,
          0,
          0
        ],
        "radius": 272.699119
      },
      "provenance": {
        "source": "greybox",
        "tool": "Blender 5.2.0 LTS + tools/blender/greybox_economy.py",
        "humanContribution": "none",
        "license": "LicenseRef-Eclipse-Owned",
        "aiGenerated": true
      }
    },
    {
      "id": "station.defense_platform",
      "kind": "model",
      "class": "station",
      "budget": "station",
      "path": "/assets/placeholder/station.defense_platform.d90c8647.glb",
      "bytes": 91628,
      "sha256": "d90c8647dee8e3af94cdb7ce4e700fff0d0e7971a8311f85f919e8c2278fab95",
      "ledgerLine": "placeholders_m6",
      "placeholder": true,
      "materialSlots": [
        "hull",
        "emissive"
      ],
      "lod": {
        "source": "authored",
        "distances": [
          0,
          2526,
          4848
        ],
        "hysteresis": 0.1,
        "tris": [
          760,
          520,
          284
        ]
      },
      "sockets": [
        {
          "name": "DOCK_BAY_0",
          "kind": "DOCK",
          "position": [
            0,
            -67.468102,
            -258.75
          ],
          "quaternion": [
            0,
            0,
            0,
            1
          ],
          "params": {
            "bayD": 80,
            "bayH": 26,
            "bayW": 44,
            "size": "M"
          }
        },
        {
          "name": "LIGHT_BAY_BL",
          "kind": "LIGHT",
          "position": [
            -21,
            -79.468102,
            -297.75
          ],
          "quaternion": [
            -0.001656,
            -0.969635,
            -0.006567,
            0.244462
          ],
          "params": {
            "blinkHz": 0,
            "color": "#FFD27A",
            "phase": 0,
            "type": "work"
          }
        },
        {
          "name": "LIGHT_BAY_BR",
          "kind": "LIGHT",
          "position": [
            21,
            -79.468102,
            -297.75
          ],
          "quaternion": [
            -0.001656,
            0.969635,
            0.006567,
            0.244462
          ],
          "params": {
            "blinkHz": 0,
            "color": "#FFD27A",
            "phase": 0,
            "type": "work"
          }
        },
        {
          "name": "LIGHT_BAY_TL",
          "kind": "LIGHT",
          "position": [
            -21,
            -55.468102,
            -297.75
          ],
          "quaternion": [
            -0.061306,
            -0.938673,
            -0.243165,
            0.236656
          ],
          "params": {
            "blinkHz": 0,
            "color": "#FFD27A",
            "phase": 0,
            "type": "work"
          }
        },
        {
          "name": "LIGHT_BAY_TR",
          "kind": "LIGHT",
          "position": [
            21,
            -55.468102,
            -297.75
          ],
          "quaternion": [
            -0.061306,
            0.938673,
            0.243165,
            0.236656
          ],
          "params": {
            "blinkHz": 0,
            "color": "#FFD27A",
            "phase": 0,
            "type": "work"
          }
        },
        {
          "name": "LIGHT_BEACON",
          "kind": "LIGHT",
          "position": [
            0,
            253.295288,
            86.344322
          ],
          "quaternion": [
            0,
            0.707107,
            -0.707107,
            0
          ],
          "params": {
            "blinkHz": 0.5,
            "color": "#FF2A1F",
            "phase": 0,
            "type": "strobe"
          }
        },
        {
          "name": "LIGHT_NAV_PORT",
          "kind": "LIGHT",
          "position": [
            -25,
            -67.468102,
            -299.75
          ],
          "quaternion": [
            0,
            0.707107,
            0,
            0.707107
          ],
          "params": {
            "blinkHz": 0,
            "color": "#FF2A1F",
            "phase": 0,
            "type": "nav"
          }
        },
        {
          "name": "LIGHT_NAV_STBD",
          "kind": "LIGHT",
          "position": [
            25,
            -67.468102,
            -299.75
          ],
          "quaternion": [
            0,
            -0.707107,
            0,
            0.707107
          ],
          "params": {
            "blinkHz": 0,
            "color": "#2BFF6A",
            "phase": 0,
            "type": "nav"
          }
        }
      ],
      "collider": {
        "kind": "trimesh",
        "nodes": [
          "COL_STATION"
        ],
        "triangles": 444
      },
      "bounds": {
        "min": [
          -299.788391,
          -262.468079,
          -299.25
        ],
        "max": [
          299.788391,
          262.468079,
          299.25
        ],
        "center": [
          0,
          0,
          0
        ],
        "radius": 363.541287
      },
      "provenance": {
        "source": "greybox",
        "tool": "Blender 5.2.0 LTS + tools/blender/greybox_fleet.py",
        "humanContribution": "none",
        "license": "LicenseRef-Eclipse-Owned",
        "aiGenerated": true
      }
    },
    {
      "id": "station.fabworks",
      "kind": "model",
      "class": "station",
      "budget": "station",
      "path": "/assets/placeholder/station.fabworks.1e2f269f.glb",
      "bytes": 67336,
      "sha256": "1e2f269f0425f99f46480047c454e33efa1a34dd78c11a506795359b3a093e0e",
      "ledgerLine": "placeholders_m4",
      "placeholder": true,
      "materialSlots": [
        "hull",
        "emissive"
      ],
      "lod": {
        "source": "authored",
        "distances": [
          0,
          3393,
          11092
        ],
        "hysteresis": 0.1,
        "tris": [
          756,
          344,
          116
        ]
      },
      "sockets": [
        {
          "name": "DOCK_BAY_0",
          "kind": "DOCK",
          "position": [
            -56,
            -417.271118,
            -509.749969
          ],
          "quaternion": [
            0,
            0,
            0,
            1
          ],
          "params": {
            "bayD": 80,
            "bayH": 26,
            "bayW": 44,
            "size": "M"
          }
        },
        {
          "name": "LIGHT_BAY_BL",
          "kind": "LIGHT",
          "position": [
            -77,
            -429.271118,
            -548.749939
          ],
          "quaternion": [
            -0.001656,
            -0.969635,
            -0.006567,
            0.244462
          ],
          "params": {
            "blinkHz": 0,
            "color": "#FFD27A",
            "phase": 0,
            "type": "work"
          }
        },
        {
          "name": "LIGHT_BAY_BR",
          "kind": "LIGHT",
          "position": [
            -35,
            -429.271118,
            -548.749939
          ],
          "quaternion": [
            -0.001656,
            0.969635,
            0.006567,
            0.244462
          ],
          "params": {
            "blinkHz": 0,
            "color": "#FFD27A",
            "phase": 0,
            "type": "work"
          }
        },
        {
          "name": "LIGHT_BAY_TL",
          "kind": "LIGHT",
          "position": [
            -77,
            -405.271118,
            -548.749939
          ],
          "quaternion": [
            -0.061306,
            -0.938673,
            -0.243165,
            0.236656
          ],
          "params": {
            "blinkHz": 0,
            "color": "#FFD27A",
            "phase": 0,
            "type": "work"
          }
        },
        {
          "name": "LIGHT_BAY_TR",
          "kind": "LIGHT",
          "position": [
            -35,
            -405.271118,
            -548.749939
          ],
          "quaternion": [
            -0.061306,
            0.938673,
            0.243165,
            0.236656
          ],
          "params": {
            "blinkHz": 0,
            "color": "#FFD27A",
            "phase": 0,
            "type": "work"
          }
        },
        {
          "name": "LIGHT_BEACON",
          "kind": "LIGHT",
          "position": [
            0,
            433.128937,
            270.249969
          ],
          "quaternion": [
            0,
            0.707107,
            -0.707107,
            0
          ],
          "params": {
            "blinkHz": 0.5,
            "color": "#FF2A1F",
            "phase": 0,
            "type": "strobe"
          }
        },
        {
          "name": "LIGHT_NAV_PORT",
          "kind": "LIGHT",
          "position": [
            -81,
            -417.271118,
            -550.749939
          ],
          "quaternion": [
            0,
            0.707107,
            0,
            0.707107
          ],
          "params": {
            "blinkHz": 0,
            "color": "#FF2A1F",
            "phase": 0,
            "type": "nav"
          }
        },
        {
          "name": "LIGHT_NAV_STBD",
          "kind": "LIGHT",
          "position": [
            -31,
            -417.271118,
            -550.749939
          ],
          "quaternion": [
            0,
            -0.707107,
            0,
            0.707107
          ],
          "params": {
            "blinkHz": 0,
            "color": "#2BFF6A",
            "phase": 0,
            "type": "nav"
          }
        }
      ],
      "collider": {
        "kind": "trimesh",
        "nodes": [
          "COL_STATION"
        ],
        "triangles": 308
      },
      "bounds": {
        "min": [
          -346.28125,
          -627.271118,
          -550.25
        ],
        "max": [
          346.28125,
          627.271057,
          550.25
        ],
        "center": [
          0,
          -0.000031,
          0
        ],
        "radius": 831.836843
      },
      "provenance": {
        "source": "greybox",
        "tool": "Blender 5.2.0 LTS + tools/blender/greybox_economy.py",
        "humanContribution": "none",
        "license": "LicenseRef-Eclipse-Owned",
        "aiGenerated": true
      }
    },
    {
      "id": "station.hub",
      "class": "station",
      "budget": "station",
      "path": "/assets/station/station.hub.d861f095.glb",
      "bytes": 1735084,
      "sha256": "d861f095458cff4c9aee5b35f637602e38eac1e58bff324a729956f4e868e9ad",
      "ledgerLine": "station.hub",
      "placeholder": false,
      "provenance": {
        "source": "procedural-ts",
        "tool": "Node 24.15.0 + tools/assetkit + assets-src/station.hub/build.ts @ sha256:db63f549e226",
        "humanContribution": "none",
        "license": "LicenseRef-Eclipse-Owned",
        "aiGenerated": true,
        "manifestRef": "station.hub"
      },
      "kind": "model",
      "materialSlots": [
        "hull",
        "emissive",
        "decal"
      ],
      "lod": {
        "source": "authored",
        "distances": [
          0,
          6046,
          20151,
          60453
        ],
        "hysteresis": 0.1,
        "tris": [
          52728,
          21828,
          6102,
          1622
        ]
      },
      "sockets": [
        {
          "name": "DOCK_BAY_0",
          "kind": "DOCK",
          "position": [
            0,
            -387.114014,
            -1325
          ],
          "quaternion": [
            0,
            0,
            0,
            1
          ],
          "params": {
            "bayD": 80,
            "bayH": 26,
            "bayW": 44,
            "size": "M"
          }
        },
        {
          "name": "DOCK_BAY_1",
          "kind": "DOCK",
          "position": [
            -1325,
            -387.114014,
            0
          ],
          "quaternion": [
            0,
            0.707107,
            0,
            0.707107
          ],
          "params": {
            "bayD": 80,
            "bayH": 26,
            "bayW": 44,
            "size": "M"
          }
        },
        {
          "name": "DOCK_BAY_2",
          "kind": "DOCK",
          "position": [
            0,
            -387.114014,
            1325
          ],
          "quaternion": [
            0,
            1,
            0,
            0
          ],
          "params": {
            "bayD": 80,
            "bayH": 26,
            "bayW": 44,
            "size": "M"
          }
        },
        {
          "name": "DOCK_BAY_3",
          "kind": "DOCK",
          "position": [
            1325,
            -387.114014,
            0
          ],
          "quaternion": [
            0,
            -0.707107,
            0,
            0.707107
          ],
          "params": {
            "bayD": 80,
            "bayH": 26,
            "bayW": 44,
            "size": "M"
          }
        },
        {
          "name": "LIGHT_BAY_BL",
          "kind": "LIGHT",
          "position": [
            -21,
            -399.114014,
            -1364
          ],
          "quaternion": [
            0,
            0,
            0,
            1
          ],
          "params": {
            "blinkHz": 0,
            "color": "#FFD27A",
            "phase": 0,
            "type": "work"
          }
        },
        {
          "name": "LIGHT_BAY_BR",
          "kind": "LIGHT",
          "position": [
            21,
            -399.114014,
            -1364
          ],
          "quaternion": [
            0,
            0,
            0,
            1
          ],
          "params": {
            "blinkHz": 0,
            "color": "#FFD27A",
            "phase": 0,
            "type": "work"
          }
        },
        {
          "name": "LIGHT_BAY_TL",
          "kind": "LIGHT",
          "position": [
            -21,
            -375.114014,
            -1364
          ],
          "quaternion": [
            0,
            0,
            0,
            1
          ],
          "params": {
            "blinkHz": 0,
            "color": "#FFD27A",
            "phase": 0,
            "type": "work"
          }
        },
        {
          "name": "LIGHT_BAY_TR",
          "kind": "LIGHT",
          "position": [
            21,
            -375.114014,
            -1364
          ],
          "quaternion": [
            0,
            0,
            0,
            1
          ],
          "params": {
            "blinkHz": 0,
            "color": "#FFD27A",
            "phase": 0,
            "type": "work"
          }
        },
        {
          "name": "LIGHT_BEACON",
          "kind": "LIGHT",
          "position": [
            0,
            1218.39905,
            0
          ],
          "quaternion": [
            0,
            -0.707107,
            0.707107,
            0
          ],
          "params": {
            "blinkHz": 0.5,
            "color": "#FF2A1F",
            "phase": 0,
            "type": "strobe"
          }
        },
        {
          "name": "LIGHT_CHAIN_00",
          "kind": "LIGHT",
          "position": [
            0,
            -217.854004,
            -1364.19995
          ],
          "quaternion": [
            0,
            0,
            0,
            1
          ],
          "params": {
            "blinkHz": 1,
            "color": "#CFE6FF",
            "phase": 0,
            "type": "strobe"
          }
        },
        {
          "name": "LIGHT_CHAIN_01",
          "kind": "LIGHT",
          "position": [
            0,
            -239.854004,
            -1364.19995
          ],
          "quaternion": [
            0,
            0,
            0,
            1
          ],
          "params": {
            "blinkHz": 1,
            "color": "#CFE6FF",
            "phase": 0.2,
            "type": "strobe"
          }
        },
        {
          "name": "LIGHT_CHAIN_02",
          "kind": "LIGHT",
          "position": [
            0,
            -261.854004,
            -1364.19995
          ],
          "quaternion": [
            0,
            0,
            0,
            1
          ],
          "params": {
            "blinkHz": 1,
            "color": "#CFE6FF",
            "phase": 0.4,
            "type": "strobe"
          }
        },
        {
          "name": "LIGHT_CHAIN_03",
          "kind": "LIGHT",
          "position": [
            0,
            -283.854004,
            -1364.19995
          ],
          "quaternion": [
            0,
            0,
            0,
            1
          ],
          "params": {
            "blinkHz": 1,
            "color": "#CFE6FF",
            "phase": 0.6,
            "type": "strobe"
          }
        },
        {
          "name": "LIGHT_CHAIN_04",
          "kind": "LIGHT",
          "position": [
            0,
            -305.854004,
            -1364.19995
          ],
          "quaternion": [
            0,
            0,
            0,
            1
          ],
          "params": {
            "blinkHz": 1,
            "color": "#CFE6FF",
            "phase": 0.8,
            "type": "strobe"
          }
        },
        {
          "name": "LIGHT_MAST_0",
          "kind": "LIGHT",
          "position": [
            0,
            1014.19501,
            -15.515
          ],
          "quaternion": [
            0,
            0,
            0,
            1
          ],
          "params": {
            "blinkHz": 0.5,
            "color": "#CFE6FF",
            "phase": 0.5,
            "type": "strobe"
          }
        },
        {
          "name": "LIGHT_MAST_1",
          "kind": "LIGHT",
          "position": [
            0,
            1121.07446,
            -15.515
          ],
          "quaternion": [
            0,
            0,
            0,
            1
          ],
          "params": {
            "blinkHz": 0.5,
            "color": "#CFE6FF",
            "phase": 0.75,
            "type": "strobe"
          }
        },
        {
          "name": "LIGHT_MAST_2",
          "kind": "LIGHT",
          "position": [
            -213.759003,
            942.942017,
            -15.515
          ],
          "quaternion": [
            0,
            0,
            0,
            1
          ],
          "params": {
            "blinkHz": 0.5,
            "color": "#CFE6FF",
            "phase": 0,
            "type": "strobe"
          }
        },
        {
          "name": "LIGHT_MAST_3",
          "kind": "LIGHT",
          "position": [
            -213.759003,
            1037.94604,
            -15.515
          ],
          "quaternion": [
            0,
            0,
            0,
            1
          ],
          "params": {
            "blinkHz": 0.5,
            "color": "#CFE6FF",
            "phase": 0.25,
            "type": "strobe"
          }
        },
        {
          "name": "LIGHT_MAST_4",
          "kind": "LIGHT",
          "position": [
            213.759003,
            942.942017,
            -15.515
          ],
          "quaternion": [
            0,
            0,
            0,
            1
          ],
          "params": {
            "blinkHz": 0.5,
            "color": "#CFE6FF",
            "phase": 0,
            "type": "strobe"
          }
        },
        {
          "name": "LIGHT_MAST_5",
          "kind": "LIGHT",
          "position": [
            213.759003,
            1037.94604,
            -15.515
          ],
          "quaternion": [
            0,
            0,
            0,
            1
          ],
          "params": {
            "blinkHz": 0.5,
            "color": "#CFE6FF",
            "phase": 0.25,
            "type": "strobe"
          }
        },
        {
          "name": "LIGHT_NAV1_PORT",
          "kind": "LIGHT",
          "position": [
            -1366.19995,
            -387.114014,
            26.5
          ],
          "quaternion": [
            0,
            0.707107,
            0,
            0.707107
          ],
          "params": {
            "blinkHz": 0,
            "color": "#FF2A1F",
            "phase": 0,
            "type": "nav"
          }
        },
        {
          "name": "LIGHT_NAV1_STBD",
          "kind": "LIGHT",
          "position": [
            -1366.19995,
            -387.114014,
            -26.5
          ],
          "quaternion": [
            0,
            0.707107,
            0,
            0.707107
          ],
          "params": {
            "blinkHz": 0,
            "color": "#2BFF6A",
            "phase": 0,
            "type": "nav"
          }
        },
        {
          "name": "LIGHT_NAV2_PORT",
          "kind": "LIGHT",
          "position": [
            26.5,
            -387.114014,
            1366.19995
          ],
          "quaternion": [
            0,
            1,
            0,
            0
          ],
          "params": {
            "blinkHz": 0,
            "color": "#FF2A1F",
            "phase": 0,
            "type": "nav"
          }
        },
        {
          "name": "LIGHT_NAV2_STBD",
          "kind": "LIGHT",
          "position": [
            -26.5,
            -387.114014,
            1366.19995
          ],
          "quaternion": [
            0,
            1,
            0,
            0
          ],
          "params": {
            "blinkHz": 0,
            "color": "#2BFF6A",
            "phase": 0,
            "type": "nav"
          }
        },
        {
          "name": "LIGHT_NAV3_PORT",
          "kind": "LIGHT",
          "position": [
            1366.19995,
            -387.114014,
            -26.5
          ],
          "quaternion": [
            0,
            -0.707107,
            0,
            0.707107
          ],
          "params": {
            "blinkHz": 0,
            "color": "#FF2A1F",
            "phase": 0,
            "type": "nav"
          }
        },
        {
          "name": "LIGHT_NAV3_STBD",
          "kind": "LIGHT",
          "position": [
            1366.19995,
            -387.114014,
            26.5
          ],
          "quaternion": [
            0,
            -0.707107,
            0,
            0.707107
          ],
          "params": {
            "blinkHz": 0,
            "color": "#2BFF6A",
            "phase": 0,
            "type": "nav"
          }
        },
        {
          "name": "LIGHT_NAV_PORT",
          "kind": "LIGHT",
          "position": [
            -26.5,
            -387.114014,
            -1366.19995
          ],
          "quaternion": [
            0,
            0,
            0,
            1
          ],
          "params": {
            "blinkHz": 0,
            "color": "#FF2A1F",
            "phase": 0,
            "type": "nav"
          }
        },
        {
          "name": "LIGHT_NAV_STBD",
          "kind": "LIGHT",
          "position": [
            26.5,
            -387.114014,
            -1366.19995
          ],
          "quaternion": [
            0,
            0,
            0,
            1
          ],
          "params": {
            "blinkHz": 0,
            "color": "#2BFF6A",
            "phase": 0,
            "type": "nav"
          }
        }
      ],
      "collider": {
        "kind": "trimesh",
        "nodes": [
          "COL_TRIMESH_00"
        ],
        "triangles": 6102
      },
      "bounds": {
        "min": [
          -1365.80005,
          -1218.39905,
          -1365.80005
        ],
        "max": [
          1365.800113,
          1218.387533,
          1365.800113
        ],
        "center": [
          0.000031,
          -0.005758,
          0.000031
        ],
        "radius": 1511.310679
      }
    },
    {
      "id": "station.hydro",
      "kind": "model",
      "class": "station",
      "budget": "station",
      "path": "/assets/placeholder/station.hydro.df050774.glb",
      "bytes": 110348,
      "sha256": "df05077480872cc988f2419255170e147a21bd59e771c073a7f1645eac8d6a2f",
      "ledgerLine": "placeholders_m4",
      "placeholder": true,
      "materialSlots": [
        "hull",
        "emissive"
      ],
      "lod": {
        "source": "authored",
        "distances": [
          0,
          2976,
          8089
        ],
        "hysteresis": 0.1,
        "tris": [
          1184,
          652,
          284
        ]
      },
      "sockets": [
        {
          "name": "DOCK_BAY_0",
          "kind": "DOCK",
          "position": [
            -28,
            -265.000031,
            -455.749969
          ],
          "quaternion": [
            0,
            0,
            0,
            1
          ],
          "params": {
            "bayD": 80,
            "bayH": 26,
            "bayW": 44,
            "size": "M"
          }
        },
        {
          "name": "LIGHT_BAY_BL",
          "kind": "LIGHT",
          "position": [
            -49,
            -277.000031,
            -494.749969
          ],
          "quaternion": [
            -0.001656,
            -0.969635,
            -0.006567,
            0.244462
          ],
          "params": {
            "blinkHz": 0,
            "color": "#FFD27A",
            "phase": 0,
            "type": "work"
          }
        },
        {
          "name": "LIGHT_BAY_BR",
          "kind": "LIGHT",
          "position": [
            -7,
            -277.000031,
            -494.749969
          ],
          "quaternion": [
            -0.001656,
            0.969635,
            0.006567,
            0.244462
          ],
          "params": {
            "blinkHz": 0,
            "color": "#FFD27A",
            "phase": 0,
            "type": "work"
          }
        },
        {
          "name": "LIGHT_BAY_TL",
          "kind": "LIGHT",
          "position": [
            -49,
            -253.000031,
            -494.749969
          ],
          "quaternion": [
            -0.061306,
            -0.938673,
            -0.243165,
            0.236656
          ],
          "params": {
            "blinkHz": 0,
            "color": "#FFD27A",
            "phase": 0,
            "type": "work"
          }
        },
        {
          "name": "LIGHT_BAY_TR",
          "kind": "LIGHT",
          "position": [
            -7,
            -253.000031,
            -494.749969
          ],
          "quaternion": [
            -0.061306,
            0.938673,
            0.243165,
            0.236656
          ],
          "params": {
            "blinkHz": 0,
            "color": "#FFD27A",
            "phase": 0,
            "type": "work"
          }
        },
        {
          "name": "LIGHT_BEACON",
          "kind": "LIGHT",
          "position": [
            0,
            446.399994,
            64.249969
          ],
          "quaternion": [
            0,
            0.707107,
            -0.707107,
            0
          ],
          "params": {
            "blinkHz": 0.5,
            "color": "#FF2A1F",
            "phase": 0,
            "type": "strobe"
          }
        },
        {
          "name": "LIGHT_NAV_PORT",
          "kind": "LIGHT",
          "position": [
            -53,
            -265.000031,
            -496.749969
          ],
          "quaternion": [
            0,
            0.707107,
            0,
            0.707107
          ],
          "params": {
            "blinkHz": 0,
            "color": "#FF2A1F",
            "phase": 0,
            "type": "nav"
          }
        },
        {
          "name": "LIGHT_NAV_STBD",
          "kind": "LIGHT",
          "position": [
            -3,
            -265.000031,
            -496.749969
          ],
          "quaternion": [
            0,
            -0.707107,
            0,
            0.707107
          ],
          "params": {
            "blinkHz": 0,
            "color": "#2BFF6A",
            "phase": 0,
            "type": "nav"
          }
        }
      ],
      "collider": {
        "kind": "trimesh",
        "nodes": [
          "COL_STATION"
        ],
        "triangles": 512
      },
      "bounds": {
        "min": [
          -500,
          -445,
          -496.249969
        ],
        "max": [
          500,
          445,
          496.25
        ],
        "center": [
          0,
          0,
          0.000015
        ],
        "radius": 606.624322
      },
      "provenance": {
        "source": "greybox",
        "tool": "Blender 5.2.0 LTS + tools/blender/greybox_economy.py",
        "humanContribution": "none",
        "license": "LicenseRef-Eclipse-Owned",
        "aiGenerated": true
      }
    },
    {
      "id": "station.ice_works",
      "kind": "model",
      "class": "station",
      "budget": "station",
      "path": "/assets/placeholder/station.ice_works.6a31efe4.glb",
      "bytes": 91924,
      "sha256": "6a31efe4909f4c5de28961e998f6ef13cbfe5f18f57059ed00baeb7eb435de45",
      "ledgerLine": "placeholders_m4",
      "placeholder": true,
      "materialSlots": [
        "hull",
        "emissive"
      ],
      "lod": {
        "source": "authored",
        "distances": [
          0,
          3198,
          9688
        ],
        "hysteresis": 0.1,
        "tris": [
          1132,
          492,
          172
        ]
      },
      "sockets": [
        {
          "name": "DOCK_BAY_0",
          "kind": "DOCK",
          "position": [
            -121.906647,
            -347.000031,
            -389.749969
          ],
          "quaternion": [
            0,
            0,
            0,
            1
          ],
          "params": {
            "bayD": 80,
            "bayH": 26,
            "bayW": 44,
            "size": "M"
          }
        },
        {
          "name": "LIGHT_BAY_BL",
          "kind": "LIGHT",
          "position": [
            -142.906647,
            -359.000031,
            -428.749969
          ],
          "quaternion": [
            -0.001656,
            -0.969635,
            -0.006567,
            0.244462
          ],
          "params": {
            "blinkHz": 0,
            "color": "#FFD27A",
            "phase": 0,
            "type": "work"
          }
        },
        {
          "name": "LIGHT_BAY_BR",
          "kind": "LIGHT",
          "position": [
            -100.906647,
            -359.000031,
            -428.749969
          ],
          "quaternion": [
            -0.001656,
            0.969635,
            0.006567,
            0.244462
          ],
          "params": {
            "blinkHz": 0,
            "color": "#FFD27A",
            "phase": 0,
            "type": "work"
          }
        },
        {
          "name": "LIGHT_BAY_TL",
          "kind": "LIGHT",
          "position": [
            -142.906647,
            -335.000031,
            -428.749969
          ],
          "quaternion": [
            -0.061306,
            -0.938673,
            -0.243165,
            0.236656
          ],
          "params": {
            "blinkHz": 0,
            "color": "#FFD27A",
            "phase": 0,
            "type": "work"
          }
        },
        {
          "name": "LIGHT_BAY_TR",
          "kind": "LIGHT",
          "position": [
            -100.906647,
            -335.000031,
            -428.749969
          ],
          "quaternion": [
            -0.061306,
            0.938673,
            0.243165,
            0.236656
          ],
          "params": {
            "blinkHz": 0,
            "color": "#FFD27A",
            "phase": 0,
            "type": "work"
          }
        },
        {
          "name": "LIGHT_BEACON",
          "kind": "LIGHT",
          "position": [
            -65.906647,
            518.400024,
            140.249954
          ],
          "quaternion": [
            0,
            0.707107,
            -0.707107,
            0
          ],
          "params": {
            "blinkHz": 0.5,
            "color": "#FF2A1F",
            "phase": 0,
            "type": "strobe"
          }
        },
        {
          "name": "LIGHT_NAV_PORT",
          "kind": "LIGHT",
          "position": [
            -146.906647,
            -347.000031,
            -430.749969
          ],
          "quaternion": [
            0,
            0.707107,
            0,
            0.707107
          ],
          "params": {
            "blinkHz": 0,
            "color": "#FF2A1F",
            "phase": 0,
            "type": "nav"
          }
        },
        {
          "name": "LIGHT_NAV_STBD",
          "kind": "LIGHT",
          "position": [
            -96.906647,
            -347.000031,
            -430.749969
          ],
          "quaternion": [
            0,
            -0.707107,
            0,
            0.707107
          ],
          "params": {
            "blinkHz": 0,
            "color": "#2BFF6A",
            "phase": 0,
            "type": "nav"
          }
        }
      ],
      "collider": {
        "kind": "trimesh",
        "nodes": [
          "COL_STATION"
        ],
        "triangles": 340
      },
      "bounds": {
        "min": [
          -394.190918,
          -517,
          -430.249969
        ],
        "max": [
          394.190918,
          517,
          430.250031
        ],
        "center": [
          0,
          0,
          0.000031
        ],
        "radius": 726.534038
      },
      "provenance": {
        "source": "greybox",
        "tool": "Blender 5.2.0 LTS + tools/blender/greybox_economy.py",
        "humanContribution": "none",
        "license": "LicenseRef-Eclipse-Owned",
        "aiGenerated": true
      }
    },
    {
      "id": "station.refinery",
      "kind": "model",
      "class": "station",
      "budget": "station",
      "path": "/assets/placeholder/station.refinery.df0a295f.glb",
      "bytes": 108596,
      "sha256": "df0a295f6b6b9d9d0c89540581da7198b3d31e44e8c1fea90f9a6a165453be6d",
      "ledgerLine": "placeholders",
      "placeholder": true,
      "materialSlots": [
        "hull",
        "emissive"
      ],
      "lod": {
        "source": "authored",
        "distances": [
          0,
          3567,
          11888
        ],
        "hysteresis": 0.1,
        "tris": [
          1330,
          600,
          192
        ]
      },
      "sockets": [
        {
          "name": "DOCK_BAY_0",
          "kind": "DOCK",
          "position": [
            -125,
            -437.900024,
            -554.999939
          ],
          "quaternion": [
            0,
            0,
            0,
            1
          ],
          "params": {
            "bayD": 80,
            "bayH": 26,
            "bayW": 44,
            "size": "M"
          }
        },
        {
          "name": "LIGHT_BAY_BL",
          "kind": "LIGHT",
          "position": [
            -146,
            -449.900024,
            -593.999939
          ],
          "quaternion": [
            -0.001656,
            -0.969635,
            -0.006567,
            0.244462
          ],
          "params": {
            "blinkHz": 0,
            "color": "#FFD27A",
            "phase": 0,
            "type": "work"
          }
        },
        {
          "name": "LIGHT_BAY_BR",
          "kind": "LIGHT",
          "position": [
            -104,
            -449.900024,
            -593.999939
          ],
          "quaternion": [
            -0.001656,
            0.969635,
            0.006567,
            0.244462
          ],
          "params": {
            "blinkHz": 0,
            "color": "#FFD27A",
            "phase": 0,
            "type": "work"
          }
        },
        {
          "name": "LIGHT_BAY_TL",
          "kind": "LIGHT",
          "position": [
            -146,
            -425.900024,
            -593.999939
          ],
          "quaternion": [
            -0.061306,
            -0.938673,
            -0.243165,
            0.236656
          ],
          "params": {
            "blinkHz": 0,
            "color": "#FFD27A",
            "phase": 0,
            "type": "work"
          }
        },
        {
          "name": "LIGHT_BAY_TR",
          "kind": "LIGHT",
          "position": [
            -104,
            -425.900024,
            -593.999939
          ],
          "quaternion": [
            -0.061306,
            0.938673,
            0.243165,
            0.236656
          ],
          "params": {
            "blinkHz": 0,
            "color": "#FFD27A",
            "phase": 0,
            "type": "work"
          }
        },
        {
          "name": "LIGHT_BEACON",
          "kind": "LIGHT",
          "position": [
            -69,
            589.400024,
            44.999954
          ],
          "quaternion": [
            0,
            0.707107,
            -0.707107,
            0
          ],
          "params": {
            "blinkHz": 0.5,
            "color": "#FF2A1F",
            "phase": 0,
            "type": "strobe"
          }
        },
        {
          "name": "LIGHT_NAV_PORT",
          "kind": "LIGHT",
          "position": [
            -150,
            -437.900024,
            -595.999939
          ],
          "quaternion": [
            0,
            0.707107,
            0,
            0.707107
          ],
          "params": {
            "blinkHz": 0,
            "color": "#FF2A1F",
            "phase": 0,
            "type": "nav"
          }
        },
        {
          "name": "LIGHT_NAV_STBD",
          "kind": "LIGHT",
          "position": [
            -100,
            -437.900024,
            -595.999939
          ],
          "quaternion": [
            0,
            -0.707107,
            0,
            0.707107
          ],
          "params": {
            "blinkHz": 0,
            "color": "#2BFF6A",
            "phase": 0,
            "type": "nav"
          }
        }
      ],
      "collider": {
        "kind": "trimesh",
        "nodes": [
          "COL_STATION"
        ],
        "triangles": 580
      },
      "bounds": {
        "min": [
          -518.683105,
          -588,
          -605.881042
        ],
        "max": [
          519,
          588,
          605
        ],
        "center": [
          0.158447,
          0,
          -0.440521
        ],
        "radius": 891.119231
      },
      "provenance": {
        "source": "greybox",
        "tool": "Blender 5.2.0 LTS + tools/blender/m2_placeholders.py",
        "humanContribution": "none",
        "license": "LicenseRef-Eclipse-Owned",
        "aiGenerated": true
      }
    },
    {
      "id": "station.scrapyard",
      "kind": "model",
      "class": "station",
      "budget": "station",
      "path": "/assets/placeholder/station.scrapyard.2a9b14db.glb",
      "bytes": 100232,
      "sha256": "2a9b14dbbdee2d4e0c3f7a281be28ebfa2215f90c69194995133cacb708fc8e3",
      "ledgerLine": "placeholders",
      "placeholder": true,
      "materialSlots": [
        "hull",
        "emissive"
      ],
      "lod": {
        "source": "authored",
        "distances": [
          0,
          2963,
          7995
        ],
        "hysteresis": 0.1,
        "tris": [
          1136,
          580,
          156
        ]
      },
      "sockets": [
        {
          "name": "DOCK_BAY_0",
          "kind": "DOCK",
          "position": [
            9,
            -438.900024,
            -259.999969
          ],
          "quaternion": [
            0,
            0,
            0,
            1
          ],
          "params": {
            "bayD": 80,
            "bayH": 26,
            "bayW": 44,
            "size": "M"
          }
        },
        {
          "name": "LIGHT_BAY_BL",
          "kind": "LIGHT",
          "position": [
            -12,
            -450.900024,
            -298.999969
          ],
          "quaternion": [
            -0.001656,
            -0.969635,
            -0.006567,
            0.244462
          ],
          "params": {
            "blinkHz": 0,
            "color": "#FFD27A",
            "phase": 0,
            "type": "work"
          }
        },
        {
          "name": "LIGHT_BAY_BR",
          "kind": "LIGHT",
          "position": [
            30,
            -450.900024,
            -298.999969
          ],
          "quaternion": [
            -0.001656,
            0.969635,
            0.006567,
            0.244462
          ],
          "params": {
            "blinkHz": 0,
            "color": "#FFD27A",
            "phase": 0,
            "type": "work"
          }
        },
        {
          "name": "LIGHT_BAY_TL",
          "kind": "LIGHT",
          "position": [
            -12,
            -426.900024,
            -298.999969
          ],
          "quaternion": [
            -0.061306,
            -0.938673,
            -0.243165,
            0.236656
          ],
          "params": {
            "blinkHz": 0,
            "color": "#FFD27A",
            "phase": 0,
            "type": "work"
          }
        },
        {
          "name": "LIGHT_BAY_TR",
          "kind": "LIGHT",
          "position": [
            30,
            -426.900024,
            -298.999969
          ],
          "quaternion": [
            -0.061306,
            0.938673,
            0.243165,
            0.236656
          ],
          "params": {
            "blinkHz": 0,
            "color": "#FFD27A",
            "phase": 0,
            "type": "work"
          }
        },
        {
          "name": "LIGHT_BEACON",
          "kind": "LIGHT",
          "position": [
            -2.722789,
            520.475037,
            229.999954
          ],
          "quaternion": [
            0,
            0.707107,
            -0.707107,
            0
          ],
          "params": {
            "blinkHz": 0.5,
            "color": "#FF2A1F",
            "phase": 0,
            "type": "strobe"
          }
        },
        {
          "name": "LIGHT_NAV_PORT",
          "kind": "LIGHT",
          "position": [
            -16,
            -438.900024,
            -300.999969
          ],
          "quaternion": [
            0,
            0.707107,
            0,
            0.707107
          ],
          "params": {
            "blinkHz": 0,
            "color": "#FF2A1F",
            "phase": 0,
            "type": "nav"
          }
        },
        {
          "name": "LIGHT_NAV_STBD",
          "kind": "LIGHT",
          "position": [
            34,
            -438.900024,
            -300.999969
          ],
          "quaternion": [
            0,
            -0.707107,
            0,
            0.707107
          ],
          "params": {
            "blinkHz": 0,
            "color": "#2BFF6A",
            "phase": 0,
            "type": "nav"
          }
        }
      ],
      "collider": {
        "kind": "trimesh",
        "nodes": [
          "COL_STATION"
        ],
        "triangles": 556
      },
      "bounds": {
        "min": [
          -475,
          -519,
          -300.999969
        ],
        "max": [
          474.086243,
          519.075012,
          300.000031
        ],
        "center": [
          -0.456879,
          0.037506,
          -0.499969
        ],
        "radius": 598.882393
      },
      "provenance": {
        "source": "greybox",
        "tool": "Blender 5.2.0 LTS + tools/blender/m2_placeholders.py",
        "humanContribution": "none",
        "license": "LicenseRef-Eclipse-Owned",
        "aiGenerated": true
      }
    },
    {
      "id": "station.terminal",
      "kind": "model",
      "class": "station",
      "budget": "station",
      "path": "/assets/placeholder/station.terminal.fad8a33d.glb",
      "bytes": 117272,
      "sha256": "fad8a33d759ed05c9dfdcdaa2c8c60c30b70097d49144dcc05cdc99598f20dba",
      "ledgerLine": "placeholders_m4",
      "placeholder": true,
      "materialSlots": [
        "hull",
        "emissive"
      ],
      "lod": {
        "source": "authored",
        "distances": [
          0,
          5629,
          18763
        ],
        "hysteresis": 0.1,
        "tris": [
          1502,
          680,
          268
        ]
      },
      "sockets": [
        {
          "name": "DOCK_BAY_0",
          "kind": "DOCK",
          "position": [
            -129,
            -522.000061,
            -1159.75
          ],
          "quaternion": [
            0,
            0,
            0,
            1
          ],
          "params": {
            "bayD": 80,
            "bayH": 26,
            "bayW": 44,
            "size": "M"
          }
        },
        {
          "name": "LIGHT_BAY_BL",
          "kind": "LIGHT",
          "position": [
            -150,
            -534.000061,
            -1198.75
          ],
          "quaternion": [
            -0.001656,
            -0.969635,
            -0.006567,
            0.244462
          ],
          "params": {
            "blinkHz": 0,
            "color": "#FFD27A",
            "phase": 0,
            "type": "work"
          }
        },
        {
          "name": "LIGHT_BAY_BR",
          "kind": "LIGHT",
          "position": [
            -108,
            -534.000061,
            -1198.75
          ],
          "quaternion": [
            -0.001656,
            0.969635,
            0.006567,
            0.244462
          ],
          "params": {
            "blinkHz": 0,
            "color": "#FFD27A",
            "phase": 0,
            "type": "work"
          }
        },
        {
          "name": "LIGHT_BAY_TL",
          "kind": "LIGHT",
          "position": [
            -150,
            -510.000092,
            -1198.75
          ],
          "quaternion": [
            -0.061306,
            -0.938673,
            -0.243165,
            0.236656
          ],
          "params": {
            "blinkHz": 0,
            "color": "#FFD27A",
            "phase": 0,
            "type": "work"
          }
        },
        {
          "name": "LIGHT_BAY_TR",
          "kind": "LIGHT",
          "position": [
            -108,
            -510.000092,
            -1198.75
          ],
          "quaternion": [
            -0.061306,
            0.938673,
            0.243165,
            0.236656
          ],
          "params": {
            "blinkHz": 0,
            "color": "#FFD27A",
            "phase": 0,
            "type": "work"
          }
        },
        {
          "name": "LIGHT_BEACON",
          "kind": "LIGHT",
          "position": [
            -45,
            843.399963,
            -659.750061
          ],
          "quaternion": [
            0,
            0.707107,
            -0.707107,
            0
          ],
          "params": {
            "blinkHz": 0.5,
            "color": "#FF2A1F",
            "phase": 0,
            "type": "strobe"
          }
        },
        {
          "name": "LIGHT_NAV_PORT",
          "kind": "LIGHT",
          "position": [
            -154,
            -522.000061,
            -1200.75
          ],
          "quaternion": [
            0,
            0.707107,
            0,
            0.707107
          ],
          "params": {
            "blinkHz": 0,
            "color": "#FF2A1F",
            "phase": 0,
            "type": "nav"
          }
        },
        {
          "name": "LIGHT_NAV_STBD",
          "kind": "LIGHT",
          "position": [
            -104,
            -522.000061,
            -1200.75
          ],
          "quaternion": [
            0,
            -0.707107,
            0,
            0.707107
          ],
          "params": {
            "blinkHz": 0,
            "color": "#2BFF6A",
            "phase": 0,
            "type": "nav"
          }
        }
      ],
      "collider": {
        "kind": "trimesh",
        "nodes": [
          "COL_STATION"
        ],
        "triangles": 676
      },
      "bounds": {
        "min": [
          -605,
          -842.000061,
          -1200.25
        ],
        "max": [
          605,
          841.999939,
          1200.25
        ],
        "center": [
          0,
          -0.000061,
          0
        ],
        "radius": 1407.172364
      },
      "provenance": {
        "source": "greybox",
        "tool": "Blender 5.2.0 LTS + tools/blender/greybox_economy.py",
        "humanContribution": "none",
        "license": "LicenseRef-Eclipse-Owned",
        "aiGenerated": true
      }
    },
    {
      "id": "station.yards",
      "kind": "model",
      "class": "station",
      "budget": "station",
      "path": "/assets/placeholder/station.yards.6d027610.glb",
      "bytes": 82088,
      "sha256": "6d0276105846d422c7f1f50d99741e4ebc0180091e4f473cd9616941fcf27893",
      "ledgerLine": "placeholders_m4",
      "placeholder": true,
      "materialSlots": [
        "hull",
        "emissive"
      ],
      "lod": {
        "source": "authored",
        "distances": [
          0,
          4281,
          14267
        ],
        "hysteresis": 0.1,
        "tris": [
          962,
          468,
          96
        ]
      },
      "sockets": [
        {
          "name": "DOCK_BAY_0",
          "kind": "DOCK",
          "position": [
            -84,
            -145.556152,
            -974.235596
          ],
          "quaternion": [
            0,
            0,
            0,
            1
          ],
          "params": {
            "bayD": 80,
            "bayH": 26,
            "bayW": 44,
            "size": "M"
          }
        },
        {
          "name": "LIGHT_BAY_BL",
          "kind": "LIGHT",
          "position": [
            -105,
            -157.556152,
            -1013.235596
          ],
          "quaternion": [
            -0.001656,
            -0.969635,
            -0.006567,
            0.244462
          ],
          "params": {
            "blinkHz": 0,
            "color": "#FFD27A",
            "phase": 0,
            "type": "work"
          }
        },
        {
          "name": "LIGHT_BAY_BR",
          "kind": "LIGHT",
          "position": [
            -63,
            -157.556152,
            -1013.235596
          ],
          "quaternion": [
            -0.001656,
            0.969635,
            0.006567,
            0.244462
          ],
          "params": {
            "blinkHz": 0,
            "color": "#FFD27A",
            "phase": 0,
            "type": "work"
          }
        },
        {
          "name": "LIGHT_BAY_TL",
          "kind": "LIGHT",
          "position": [
            -105,
            -133.556152,
            -1013.235596
          ],
          "quaternion": [
            -0.061306,
            -0.938673,
            -0.243165,
            0.236656
          ],
          "params": {
            "blinkHz": 0,
            "color": "#FFD27A",
            "phase": 0,
            "type": "work"
          }
        },
        {
          "name": "LIGHT_BAY_TR",
          "kind": "LIGHT",
          "position": [
            -63,
            -133.556152,
            -1013.235596
          ],
          "quaternion": [
            -0.061306,
            0.938673,
            0.243165,
            0.236656
          ],
          "params": {
            "blinkHz": 0,
            "color": "#FFD27A",
            "phase": 0,
            "type": "work"
          }
        },
        {
          "name": "LIGHT_BEACON",
          "kind": "LIGHT",
          "position": [
            150,
            319.843872,
            -694.235596
          ],
          "quaternion": [
            0,
            0.707107,
            -0.707107,
            0
          ],
          "params": {
            "blinkHz": 0.5,
            "color": "#FF2A1F",
            "phase": 0,
            "type": "strobe"
          }
        },
        {
          "name": "LIGHT_NAV_PORT",
          "kind": "LIGHT",
          "position": [
            -109,
            -145.556152,
            -1015.235596
          ],
          "quaternion": [
            0,
            0.707107,
            0,
            0.707107
          ],
          "params": {
            "blinkHz": 0,
            "color": "#FF2A1F",
            "phase": 0,
            "type": "nav"
          }
        },
        {
          "name": "LIGHT_NAV_STBD",
          "kind": "LIGHT",
          "position": [
            -59,
            -145.556152,
            -1015.235596
          ],
          "quaternion": [
            0,
            -0.707107,
            0,
            0.707107
          ],
          "params": {
            "blinkHz": 0,
            "color": "#2BFF6A",
            "phase": 0,
            "type": "nav"
          }
        }
      ],
      "collider": {
        "kind": "trimesh",
        "nodes": [
          "COL_STATION"
        ],
        "triangles": 444
      },
      "bounds": {
        "min": [
          -342.310913,
          -415.556152,
          -1014.735596
        ],
        "max": [
          342.310913,
          415.556,
          1014.735535
        ],
        "center": [
          0,
          -0.000076,
          -0.000031
        ],
        "radius": 1070.012707
      },
      "provenance": {
        "source": "greybox",
        "tool": "Blender 5.2.0 LTS + tools/blender/greybox_economy.py",
        "humanContribution": "none",
        "license": "LicenseRef-Eclipse-Owned",
        "aiGenerated": true
      }
    },
    {
      "id": "ship.holdfast_delver_block",
      "kind": "model",
      "class": "ship",
      "budget": "ship_medium",
      "path": "/assets/placeholder/ship.holdfast_delver_block.4ffb9cf3.glb",
      "bytes": 132068,
      "sha256": "4ffb9cf3156a5f55293564bfd4bfbf628243d7c6808e41368036622ca16eaddd",
      "ledgerLine": "streamed.ships",
      "placeholder": true,
      "materialSlots": [
        "hull",
        "glass",
        "emissive"
      ],
      "lod": {
        "source": "authored",
        "distances": [
          0,
          90,
          350,
          1200
        ],
        "hysteresis": 0.1,
        "tris": [
          1280,
          736,
          352,
          220
        ]
      },
      "sockets": [
        {
          "name": "ENG_MAIN_L",
          "kind": "ENG",
          "position": [
            -3.0,
            0.0,
            25.0
          ],
          "quaternion": [
            0.0,
            -1.0,
            0.0,
            0.0
          ],
          "params": {
            "radius": 2.2
          }
        },
        {
          "name": "ENG_MAIN_R",
          "kind": "ENG",
          "position": [
            3.0,
            0.0,
            25.0
          ],
          "quaternion": [
            0.0,
            -1.0,
            0.0,
            0.0
          ],
          "params": {
            "radius": 2.2
          }
        },
        {
          "name": "ENG_RETRO_L",
          "kind": "ENG",
          "position": [
            -4.0,
            -2.000001,
            -19.0
          ],
          "quaternion": [
            0.0,
            0.0,
            0.0,
            1.0
          ],
          "params": {
            "radius": 0.6
          }
        },
        {
          "name": "ENG_RETRO_R",
          "kind": "ENG",
          "position": [
            4.0,
            -2.000001,
            -19.0
          ],
          "quaternion": [
            0.0,
            0.0,
            0.0,
            1.0
          ],
          "params": {
            "radius": 0.6
          }
        },
        {
          "name": "EYE_PILOT",
          "kind": "EYE",
          "position": [
            0.0,
            5.999999,
            -13.0
          ],
          "quaternion": [
            0.0,
            0.0,
            0.0,
            1.0
          ],
          "params": {}
        },
        {
          "name": "HP_MINING_L",
          "kind": "HP",
          "position": [
            -2.0,
            -2.000002,
            -25.0
          ],
          "quaternion": [
            0.0,
            0.0,
            0.0,
            1.0
          ],
          "params": {
            "size": "S"
          }
        },
        {
          "name": "HP_MINING_R",
          "kind": "HP",
          "position": [
            2.0,
            -2.000002,
            -25.0
          ],
          "quaternion": [
            0.0,
            0.0,
            0.0,
            1.0
          ],
          "params": {
            "size": "S"
          }
        },
        {
          "name": "LIGHT_NAV_PORT",
          "kind": "LIGHT",
          "position": [
            -15.0,
            0.0,
            0.0
          ],
          "quaternion": [
            0.0,
            0.707107,
            0.0,
            0.707107
          ],
          "params": {
            "blinkHz": 0,
            "color": "#FF2A1F",
            "phase": 0,
            "type": "nav"
          }
        },
        {
          "name": "LIGHT_NAV_STBD",
          "kind": "LIGHT",
          "position": [
            15.0,
            0.0,
            0.0
          ],
          "quaternion": [
            0.0,
            -0.707107,
            0.0,
            0.707107
          ],
          "params": {
            "blinkHz": 0,
            "color": "#2BFF6A",
            "phase": 0,
            "type": "nav"
          }
        },
        {
          "name": "LIGHT_STROBE",
          "kind": "LIGHT",
          "position": [
            0.0,
            7.0,
            -9.000001
          ],
          "quaternion": [
            0.0,
            0.707107,
            -0.707107,
            0.0
          ],
          "params": {
            "blinkHz": 1,
            "color": "#FFFFFF",
            "phase": 0,
            "type": "strobe"
          }
        },
        {
          "name": "LIGHT_WORK_L",
          "kind": "LIGHT",
          "position": [
            -4.0,
            2.999999,
            -19.5
          ],
          "quaternion": [
            -0.145213,
            0.0,
            0.0,
            0.9894
          ],
          "params": {
            "blinkHz": 0,
            "color": "#FFF1D6",
            "phase": 0,
            "type": "work"
          }
        },
        {
          "name": "LIGHT_WORK_R",
          "kind": "LIGHT",
          "position": [
            4.0,
            2.999999,
            -19.5
          ],
          "quaternion": [
            -0.145213,
            0.0,
            0.0,
            0.9894
          ],
          "params": {
            "blinkHz": 0,
            "color": "#FFF1D6",
            "phase": 0,
            "type": "work"
          }
        }
      ],
      "collider": {
        "kind": "convexHulls",
        "nodes": [
          "COL_BRIDGE",
          "COL_DRILL",
          "COL_DRUMS_L",
          "COL_DRUMS_R",
          "COL_ENGINE",
          "COL_SPINE"
        ],
        "hullVerts": [
          8,
          8,
          8,
          8,
          8,
          8
        ]
      },
      "bounds": {
        "min": [
          -15.0,
          -4.499999,
          -25.0
        ],
        "max": [
          15.0,
          7.0,
          25.0
        ],
        "center": [
          0.0,
          1.25,
          0.0
        ],
        "radius": 25.587154
      },
      "provenance": {
        "source": "greybox",
        "tool": "Blender 5.2.0 LTS + tools/blender/greybox_m10_sm.py",
        "humanContribution": "none",
        "license": "LicenseRef-Eclipse-Owned",
        "aiGenerated": true
      }
    },
    {
      "id": "ship.tethys_kt3p_block",
      "kind": "model",
      "class": "ship",
      "budget": "ship_light",
      "path": "/assets/placeholder/ship.tethys_kt3p_block.a54d5d76.glb",
      "bytes": 83440,
      "sha256": "a54d5d76551e71d2ceaf89927827c22698b5a387b8755db6f8f880ed7f0eeee3",
      "ledgerLine": "streamed.ships",
      "placeholder": true,
      "materialSlots": [
        "hull",
        "glass",
        "emissive"
      ],
      "lod": {
        "source": "authored",
        "distances": [
          0,
          50,
          200,
          700
        ],
        "hysteresis": 0.1,
        "tris": [
          688,
          240,
          228,
          120
        ]
      },
      "sockets": [
        {
          "name": "ENG_MAIN_L",
          "kind": "ENG",
          "position": [
            -1.2,
            0.2,
            6.6
          ],
          "quaternion": [
            0.0,
            -1.0,
            0.0,
            0.0
          ],
          "params": {
            "radius": 0.8
          }
        },
        {
          "name": "ENG_MAIN_R",
          "kind": "ENG",
          "position": [
            1.2,
            0.2,
            6.6
          ],
          "quaternion": [
            0.0,
            -1.0,
            0.0,
            0.0
          ],
          "params": {
            "radius": 0.8
          }
        },
        {
          "name": "ENG_RCS_AL",
          "kind": "ENG",
          "position": [
            -5.6,
            0.0,
            3.0
          ],
          "quaternion": [
            0.0,
            0.707107,
            0.0,
            0.707107
          ],
          "params": {
            "radius": 0.2
          }
        },
        {
          "name": "ENG_RCS_AR",
          "kind": "ENG",
          "position": [
            5.6,
            0.0,
            3.0
          ],
          "quaternion": [
            0.0,
            -0.707107,
            0.0,
            0.707107
          ],
          "params": {
            "radius": 0.2
          }
        },
        {
          "name": "ENG_RCS_FL",
          "kind": "ENG",
          "position": [
            -5.6,
            0.0,
            -5.0
          ],
          "quaternion": [
            0.0,
            0.707107,
            0.0,
            0.707107
          ],
          "params": {
            "radius": 0.2
          }
        },
        {
          "name": "ENG_RCS_FR",
          "kind": "ENG",
          "position": [
            5.6,
            0.0,
            -5.0
          ],
          "quaternion": [
            0.0,
            -0.707107,
            0.0,
            0.707107
          ],
          "params": {
            "radius": 0.2
          }
        },
        {
          "name": "ENG_RETRO_L",
          "kind": "ENG",
          "position": [
            -4.3,
            0.0,
            -6.8
          ],
          "quaternion": [
            0.0,
            0.0,
            0.0,
            1.0
          ],
          "params": {
            "radius": 0.3
          }
        },
        {
          "name": "ENG_RETRO_R",
          "kind": "ENG",
          "position": [
            4.3,
            0.0,
            -6.8
          ],
          "quaternion": [
            0.0,
            0.0,
            0.0,
            1.0
          ],
          "params": {
            "radius": 0.3
          }
        },
        {
          "name": "EYE_PILOT",
          "kind": "EYE",
          "position": [
            0.0,
            2.3,
            -3.0
          ],
          "quaternion": [
            0.0,
            0.0,
            0.0,
            1.0
          ],
          "params": {}
        },
        {
          "name": "HP_LASER_C",
          "kind": "HP",
          "position": [
            0.0,
            -1.0,
            -4.0
          ],
          "quaternion": [
            0.0,
            0.0,
            0.0,
            1.0
          ],
          "params": {
            "size": "S"
          }
        },
        {
          "name": "HP_MINING_C",
          "kind": "HP",
          "position": [
            0.0,
            0.699999,
            -7.27
          ],
          "quaternion": [
            0.0,
            0.0,
            0.0,
            1.0
          ],
          "params": {
            "size": "S"
          }
        },
        {
          "name": "HP_PDC_L",
          "kind": "HP",
          "position": [
            -4.3,
            0.799999,
            -6.8
          ],
          "quaternion": [
            0.0,
            0.0,
            0.0,
            1.0
          ],
          "params": {
            "size": "S"
          }
        },
        {
          "name": "HP_PDC_R",
          "kind": "HP",
          "position": [
            4.3,
            0.799999,
            -6.8
          ],
          "quaternion": [
            0.0,
            0.0,
            0.0,
            1.0
          ],
          "params": {
            "size": "S"
          }
        },
        {
          "name": "LIGHT_NAV_PORT",
          "kind": "LIGHT",
          "position": [
            -5.6,
            0.8,
            0.0
          ],
          "quaternion": [
            0.0,
            0.707107,
            0.0,
            0.707107
          ],
          "params": {
            "blinkHz": 0,
            "color": "#FF2A1F",
            "phase": 0,
            "type": "nav"
          }
        },
        {
          "name": "LIGHT_NAV_STBD",
          "kind": "LIGHT",
          "position": [
            5.6,
            0.8,
            0.0
          ],
          "quaternion": [
            0.0,
            -0.707107,
            0.0,
            0.707107
          ],
          "params": {
            "blinkHz": 0,
            "color": "#2BFF6A",
            "phase": 0,
            "type": "nav"
          }
        },
        {
          "name": "LIGHT_STROBE",
          "kind": "LIGHT",
          "position": [
            0.0,
            2.9,
            0.0
          ],
          "quaternion": [
            0.0,
            0.707107,
            -0.707107,
            0.0
          ],
          "params": {
            "blinkHz": 1,
            "color": "#FFFFFF",
            "phase": 0,
            "type": "strobe"
          }
        },
        {
          "name": "LIGHT_WORK_L",
          "kind": "LIGHT",
          "position": [
            -1.0,
            1.6,
            -7.0
          ],
          "quaternion": [
            -0.145213,
            0.0,
            0.0,
            0.9894
          ],
          "params": {
            "blinkHz": 0,
            "color": "#FFF1D6",
            "phase": 0,
            "type": "work"
          }
        },
        {
          "name": "LIGHT_WORK_R",
          "kind": "LIGHT",
          "position": [
            1.0,
            1.6,
            -7.0
          ],
          "quaternion": [
            -0.145213,
            0.0,
            0.0,
            0.9894
          ],
          "params": {
            "blinkHz": 0,
            "color": "#FFF1D6",
            "phase": 0,
            "type": "work"
          }
        }
      ],
      "collider": {
        "kind": "convexHulls",
        "nodes": [
          "COL_BODY",
          "COL_HOPPER",
          "COL_PRONG_L",
          "COL_PRONG_R"
        ],
        "hullVerts": [
          8,
          8,
          8,
          8
        ]
      },
      "bounds": {
        "min": [
          -5.6,
          -1.700001,
          -7.27
        ],
        "max": [
          5.6,
          2.9,
          6.6
        ],
        "center": [
          0.0,
          0.6,
          -0.335
        ],
        "radius": 8.660325
      },
      "provenance": {
        "source": "greybox",
        "tool": "Blender 5.2.0 LTS + tools/blender/greybox_m10_sm.py",
        "humanContribution": "none",
        "license": "LicenseRef-Eclipse-Owned",
        "aiGenerated": true
      }
    },
    {
      "id": "ship.varro_mastiff_b_block",
      "kind": "model",
      "class": "ship",
      "budget": "ship_medium",
      "path": "/assets/placeholder/ship.varro_mastiff_b_block.35507f68.glb",
      "bytes": 145424,
      "sha256": "35507f681f66ac2120bb8e494f741515c759fbd0f076193b24f36532f22d3feb",
      "ledgerLine": "streamed.ships",
      "placeholder": true,
      "materialSlots": [
        "hull",
        "glass",
        "emissive"
      ],
      "lod": {
        "source": "authored",
        "distances": [
          0,
          90,
          350,
          1200
        ],
        "hysteresis": 0.1,
        "tris": [
          1228,
          572,
          496,
          320
        ]
      },
      "sockets": [
        {
          "name": "ENG_MAIN_L",
          "kind": "ENG",
          "position": [
            -2.6,
            1.200001,
            18.1
          ],
          "quaternion": [
            0.0,
            -1.0,
            0.0,
            0.0
          ],
          "params": {
            "radius": 1.1
          }
        },
        {
          "name": "ENG_MAIN_L2",
          "kind": "ENG",
          "position": [
            -2.6,
            -1.199999,
            18.1
          ],
          "quaternion": [
            0.0,
            -1.0,
            0.0,
            0.0
          ],
          "params": {
            "radius": 1.1
          }
        },
        {
          "name": "ENG_MAIN_R",
          "kind": "ENG",
          "position": [
            2.6,
            1.200001,
            18.1
          ],
          "quaternion": [
            0.0,
            -1.0,
            0.0,
            0.0
          ],
          "params": {
            "radius": 1.1
          }
        },
        {
          "name": "ENG_MAIN_R2",
          "kind": "ENG",
          "position": [
            2.6,
            -1.199999,
            18.1
          ],
          "quaternion": [
            0.0,
            -1.0,
            0.0,
            0.0
          ],
          "params": {
            "radius": 1.1
          }
        },
        {
          "name": "ENG_RETRO_L",
          "kind": "ENG",
          "position": [
            -6.0,
            0.0,
            -2.0
          ],
          "quaternion": [
            0.0,
            0.0,
            0.0,
            1.0
          ],
          "params": {
            "radius": 0.5
          }
        },
        {
          "name": "ENG_RETRO_R",
          "kind": "ENG",
          "position": [
            6.0,
            0.0,
            -2.0
          ],
          "quaternion": [
            0.0,
            0.0,
            0.0,
            1.0
          ],
          "params": {
            "radius": 0.5
          }
        },
        {
          "name": "EYE_PILOT",
          "kind": "EYE",
          "position": [
            0.0,
            4.2,
            -3.0
          ],
          "quaternion": [
            0.0,
            0.0,
            0.0,
            1.0
          ],
          "params": {}
        },
        {
          "name": "HP_LASER_L",
          "kind": "HP",
          "position": [
            -7.55,
            -0.800001,
            -12.0
          ],
          "quaternion": [
            0.0,
            0.0,
            0.0,
            1.0
          ],
          "params": {
            "size": "S"
          }
        },
        {
          "name": "HP_LASER_R",
          "kind": "HP",
          "position": [
            7.55,
            -0.800001,
            -12.0
          ],
          "quaternion": [
            0.0,
            0.0,
            0.0,
            1.0
          ],
          "params": {
            "size": "S"
          }
        },
        {
          "name": "HP_PDC_L",
          "kind": "HP",
          "position": [
            -7.55,
            0.599999,
            -13.0
          ],
          "quaternion": [
            0.0,
            0.0,
            0.0,
            1.0
          ],
          "params": {
            "size": "S"
          }
        },
        {
          "name": "HP_PDC_R",
          "kind": "HP",
          "position": [
            7.55,
            0.599999,
            -13.0
          ],
          "quaternion": [
            0.0,
            0.0,
            0.0,
            1.0
          ],
          "params": {
            "size": "S"
          }
        },
        {
          "name": "HP_TORP_L",
          "kind": "HP",
          "position": [
            -3.5,
            -3.200001,
            -10.0
          ],
          "quaternion": [
            0.0,
            0.0,
            0.0,
            1.0
          ],
          "params": {
            "size": "S"
          }
        },
        {
          "name": "HP_TORP_R",
          "kind": "HP",
          "position": [
            3.5,
            -3.200001,
            -10.0
          ],
          "quaternion": [
            0.0,
            0.0,
            0.0,
            1.0
          ],
          "params": {
            "size": "S"
          }
        },
        {
          "name": "LIGHT_NAV_PORT",
          "kind": "LIGHT",
          "position": [
            -8.6,
            0.0,
            0.0
          ],
          "quaternion": [
            0.0,
            0.707107,
            0.0,
            0.707107
          ],
          "params": {
            "blinkHz": 0,
            "color": "#FF2A1F",
            "phase": 0,
            "type": "nav"
          }
        },
        {
          "name": "LIGHT_NAV_STBD",
          "kind": "LIGHT",
          "position": [
            8.6,
            0.0,
            0.0
          ],
          "quaternion": [
            0.0,
            -0.707107,
            0.0,
            0.707107
          ],
          "params": {
            "blinkHz": 0,
            "color": "#2BFF6A",
            "phase": 0,
            "type": "nav"
          }
        },
        {
          "name": "LIGHT_STROBE",
          "kind": "LIGHT",
          "position": [
            0.0,
            9.2,
            1.999999
          ],
          "quaternion": [
            0.0,
            0.707107,
            -0.707107,
            0.0
          ],
          "params": {
            "blinkHz": 1,
            "color": "#FFFFFF",
            "phase": 0,
            "type": "strobe"
          }
        }
      ],
      "collider": {
        "kind": "convexHulls",
        "nodes": [
          "COL_AFT",
          "COL_BRIDGE",
          "COL_FWD",
          "COL_KEEL",
          "COL_MAIN",
          "COL_MAST",
          "COL_PROW",
          "COL_SPONSON_L",
          "COL_SPONSON_R"
        ],
        "hullVerts": [
          8,
          8,
          8,
          8,
          8,
          8,
          8,
          8,
          8
        ]
      },
      "bounds": {
        "min": [
          -8.6,
          -3.600001,
          -20.0
        ],
        "max": [
          8.6,
          9.2,
          18.099998
        ],
        "center": [
          0.0,
          2.799999,
          -0.950001
        ],
        "radius": 19.933739
      },
      "provenance": {
        "source": "greybox",
        "tool": "Blender 5.2.0 LTS + tools/blender/greybox_m10_sm.py",
        "humanContribution": "none",
        "license": "LicenseRef-Eclipse-Owned",
        "aiGenerated": true
      }
    },
    {
      "id": "structure.megaproject_spire",
      "class": "structure",
      "budget": "structure",
      "path": "/assets/structure/structure.megaproject_spire.22a37aa5.glb",
      "bytes": 223424,
      "sha256": "22a37aa5b6f916a640c82993c100d651dc0cece94758c80d9f5161cc461a46d8",
      "ledgerLine": "structure.megaproject_spire",
      "placeholder": false,
      "provenance": {
        "aiGenerated": true,
        "humanContribution": "none",
        "license": "LicenseRef-Eclipse-Owned",
        "manifestRef": "structure.megaproject_spire",
        "source": "procedural-ts",
        "tool": "Node 24.15.0 + tools/assetkit + assets-src/structure.megaproject_spire/build.ts @ sha256:2567a7e46f76"
      },
      "kind": "model",
      "materialSlots": [
        "hull",
        "emissive"
      ],
      "lod": {
        "distances": [
          0,
          18600,
          74600,
          248500
        ],
        "hysteresis": 0.1,
        "source": "authored",
        "tris": [
          5840,
          2072,
          1104,
          306
        ]
      },
      "sockets": [
        {
          "kind": "LIGHT",
          "name": "LIGHT_BEACON",
          "params": {
            "blinkHz": 0.5,
            "color": "#FF2A1F",
            "phase": 0,
            "type": "strobe"
          },
          "position": [
            0,
            1807.84961,
            0
          ],
          "quaternion": [
            0.707107,
            0,
            0,
            0.707107
          ]
        },
        {
          "kind": "LIGHT",
          "name": "LIGHT_PLINTH_0",
          "params": {
            "blinkHz": 0.75,
            "color": "#FFD27A",
            "phase": 0,
            "type": "nav"
          },
          "position": [
            0,
            40,
            325.635254
          ],
          "quaternion": [
            0,
            1,
            0,
            0
          ]
        },
        {
          "kind": "LIGHT",
          "name": "LIGHT_PLINTH_1",
          "params": {
            "blinkHz": 0.75,
            "color": "#FFD27A",
            "phase": 0.25,
            "type": "nav"
          },
          "position": [
            325.635254,
            40,
            0
          ],
          "quaternion": [
            0,
            -0.707107,
            0,
            0.707107
          ]
        },
        {
          "kind": "LIGHT",
          "name": "LIGHT_PLINTH_2",
          "params": {
            "blinkHz": 0.75,
            "color": "#FFD27A",
            "phase": 0.5,
            "type": "nav"
          },
          "position": [
            0,
            40,
            -325.635254
          ],
          "quaternion": [
            0,
            0,
            0,
            1
          ]
        },
        {
          "kind": "LIGHT",
          "name": "LIGHT_PLINTH_3",
          "params": {
            "blinkHz": 0.75,
            "color": "#FFD27A",
            "phase": 0.75,
            "type": "nav"
          },
          "position": [
            -325.635254,
            40,
            0
          ],
          "quaternion": [
            0,
            0.707107,
            0,
            0.707107
          ]
        }
      ],
      "collider": {
        "kind": "trimesh",
        "nodes": [
          "COL_TRIMESH_00"
        ],
        "triangles": 1104
      },
      "bounds": {
        "center": [
          0.004836,
          903.924805,
          0.004836
        ],
        "max": [
          299.009672,
          1807.849611,
          299.009672
        ],
        "min": [
          -299,
          0,
          -299
        ],
        "radius": 960.117465
      }
    }
  ],
  "textureSets": [
    {
      "id": "tex.decals",
      "class": "texture_set",
      "budget": "decal_atlas",
      "path": "/assets/texture_set/tex.decals.76186ffd.glb",
      "bytes": 114484,
      "sha256": "76186ffd399b125c02eea4d98eb4e8c0a6b39c16250d2578c00f518bc5c94912",
      "ledgerLine": "tex.decals",
      "placeholder": false,
      "provenance": {
        "source": "blender-bake",
        "tool": "Blender 5.2.0 LTS + assets-src/tex.decals/build.py @ sha256:edd2f2d6183f",
        "humanContribution": "none",
        "license": "LicenseRef-Eclipse-Owned",
        "aiGenerated": true,
        "manifestRef": "tex.decals"
      },
      "kind": "textureSet",
      "maps": [
        "baseColor"
      ],
      "size": [
        1024,
        1024
      ]
    },
    {
      "id": "tex.detail.metal",
      "class": "texture_set",
      "budget": "detail_set",
      "path": "/assets/texture_set/tex.detail.metal.ca28f5a6.glb",
      "bytes": 183836,
      "sha256": "ca28f5a64be18efd75c7adfb0518f64498b64dd2a5efe0f8446b7257a5c78513",
      "ledgerLine": "tex.detail",
      "placeholder": false,
      "provenance": {
        "source": "blender-bake",
        "tool": "Blender 5.2.0 LTS + assets-src/tex.detail.metal/build.py @ sha256:3237a1a4f505",
        "humanContribution": "none",
        "license": "LicenseRef-Eclipse-Owned",
        "aiGenerated": true,
        "manifestRef": "tex.detail.metal"
      },
      "kind": "textureSet",
      "maps": [
        "baseColor",
        "normal"
      ],
      "size": [
        512,
        512
      ],
      "texelsPerMeter": 2048
    },
    {
      "id": "tex.lens",
      "class": "texture_set",
      "budget": "post_set",
      "path": "/assets/placeholder/tex.lens.e3189c9c.glb",
      "bytes": 1444,
      "sha256": "e3189c9c9a7cc5a33b98a77cb33d21fcb86be9d97c0e63ccdf54b3c22a75a361",
      "ledgerLine": "placeholders",
      "placeholder": true,
      "provenance": {
        "source": "greybox",
        "tool": "Blender 5.2.0 LTS + tools/blender/greybox_placeholders.py",
        "humanContribution": "none",
        "license": "LicenseRef-Eclipse-Owned",
        "aiGenerated": true
      },
      "kind": "textureSet",
      "maps": [
        "baseColor"
      ],
      "size": [
        4,
        4
      ]
    },
    {
      "id": "tex.rock",
      "class": "texture_set",
      "budget": "material_set",
      "path": "/assets/placeholder/tex.rock.ca9bbf39.glb",
      "bytes": 1916,
      "sha256": "ca9bbf3905804114cb6452d31f3acf7686ae59b369a18661349eab11ddbb3630",
      "ledgerLine": "placeholders",
      "placeholder": true,
      "provenance": {
        "source": "greybox",
        "tool": "Blender 5.2.0 LTS + tools/blender/greybox_placeholders.py",
        "humanContribution": "none",
        "license": "LicenseRef-Eclipse-Owned",
        "aiGenerated": true
      },
      "kind": "textureSet",
      "maps": [
        "baseColor",
        "normal",
        "orm"
      ],
      "size": [
        4,
        4
      ]
    },
    {
      "id": "tex.trim.first_rush",
      "class": "texture_set",
      "budget": "material_set",
      "path": "/assets/texture_set/tex.trim.first_rush.4ea3414c.glb",
      "bytes": 521380,
      "sha256": "4ea3414cb303a3e7459bbde95346612798461b420bcc9c52ca8d66c273e76863",
      "ledgerLine": "tex.trim.first_rush",
      "placeholder": false,
      "provenance": {
        "source": "blender-bake",
        "tool": "Blender 5.2.0 LTS + assets-src/tex.trim.first_rush/build.py @ sha256:21345190bfc1",
        "humanContribution": "none",
        "license": "LicenseRef-Eclipse-Owned",
        "aiGenerated": true,
        "manifestRef": "tex.trim.first_rush"
      },
      "kind": "textureSet",
      "maps": [
        "baseColor",
        "normal",
        "orm",
        "emissive"
      ],
      "size": [
        1024,
        1024
      ],
      "texelsPerMeter": 256
    },
    {
      "id": "tex.trim.reach",
      "class": "texture_set",
      "budget": "material_set",
      "path": "/assets/texture_set/tex.trim.reach.8ecd0cd7.glb",
      "bytes": 440748,
      "sha256": "8ecd0cd7b872f2ef1d3aca69eced3864fde0376de0610e710eee6d80866f56bc",
      "ledgerLine": "tex.trim.reach",
      "placeholder": false,
      "provenance": {
        "source": "blender-bake",
        "tool": "Blender 5.2.0 LTS + assets-src/tex.trim.reach/build.py @ sha256:a9839da4ee40",
        "humanContribution": "none",
        "license": "LicenseRef-Eclipse-Owned",
        "aiGenerated": true,
        "manifestRef": "tex.trim.reach"
      },
      "kind": "textureSet",
      "maps": [
        "baseColor",
        "normal",
        "orm",
        "emissive"
      ],
      "size": [
        1024,
        1024
      ],
      "texelsPerMeter": 256
    },
    {
      "id": "tex.vfx",
      "class": "texture_set",
      "budget": "vfx_atlas",
      "path": "/assets/placeholder/tex.vfx.9986aa67.glb",
      "bytes": 1440,
      "sha256": "9986aa67d97c4ffcf5b2ff7eeb344c3751604c72eedd7d73554358b88d1ddb1a",
      "ledgerLine": "placeholders",
      "placeholder": true,
      "provenance": {
        "source": "greybox",
        "tool": "Blender 5.2.0 LTS + tools/blender/greybox_placeholders.py",
        "humanContribution": "none",
        "license": "LicenseRef-Eclipse-Owned",
        "aiGenerated": true
      },
      "kind": "textureSet",
      "maps": [
        "baseColor"
      ],
      "size": [
        4,
        4
      ]
    }
  ]
}
